import "./path0.40ff540d.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebaba"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebaba"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9KLml", function(module, exports) {
module.exports = import.meta.resolve("e08go");

});


var $49cef64a94faa384$exports = {};
$49cef64a94faa384$exports = import.meta.resolve("khhPT");



// Phase timings (ms)
const $26425851e20efade$var$SPLASH_FADE_IN_MS = 1000; // 1 — splash fades in
const $26425851e20efade$var$WORLD_REVEAL_DELAY_MS = 2000; // 2 — delay after world ready before revealing
const $26425851e20efade$var$WORLD_REVEAL_MS = 1000; // 3 — world fades in behind splash
const $26425851e20efade$var$HOLD_MS = 2000; // 4 — hold before auto-close
const $26425851e20efade$var$CLOSE_FADE_MS = 1000; // 5 — splash fades out
function $26425851e20efade$export$19072be089c6139a(readyPromise) {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const overlay = document.createElement("div");
    overlay.id = "splash-overlay";
    if (reduceMotion) overlay.classList.add("no-motion");
    overlay.innerHTML = `
    <div id="splash-card">
      <img id="splash-icon" src="${0, (/*@__PURE__*/$parcel$interopDefault($49cef64a94faa384$exports))}" alt="Hexaworlds icon" />
      <div id="splash-wordmark">Hexaworlds</div>
      <div id="splash-tagline">Build your world, at your pace.</div>
      <div id="splash-hint">Click anywhere to start</div>
    </div>
  `;
    document.body.appendChild(overlay);
    // splash-active sets up the canvas transition BEFORE any blur is applied
    document.body.classList.add("splash-active");
    // Overlay is immediately opaque (hides the world).
    // Phase 1 — fade the card content in.
    const card = overlay.querySelector("#splash-card");
    if (!reduceMotion) requestAnimationFrame(()=>requestAnimationFrame(()=>card.classList.add("visible")));
    else card.classList.add("visible");
    let closed = false;
    let autoCloseTimer = null;
    let worldRevealTimer = null;
    let holdTimer = null;
    function close() {
        if (closed) return;
        closed = true;
        overlay.removeEventListener("pointerdown", onPointer);
        document.removeEventListener("keydown", onKey);
        clearTimeout(worldRevealTimer);
        clearTimeout(holdTimer);
        clearTimeout(autoCloseTimer);
        if (reduceMotion) {
            document.body.classList.remove("splash-active", "splash-world-visible");
            overlay.remove();
            return;
        }
        // Start blur fade-out simultaneously with overlay fade-out
        document.body.classList.remove("splash-world-visible");
        overlay.classList.add("hiding");
        function onTransitionEnd(e) {
            if (e.propertyName === "opacity") {
                overlay.removeEventListener("transitionend", onTransitionEnd);
                document.body.classList.remove("splash-active");
                overlay.remove();
            }
        }
        overlay.addEventListener("transitionend", onTransitionEnd);
    }
    // Phase 2–4 — triggered when world is ready
    readyPromise.then(()=>{
        worldRevealTimer = setTimeout(()=>{
            if (closed) return;
            // Phase 3 — reveal world behind splash
            overlay.classList.add("world-visible");
            document.body.classList.add("splash-world-visible");
            // Phase 4 — hold, then auto-close
            holdTimer = setTimeout(()=>{
                if (closed) return;
                autoCloseTimer = setTimeout(close, $26425851e20efade$var$HOLD_MS);
            }, reduceMotion ? 0 : $26425851e20efade$var$WORLD_REVEAL_MS);
        }, $26425851e20efade$var$WORLD_REVEAL_DELAY_MS);
    });
    function onPointer(e) {
        e.stopPropagation();
        close();
    }
    function onKey(e) {
        if (e.key === "Escape") close();
    }
    overlay.addEventListener("pointerdown", onPointer);
    document.addEventListener("keydown", onKey);
}



var $8pKpp = parcelRequire("8pKpp");

var $jlsYx = parcelRequire("jlsYx");

var $3WWYP = parcelRequire("3WWYP");

var $3oGCi = parcelRequire("3oGCi");

var $jD2dp = parcelRequire("jD2dp");

var $23xJk = parcelRequire("23xJk");

var $eehpt = parcelRequire("eehpt");

var $foHJT = parcelRequire("foHJT");

var $9KLml = parcelRequire("9KLml");

var $e6iAa = parcelRequire("e6iAa");

var $4G7Km = parcelRequire("4G7Km");
// AmbienceManager — two-slot crossfade engine for biome ambient loops
// Ambience manifest — Parcel url: imports for lazy-loaded biome loops
var $2f7f9b8e9b2e0f30$exports = {};
$2f7f9b8e9b2e0f30$exports = import.meta.resolve("ic5as");


var $f575b44a5cdd117e$exports = {};
$f575b44a5cdd117e$exports = import.meta.resolve("9XJDy");


var $5eeeef19551b4d3f$exports = {};
$5eeeef19551b4d3f$exports = import.meta.resolve("jITZ4");


var $9e148b78c2c6fce5$exports = {};
$9e148b78c2c6fce5$exports = import.meta.resolve("jSawI");


var $2379127d965b1de2$exports = {};
$2379127d965b1de2$exports = import.meta.resolve("bM3vW");


var $898b0615ddb67da8$exports = {};
$898b0615ddb67da8$exports = import.meta.resolve("72QeC");


var $020767e067981407$exports = {};
$020767e067981407$exports = import.meta.resolve("2grmy");


const $7bcda0fecfd98ab1$export$da82904520eb94f8 = [
    'ocean',
    'grass',
    'grassland',
    'mountain',
    'snow',
    'desert',
    'deadplains'
];
const $7bcda0fecfd98ab1$export$978acfbb5b0b7e9b = {
    ocean: (0, (/*@__PURE__*/$parcel$interopDefault($2f7f9b8e9b2e0f30$exports))),
    grass: (0, (/*@__PURE__*/$parcel$interopDefault($f575b44a5cdd117e$exports))),
    grassland: (0, (/*@__PURE__*/$parcel$interopDefault($5eeeef19551b4d3f$exports))),
    mountain: (0, (/*@__PURE__*/$parcel$interopDefault($9e148b78c2c6fce5$exports))),
    snow: (0, (/*@__PURE__*/$parcel$interopDefault($2379127d965b1de2$exports))),
    desert: (0, (/*@__PURE__*/$parcel$interopDefault($898b0615ddb67da8$exports))),
    deadplains: (0, (/*@__PURE__*/$parcel$interopDefault($020767e067981407$exports)))
};


// Tuning constants for the biome-ambience system
/** Weight per ring distance (index 0 = center hex, 1 = ring-1, etc.) */ const $0d898b820cb8967c$export$fe1d36b6e321e594 = [
    3,
    2,
    1
];
const $0d898b820cb8967c$export$a59c909f039950d7 = 200;
const $0d898b820cb8967c$export$57454163fb8aa853 = 1000;
const $0d898b820cb8967c$export$8f32ec364de49846 = 0.20;
const $0d898b820cb8967c$export$7adcfe3226795975 = 0.38;
const $0d898b820cb8967c$export$858ed80c9cfc8da = 2.5;


class $a8d03dc7028b41ab$export$2705803b38c34715 {
    /**
   * @param {AudioManager} audioManager — must expose getAmbienceBus()
   */ constructor(audioManager){
        this._audioManager = audioManager;
        this._slots = [
            null,
            null
        ]; // AmbienceSlot[]
        this._activeSlotIndex = 0;
        this._currentBiome = null;
        this._enabled = true;
        // Throttle / hold state
        this._lastEvalMs = 0;
        this._lastSwitchMs = 0;
        // Audio graph refs (set in unlock)
        this._audioContext = null;
        this._busGain = null;
    }
    /** Create audio elements and connect to the ambience bus. Call after AudioManager.unlock(). */ unlock() {
        const bus = this._audioManager.getAmbienceBus();
        if (!bus) return;
        this._audioContext = bus.audioContext;
        this._busGain = bus.ambienceGain;
        for(let i = 0; i < 2; i++){
            const audioEl = new Audio();
            audioEl.loop = true;
            audioEl.preload = 'none';
            // Needed so MediaElementSource works
            audioEl.crossOrigin = 'anonymous';
            const sourceNode = this._audioContext.createMediaElementSource(audioEl);
            const gainNode = this._audioContext.createGain();
            gainNode.gain.value = 0;
            sourceNode.connect(gainNode);
            gainNode.connect(this._busGain);
            this._slots[i] = {
                audioEl: audioEl,
                sourceNode: sourceNode,
                gainNode: gainNode,
                biome: null
            };
        }
    }
    /** Whether the manager has been unlocked and is ready */ get isReady() {
        return this._slots[0] !== null;
    }
    /** Enable/disable ambience playback */ setEnabled(enabled) {
        this._enabled = enabled;
        if (!enabled) this._fadeOutAll();
        else if (this._currentBiome) {
            // Resume current biome
            const slot = this._slots[this._activeSlotIndex];
            if (slot && slot.biome === this._currentBiome) {
                this._rampGain(slot.gainNode, 1, (0, $0d898b820cb8967c$export$858ed80c9cfc8da));
                slot.audioEl.play().catch(()=>{});
            }
        }
    }
    get enabled() {
        return this._enabled;
    }
    /**
   * Throttled biome evaluation — call on mousemove/wheel/keyPan.
   * @param {{ targetBiome: string|null, confidence: number }} resolved
   */ updateFromResolvedBiome(resolved) {
        if (!this.isReady || !this._enabled) return;
        const now = performance.now();
        if (now - this._lastEvalMs < (0, $0d898b820cb8967c$export$a59c909f039950d7)) return;
        this._lastEvalMs = now;
        this._evaluateSwitch(resolved, now);
    }
    /**
   * Force evaluation — bypasses throttle but respects hold.
   * Call on pan-end / initial unlock.
   * @param {{ targetBiome: string|null, confidence: number }} resolved
   */ forceUpdateFromResolvedBiome(resolved) {
        if (!this.isReady || !this._enabled) return;
        const now = performance.now();
        this._lastEvalMs = now;
        this._evaluateSwitch(resolved, now);
    }
    /** Called when volume settings change */ onSettingsChanged() {
    // The bus gain is controlled by AudioManager._applyVolumes,
    // so nothing extra needed here. This hook exists for future use
    // (e.g. if we add per-ambience gain separate from the bus).
    }
    // ─── Internal ─────────────────────────────────────────
    _evaluateSwitch(resolved, now) {
        const { targetBiome: targetBiome, confidence: confidence } = resolved;
        if (!targetBiome) return;
        // Same biome — no switch needed
        if (targetBiome === this._currentBiome) return;
        // Hold check — don't switch too rapidly after a recent switch
        if (now - this._lastSwitchMs < (0, $0d898b820cb8967c$export$57454163fb8aa853)) return;
        // Confidence must meet minimum threshold
        if (confidence < (0, $0d898b820cb8967c$export$7adcfe3226795975)) return;
        // Hysteresis — new biome must clearly dominate
        // (For the first biome when _currentBiome is null, skip hysteresis)
        if (this._currentBiome !== null) {
            const currentScore = resolved.scores[this._currentBiome] || 0;
            if (confidence - currentScore < (0, $0d898b820cb8967c$export$8f32ec364de49846)) return;
        }
        this._transitionToBiome(targetBiome);
        this._lastSwitchMs = now;
    }
    async _transitionToBiome(biome) {
        const prevIndex = this._activeSlotIndex;
        const nextIndex = 1 - prevIndex;
        const prevSlot = this._slots[prevIndex];
        const nextSlot = this._slots[nextIndex];
        // Fade out previous
        if (prevSlot && prevSlot.biome) {
            this._rampGain(prevSlot.gainNode, 0, (0, $0d898b820cb8967c$export$858ed80c9cfc8da));
            // Stop after fade completes
            const el = prevSlot.audioEl;
            setTimeout(()=>{
                if (this._slots[prevIndex].biome !== biome) el.pause();
            }, (0, $0d898b820cb8967c$export$858ed80c9cfc8da) * 1000 + 100);
        }
        // Load new biome into next slot if needed
        const url = (0, $7bcda0fecfd98ab1$export$978acfbb5b0b7e9b)[biome];
        if (!url) return;
        if (nextSlot.biome !== biome) {
            nextSlot.biome = biome;
            nextSlot.audioEl.src = url;
            // Wait for enough data to play
            await new Promise((resolve)=>{
                const onCanPlay = ()=>{
                    nextSlot.audioEl.removeEventListener('canplay', onCanPlay);
                    resolve();
                };
                nextSlot.audioEl.addEventListener('canplay', onCanPlay);
                nextSlot.audioEl.load();
            });
        }
        // Start playing and fade in
        nextSlot.gainNode.gain.setValueAtTime(0, this._audioContext.currentTime);
        nextSlot.audioEl.play().catch(()=>{});
        this._rampGain(nextSlot.gainNode, 1, (0, $0d898b820cb8967c$export$858ed80c9cfc8da));
        this._activeSlotIndex = nextIndex;
        this._currentBiome = biome;
    }
    _rampGain(gainNode, target, durationSec) {
        const now = this._audioContext.currentTime;
        gainNode.gain.cancelScheduledValues(now);
        gainNode.gain.setValueAtTime(gainNode.gain.value, now);
        gainNode.gain.linearRampToValueAtTime(target, now + durationSec);
    }
    _fadeOutAll() {
        for (const slot of this._slots)if (slot && slot.biome) {
            this._rampGain(slot.gainNode, 0, 0.5);
            const el = slot.audioEl;
            setTimeout(()=>el.pause(), 600);
        }
    }
}


// BiomeResolver — pure function: camera position → dominant biome
// deps: { tiles, hexKey, pixelToHex, hexSize, getMajorityType, hexesWithinRadius }


function $cd18dbf5d161796c$export$7b41c8d5ccdc9a1f(zoom) {
    return zoom < 0.7 ? 3 : 2;
}
function $cd18dbf5d161796c$export$bc96b274c408949e(input, deps) {
    const { cameraX: cameraX, cameraY: cameraY, zoom: zoom } = input;
    const { tiles: tiles, hexKey: hexKey, pixelToHex: pixelToHex, hexSize: hexSize, getMajorityType: getMajorityType, hexesWithinRadius: hexesWithinRadius } = deps;
    const centerHex = pixelToHex(cameraX, cameraY, hexSize);
    const radius = $cd18dbf5d161796c$export$7b41c8d5ccdc9a1f(zoom);
    const hexes = hexesWithinRadius(centerHex, radius);
    // Accumulate weighted scores per biome
    const scores = {};
    let totalWeight = 0;
    for (const hex of hexes){
        const key = hexKey(hex.q, hex.r);
        const tile = tiles[key];
        if (!tile || !tile.placed) continue;
        // Ring distance from center
        const dist = (Math.abs(hex.q - centerHex.q) + Math.abs(hex.q + hex.r - centerHex.q - centerHex.r) + Math.abs(hex.r - centerHex.r)) / 2;
        const weight = (0, $0d898b820cb8967c$export$fe1d36b6e321e594)[Math.min(dist, (0, $0d898b820cb8967c$export$fe1d36b6e321e594).length - 1)] || 1;
        const biome = getMajorityType(tile.sides);
        if (biome) {
            scores[biome] = (scores[biome] || 0) + weight;
            totalWeight += weight;
        }
    }
    if (totalWeight === 0) return {
        targetBiome: null,
        confidence: 0,
        scores: {},
        radius: radius,
        centerHex: centerHex
    };
    // Normalize scores to [0,1] and find winner
    let bestBiome = null;
    let bestScore = 0;
    for (const biome of (0, $7bcda0fecfd98ab1$export$da82904520eb94f8))if (scores[biome]) {
        scores[biome] /= totalWeight;
        if (scores[biome] > bestScore) {
            bestScore = scores[biome];
            bestBiome = biome;
        }
    }
    return {
        targetBiome: bestBiome,
        confidence: bestScore,
        scores: scores,
        radius: radius,
        centerHex: centerHex
    };
}


// Cloud simulation: spawn, update, wrap-around
// Two layers above the world with height-based depth separation.
// Higher height = appears more elevated above ground (shadow offset).
const $18698456007592c5$var$LAYER_CFG = [
    {
        name: 'far',
        height: 100,
        count: 8,
        minScale: 0.9,
        maxScale: 1.4,
        speed: 8,
        alpha: 0.18
    },
    {
        name: 'near',
        height: 60,
        count: 14,
        minScale: 0.7,
        maxScale: 1.1,
        speed: 14,
        alpha: 0.22
    }
];
let $18698456007592c5$var$nextId = 0;
function $18698456007592c5$var$seededRand(seed) {
    let s = seed | 0;
    return ()=>{
        s = s * 1664525 + 1013904223 & 0x7fffffff;
        return s / 0x7fffffff;
    };
}
function $18698456007592c5$var$makeCircles(rng, count) {
    const circles = [];
    const n = count || 6 + Math.floor(rng() * 5); // 6-10
    for(let i = 0; i < n; i++){
        const angle = i / n * Math.PI * 2 + (rng() - 0.5) * 0.4;
        const rx = 40 + rng() * 30; // ellipse x radius
        const ry = 18 + rng() * 12; // ellipse y radius
        circles.push({
            ox: Math.cos(angle) * rx,
            oy: Math.sin(angle) * ry,
            r: 18 + rng() * 22
        });
    }
    // center blob
    circles.push({
        ox: 0,
        oy: 0,
        r: 28 + rng() * 16
    });
    return circles;
}
function $18698456007592c5$var$cloudBounds(circles, scale) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const c of circles){
        const cx = c.ox * scale, cy = c.oy * scale, r = c.r * scale;
        if (cx - r < minX) minX = cx - r;
        if (cy - r < minY) minY = cy - r;
        if (cx + r > maxX) maxX = cx + r;
        if (cy + r > maxY) maxY = cy + r;
    }
    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY,
        w: maxX - minX,
        h: maxY - minY
    };
}
function $18698456007592c5$var$spawnCloud(layerCfg, wrapRect) {
    const id = $18698456007592c5$var$nextId++;
    const rng = $18698456007592c5$var$seededRand(id * 7919 + 31);
    const baseScale = layerCfg.minScale + rng() * (layerCfg.maxScale - layerCfg.minScale);
    const circles = $18698456007592c5$var$makeCircles(rng);
    const bounds = $18698456007592c5$var$cloudBounds(circles, baseScale);
    return {
        id: id,
        // world position
        wx: wrapRect.x + rng() * wrapRect.w,
        wy: wrapRect.y + rng() * wrapRect.h,
        vx: layerCfg.speed * (0.6 + rng() * 0.8),
        vy: layerCfg.speed * (rng() - 0.5) * 0.15,
        baseScale: baseScale,
        alpha: layerCfg.alpha * (0.7 + rng() * 0.3),
        circles: circles,
        bounds: bounds,
        wobblePhase: rng() * Math.PI * 2,
        wobbleSpeed: 0.3 + rng() * 0.4,
        wobbleAmp: 2 + rng() * 3
    };
}
class $18698456007592c5$export$56e19766c69f1963 {
    constructor(){
        this.layers = $18698456007592c5$var$LAYER_CFG.map((cfg)=>({
                cfg: cfg,
                clouds: []
            }));
        this._inited = false;
        /** @type {import('../../world/weather/WeatherState.mjs').WeatherState|null} */ this.weatherState = null;
    }
    /** Call once per frame */ update(dt, camera, canvasW, canvasH) {
        // dt in seconds
        const dtSec = Math.min(dt / 1000, 0.1); // clamp to avoid huge jumps
        // Weather-driven cloud count multiplier: 0.5x (clear) to 2.0x (full cover)
        const ws = this.weatherState;
        const coverMul = ws ? 0.5 + ws.cloudCover01 * 1.5 : 1;
        // Wind speed boost from weather
        const windBoost = ws ? 1 + ws.wind.x * 0.02 : 1;
        for (const layer of this.layers){
            const { cfg: cfg, clouds: clouds } = layer;
            const effectiveCount = Math.round(cfg.count * coverMul);
            // Compute wrap rect: viewport in world coords, expanded by margin
            const margin = 300;
            const halfW = canvasW / 2 / camera.zoom;
            const halfH = canvasH / 2 / camera.zoom;
            const wrapRect = {
                x: camera.x - halfW - margin,
                y: camera.y - halfH - margin,
                w: (halfW + margin) * 2,
                h: (halfH + margin) * 2
            };
            // Initial spawn
            if (!this._inited) for(let i = clouds.length; i < effectiveCount; i++)clouds.push($18698456007592c5$var$spawnCloud(cfg, wrapRect));
            // Move clouds (with wind boost)
            for (const c of clouds){
                c.wx += c.vx * dtSec * windBoost;
                c.wy += c.vy * dtSec;
            }
            // Wrap-around: if cloud leaves the wrap rect on the right, respawn on the left
            for(let i = 0; i < clouds.length; i++){
                const c = clouds[i];
                const hw = c.bounds.w / 2 + 50;
                if (c.wx - hw > wrapRect.x + wrapRect.w) {
                    // Respawn on left edge
                    c.wx = wrapRect.x - hw;
                    c.wy = wrapRect.y + Math.random() * wrapRect.h;
                }
            }
            // Shrink cloud array when effectiveCount drops below current count
            while(clouds.length > effectiveCount)clouds.pop();
            // Maintain count — grow when effectiveCount rises
            while(clouds.length < effectiveCount){
                const nc = $18698456007592c5$var$spawnCloud(cfg, wrapRect);
                nc.wx = wrapRect.x - nc.bounds.w / 2 - 50; // enter from left
                clouds.push(nc);
            }
        }
        this._inited = true;
    }
    /** Get clouds visible on screen for a given layer index */ getVisibleClouds(layerIdx, camera, canvasW, canvasH) {
        const layer = this.layers[layerIdx];
        if (!layer) return [];
        const { cfg: cfg, clouds: clouds } = layer;
        const visible = [];
        for (const c of clouds){
            // Screen position: 1:1 with tiles, elevated by height
            const sx = (c.wx - camera.x) * camera.zoom + canvasW / 2;
            const sy = (c.wy - camera.y) * camera.zoom + canvasH / 2 - cfg.height * camera.zoom;
            const scale = c.baseScale * camera.zoom;
            // AABB culling
            const hw = c.bounds.w / 2 * scale + 50;
            const hh = c.bounds.h / 2 * scale + 50;
            if (sx + hw < 0 || sx - hw > canvasW) continue;
            if (sy + hh < 0 || sy - hh > canvasH) continue;
            visible.push({
                cloud: c,
                sx: sx,
                sy: sy,
                scale: scale
            });
        }
        return visible;
    }
    /**
   * Get clouds with screen positions projected onto the ground plane (no height offset).
   * Used by shadow renderer and precipitation so positions align with tiles.
   */ getGroundProjectedClouds(layerIdx, camera, canvasW, canvasH) {
        const layer = this.layers[layerIdx];
        if (!layer) return [];
        const { cfg: cfg, clouds: clouds } = layer;
        const visible = [];
        for (const c of clouds){
            // Project at ground level (no height offset)
            const sx = (c.wx - camera.x) * camera.zoom + canvasW / 2;
            const sy = (c.wy - camera.y) * camera.zoom + canvasH / 2;
            const scale = c.baseScale * camera.zoom;
            const hw = c.bounds.w / 2 * scale + 80;
            const hh = c.bounds.h / 2 * scale + 80;
            if (sx + hw < 0 || sx - hw > canvasW) continue;
            if (sy + hh < 0 || sy - hh > canvasH) continue;
            visible.push({
                cloud: c,
                sx: sx,
                sy: sy,
                scale: scale,
                height: cfg.height
            });
        }
        return visible;
    }
    get layerCount() {
        return this.layers.length;
    }
    getHeight(layerIdx) {
        return this.layers[layerIdx]?.cfg.height ?? 0;
    }
}


// Draw clouds on the dedicated clouds canvas
// Each circle uses a radial gradient (white center → transparent edge)
// so overlapping circles blend into soft, organic cloud shapes.
class $076d6ff4d6ef455d$export$5bda4955e4213f9c {
    constructor(){
        // Cache gradients keyed by rounded radius to avoid creating new ones each frame
        this._gradientCache = new Map();
        this._cacheCtx = null;
    }
    _getGradient(ctx, cx, cy, r) {
        const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
        grad.addColorStop(0, 'rgba(255,255,255,1)');
        grad.addColorStop(0.4, 'rgba(255,255,255,0.8)');
        grad.addColorStop(0.7, 'rgba(255,255,255,0.3)');
        grad.addColorStop(1, 'rgba(255,255,255,0)');
        return grad;
    }
    /**
   * @param {CanvasRenderingContext2D} ctx - clouds canvas context
   * @param {import('./CloudSystem.mjs').CloudSystem} cloudSystem
   * @param {object} camera - { x, y, zoom }
   * @param {number} canvasW
   * @param {number} canvasH
   * @param {number} nowMs
   * @param {object} [weatherState] - optional WeatherState for alpha modulation
   */ render(ctx, cloudSystem, camera, canvasW, canvasH, nowMs, weatherState) {
        ctx.clearRect(0, 0, canvasW, canvasH);
        const timeSec = nowMs / 1000;
        // Alpha multiplier: 0.8x (clear) to 1.5x (full cover)
        const alphaMul = weatherState ? 0.8 + weatherState.cloudCover01 * 0.7 : 1;
        for(let li = 0; li < cloudSystem.layerCount; li++){
            const visible = cloudSystem.getVisibleClouds(li, camera, canvasW, canvasH);
            for (const { cloud: cloud, sx: sx, sy: sy, scale: scale } of visible){
                // Wobble offset
                const wobbleX = Math.sin(timeSec * cloud.wobbleSpeed + cloud.wobblePhase) * cloud.wobbleAmp * scale;
                const wobbleY = Math.cos(timeSec * cloud.wobbleSpeed * 0.7 + cloud.wobblePhase) * cloud.wobbleAmp * 0.5 * scale;
                ctx.globalAlpha = cloud.alpha * alphaMul;
                for (const circle of cloud.circles){
                    const cx = sx + circle.ox * scale + wobbleX;
                    const cy = sy + circle.oy * scale + wobbleY;
                    const r = circle.r * scale;
                    ctx.fillStyle = this._getGradient(ctx, cx, cy, r);
                    ctx.beginPath();
                    ctx.arc(cx, cy, r, 0, Math.PI * 2);
                    ctx.fill();
                }
            }
        }
        ctx.globalAlpha = 1;
    }
}


// Offscreen shadow buffer + composite into world canvas
// Renders at 25% resolution for performance.
// Uses transparent-based buffer with dark circles, masked to hex areas
// via destination-in before compositing onto the world canvas.
const $569c26efefdfd603$var$SHADOW_SCALE = 0.25;
const $569c26efefdfd603$var$SHADOW_OFFSET_X = 20; // base shadow offset in screen pixels
const $569c26efefdfd603$var$SHADOW_OFFSET_Y = 25;
const $569c26efefdfd603$var$SHADOW_ENLARGE = 1.15; // slightly larger than cloud
const $569c26efefdfd603$var$COMPOSITE_ALPHA = 0.55; // overall shadow darkness when drawn onto tiles
class $569c26efefdfd603$export$379d01a2d692c6fb {
    constructor(){
        this._offscreen = null;
        this._offCtx = null;
        this._w = 0;
        this._h = 0;
    }
    _ensureBuffer(canvasW, canvasH) {
        const w = Math.ceil(canvasW * $569c26efefdfd603$var$SHADOW_SCALE);
        const h = Math.ceil(canvasH * $569c26efefdfd603$var$SHADOW_SCALE);
        if (this._w !== w || this._h !== h) {
            this._offscreen = document.createElement('canvas');
            this._offscreen.width = w;
            this._offscreen.height = h;
            this._offCtx = this._offscreen.getContext('2d');
            this._w = w;
            this._h = h;
        }
    }
    /**
   * Render shadow shapes into offscreen buffer (transparent + dark circles).
   */ render(cloudSystem, camera, canvasW, canvasH, nowMs) {
        this._ensureBuffer(canvasW, canvasH);
        const ctx = this._offCtx;
        const s = $569c26efefdfd603$var$SHADOW_SCALE;
        // Clear to fully transparent
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
        ctx.clearRect(0, 0, this._w, this._h);
        const timeSec = nowMs / 1000;
        for(let li = 0; li < cloudSystem.layerCount; li++){
            const visible = cloudSystem.getGroundProjectedClouds(li, camera, canvasW, canvasH);
            const layerHeight = cloudSystem.getHeight(li);
            const heightFactor = layerHeight / 80;
            const shadowOffX = $569c26efefdfd603$var$SHADOW_OFFSET_X * heightFactor;
            const shadowOffY = $569c26efefdfd603$var$SHADOW_OFFSET_Y * heightFactor;
            // Far clouds cast lighter shadows
            const layerStrength = li === 0 ? 0.4 : 0.7;
            for (const { cloud: cloud, sx: sx, sy: sy, scale: scale } of visible){
                const wobbleX = Math.sin(timeSec * cloud.wobbleSpeed + cloud.wobblePhase) * cloud.wobbleAmp * scale;
                const wobbleY = Math.cos(timeSec * cloud.wobbleSpeed * 0.7 + cloud.wobblePhase) * cloud.wobbleAmp * 0.5 * scale;
                ctx.globalAlpha = layerStrength;
                for (const circle of cloud.circles){
                    const cx = (sx + circle.ox * scale + wobbleX + shadowOffX) * s;
                    const cy = (sy + circle.oy * scale + wobbleY + shadowOffY) * s;
                    const r = circle.r * scale * $569c26efefdfd603$var$SHADOW_ENLARGE * s;
                    const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
                    grad.addColorStop(0, 'rgba(0,0,0,0.7)');
                    grad.addColorStop(0.5, 'rgba(0,0,0,0.35)');
                    grad.addColorStop(1, 'rgba(0,0,0,0)');
                    ctx.fillStyle = grad;
                    ctx.beginPath();
                    ctx.arc(cx, cy, r, 0, Math.PI * 2);
                    ctx.fill();
                }
            }
        }
        ctx.globalAlpha = 1;
    }
    /**
   * Mask the shadow buffer to hex areas, then composite onto the world canvas.
   * @param {CanvasRenderingContext2D} worldCtx
   * @param {number} canvasW
   * @param {number} canvasH
   * @param {Array} hexScreenPositions - array of {x, y} screen centers
   * @param {number} hexSz - screen hex radius
   * @param {function} hexCornersFn - hexCorners(cx, cy, sz) function
   */ composite(worldCtx, canvasW, canvasH, hexScreenPositions, hexSz, hexCornersFn) {
        if (!this._offscreen || !hexScreenPositions || hexScreenPositions.length === 0) return;
        const ctx = this._offCtx;
        const s = $569c26efefdfd603$var$SHADOW_SCALE;
        // Mask shadow buffer to hex areas using destination-in
        ctx.globalCompositeOperation = 'destination-in';
        ctx.globalAlpha = 1;
        ctx.fillStyle = '#ffffff';
        ctx.beginPath();
        for (const pos of hexScreenPositions){
            const corners = hexCornersFn(pos.x * s, pos.y * s, hexSz * s);
            ctx.moveTo(corners[0].x, corners[0].y);
            for(let j = 1; j < corners.length; j++)ctx.lineTo(corners[j].x, corners[j].y);
            ctx.closePath();
        }
        ctx.fill();
        ctx.globalCompositeOperation = 'source-over';
        // Composite masked shadow buffer onto world canvas
        worldCtx.save();
        worldCtx.globalAlpha = $569c26efefdfd603$var$COMPOSITE_ALPHA;
        worldCtx.drawImage(this._offscreen, 0, 0, canvasW, canvasH);
        worldCtx.restore();
    }
}


// Zoom normalization helper
// Tracks min/max zoom and provides a 0..1 normalized value
class $b4ce220eca07e4ed$export$4b255736f634255e {
    constructor(minZoom = 0.3, maxZoom = 3.0){
        this._min = minZoom;
        this._max = maxZoom;
        this._last = 1;
    }
    update(zoom) {
        this._last = zoom;
    }
    /** Returns 0..1 where 0 = most zoomed out, 1 = most zoomed in */ norm() {
        return Math.max(0, Math.min(1, (this._last - this._min) / (this._max - this._min)));
    }
    get zoom() {
        return this._last;
    }
}


/**
 * GradePreset type:
 * {
 *   tint: { r, g, b, a },   // a is strength
 *   brightness: number,       // 0.95..1.05
 *   contrast: number,         // 0.95..1.05
 *   saturation: number,       // 0.90..1.05
 *   vignette: { strength, radius },  // radius 0..1
 * }
 */ const $08b2044974bf9804$export$9265403940be6b4 = {
    dawn: {
        tint: {
            r: 255,
            g: 180,
            b: 120,
            a: 0.08
        },
        brightness: 0.97,
        contrast: 0.97,
        saturation: 0.95,
        vignette: {
            strength: 0.15,
            radius: 0.7
        }
    },
    noon: {
        tint: {
            r: 255,
            g: 250,
            b: 240,
            a: 0.02
        },
        brightness: 1.03,
        contrast: 1.0,
        saturation: 1.02,
        vignette: {
            strength: 0.05,
            radius: 0.85
        }
    },
    sunset: {
        tint: {
            r: 255,
            g: 140,
            b: 80,
            a: 0.10
        },
        brightness: 0.96,
        contrast: 0.98,
        saturation: 0.98,
        vignette: {
            strength: 0.20,
            radius: 0.65
        }
    },
    night: {
        tint: {
            r: 60,
            g: 80,
            b: 160,
            a: 0.12
        },
        brightness: 0.90,
        contrast: 0.96,
        saturation: 0.85,
        vignette: {
            strength: 0.30,
            radius: 0.55
        }
    }
};
function $08b2044974bf9804$export$c64ec3177c9d6d2e(a, b, t) {
    const l = (x, y)=>x + (y - x) * t;
    return {
        tint: {
            r: l(a.tint.r, b.tint.r),
            g: l(a.tint.g, b.tint.g),
            b: l(a.tint.b, b.tint.b),
            a: l(a.tint.a, b.tint.a)
        },
        brightness: l(a.brightness, b.brightness),
        contrast: l(a.contrast, b.contrast),
        saturation: l(a.saturation, b.saturation),
        vignette: {
            strength: l(a.vignette.strength, b.vignette.strength),
            radius: l(a.vignette.radius, b.vignette.radius)
        }
    };
}


const $6cbbc4839031f904$var$LS_KEY = 'hexaworlds_timeofday';
const $6cbbc4839031f904$var$DEFAULTS = {
    enabled: true,
    cycleMinutes: 8,
    strength: 0.6
};
class $6cbbc4839031f904$export$29a0f2b50ac2bb00 {
    constructor(){
        this.startMs = performance.now();
        this.timeScale = 1.0;
        this.cycleMs = $6cbbc4839031f904$var$DEFAULTS.cycleMinutes * 60000;
        this.enabled = $6cbbc4839031f904$var$DEFAULTS.enabled;
        this.strength = $6cbbc4839031f904$var$DEFAULTS.strength;
        this._loadSettings();
    }
    /** Phase 0..1 through the day cycle. */ getPhase01(nowMs) {
        const elapsed = (nowMs - this.startMs) * this.timeScale;
        return elapsed % this.cycleMs / this.cycleMs;
    }
    /** Sun height 0..1 using cosine curve, peaks at noon (phase=0.5). */ getSunHeight01(phase01) {
        // cos curve: phase 0 (midnight) → -1, phase 0.5 (noon) → +1
        // remap to 0..1
        return 0.5 + 0.5 * Math.cos(2 * Math.PI * (phase01 - 0.5));
    }
    /**
   * Return an interpolated GradePreset for the current phase.
   * Zones: midnight→dawn→noon→sunset→midnight
   *  0.00 - 0.20  night
   *  0.20 - 0.35  night→dawn
   *  0.35 - 0.45  dawn→noon
   *  0.45 - 0.55  noon
   *  0.55 - 0.65  noon→sunset
   *  0.65 - 0.80  sunset→night
   *  0.80 - 1.00  night
   */ getPreset(phase01) {
        const p = phase01;
        if (p < 0.20) return (0, $08b2044974bf9804$export$9265403940be6b4).night;
        if (p < 0.35) return (0, $08b2044974bf9804$export$c64ec3177c9d6d2e)((0, $08b2044974bf9804$export$9265403940be6b4).night, (0, $08b2044974bf9804$export$9265403940be6b4).dawn, (p - 0.20) / 0.15);
        if (p < 0.45) return (0, $08b2044974bf9804$export$c64ec3177c9d6d2e)((0, $08b2044974bf9804$export$9265403940be6b4).dawn, (0, $08b2044974bf9804$export$9265403940be6b4).noon, (p - 0.35) / 0.10);
        if (p < 0.55) return (0, $08b2044974bf9804$export$9265403940be6b4).noon;
        if (p < 0.65) return (0, $08b2044974bf9804$export$c64ec3177c9d6d2e)((0, $08b2044974bf9804$export$9265403940be6b4).noon, (0, $08b2044974bf9804$export$9265403940be6b4).sunset, (p - 0.55) / 0.10);
        if (p < 0.80) return (0, $08b2044974bf9804$export$c64ec3177c9d6d2e)((0, $08b2044974bf9804$export$9265403940be6b4).sunset, (0, $08b2044974bf9804$export$9265403940be6b4).night, (p - 0.65) / 0.15);
        return (0, $08b2044974bf9804$export$9265403940be6b4).night;
    }
    // ---- Settings persistence ----
    _loadSettings() {
        try {
            const raw = localStorage.getItem($6cbbc4839031f904$var$LS_KEY);
            if (raw) {
                const s = JSON.parse(raw);
                if (s.enabled !== undefined) this.enabled = s.enabled;
                if (s.cycleMinutes > 0) this.cycleMs = s.cycleMinutes * 60000;
                if (s.strength >= 0 && s.strength <= 1) this.strength = s.strength;
                if (s.startMs > 0) this.startMs = s.startMs;
            }
        } catch (_) {}
    }
    _saveSettings() {
        try {
            localStorage.setItem($6cbbc4839031f904$var$LS_KEY, JSON.stringify({
                enabled: this.enabled,
                cycleMinutes: this.cycleMs / 60000,
                strength: this.strength,
                startMs: this.startMs
            }));
        } catch (_) {}
    }
    setEnabled(v) {
        this.enabled = v;
        this._saveSettings();
    }
    setCycleMinutes(m) {
        this.cycleMs = Math.max(1, m) * 60000;
        this._saveSettings();
    }
    setStrength(s) {
        this.strength = Math.max(0, Math.min(1, s));
        this._saveSettings();
    }
}


/**
 * PostFX renderer — draws tint overlay + vignette on a dedicated canvas.
 * Cheap Canvas2D approach: no getImageData, only fills and gradients.
 */ class $e3cdab81932accf3$export$42854aa698a422ea {
    constructor(){
        this._lastPreset = null;
        this._vignetteGrad = null;
        this._vignetteW = 0;
        this._vignetteH = 0;
        this._vignetteRadius = -1;
        this._vignetteStrength = -1;
    }
    /**
   * @param {CanvasRenderingContext2D} ctx - postfx canvas context
   * @param {number} w - canvas width
   * @param {number} h - canvas height
   * @param {object} preset - GradePreset (interpolated)
   * @param {number} strength - global strength multiplier 0..1
   */ render(ctx, w, h, preset, strength) {
        if (strength <= 0 || !preset) return;
        ctx.clearRect(0, 0, w, h);
        const s = strength;
        // 1) Tint overlay using "soft-light" composite
        const { r: r, g: g, b: b, a: a } = preset.tint;
        const tintAlpha = a * s;
        if (tintAlpha > 0.001) {
            ctx.save();
            ctx.globalCompositeOperation = 'source-over';
            ctx.fillStyle = `rgba(${Math.round(r)},${Math.round(g)},${Math.round(b)},${tintAlpha})`;
            ctx.fillRect(0, 0, w, h);
            ctx.restore();
        }
        // 2) Brightness / contrast / saturation via CSS filter on a subtle overlay
        //    We apply a very subtle brightness shift by drawing a black or white rect
        const bri = preset.brightness;
        if (Math.abs(bri - 1.0) * s > 0.005) {
            ctx.save();
            ctx.globalCompositeOperation = bri < 1.0 ? 'source-over' : 'source-over';
            if (bri < 1.0) {
                // Darken: draw semi-transparent black
                const darkAlpha = (1.0 - bri) * s;
                ctx.fillStyle = `rgba(0,0,0,${Math.min(darkAlpha, 0.3)})`;
            } else {
                // Brighten: draw semi-transparent white
                const lightAlpha = (bri - 1.0) * s;
                ctx.fillStyle = `rgba(255,255,255,${Math.min(lightAlpha, 0.15)})`;
            }
            ctx.fillRect(0, 0, w, h);
            ctx.restore();
        }
        // 3) Vignette: radial gradient from transparent center to dark edges
        const vig = preset.vignette;
        const vigStrength = vig.strength * s;
        if (vigStrength > 0.005) {
            const grad = this._getVignetteGrad(ctx, w, h, vig.radius, vigStrength);
            ctx.save();
            ctx.globalCompositeOperation = 'source-over';
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, w, h);
            ctx.restore();
        }
    }
    /** Cache and reuse the radial gradient when dimensions/params haven't changed. */ _getVignetteGrad(ctx, w, h, radius, strength) {
        if (this._vignetteGrad && this._vignetteW === w && this._vignetteH === h && Math.abs(this._vignetteRadius - radius) < 0.01 && Math.abs(this._vignetteStrength - strength) < 0.01) return this._vignetteGrad;
        const cx = w / 2;
        const cy = h / 2;
        const outerR = Math.sqrt(cx * cx + cy * cy);
        const innerR = outerR * radius;
        const grad = ctx.createRadialGradient(cx, cy, innerR, cx, cy, outerR);
        grad.addColorStop(0, 'rgba(0,0,0,0)');
        grad.addColorStop(1, `rgba(0,0,0,${Math.min(strength, 0.6)})`);
        this._vignetteGrad = grad;
        this._vignetteW = w;
        this._vignetteH = h;
        this._vignetteRadius = radius;
        this._vignetteStrength = strength;
        return grad;
    }
}


// WeatherState — single source of truth for weather driven by biome data.
// Modes: clear | overcast | rain | snow
// Reads biome result → produces cloudCover01, precip01, temperature01, wind.
const $ce570bd6fda2fb53$var$BIOME_CLIMATE = {
    ocean: {
        temp01: 0.55,
        humidity01: 0.85
    },
    grass: {
        temp01: 0.60,
        humidity01: 0.60
    },
    grassland: {
        temp01: 0.65,
        humidity01: 0.55
    },
    mountain: {
        temp01: 0.40,
        humidity01: 0.45
    },
    snow: {
        temp01: 0.15,
        humidity01: 0.35
    },
    desert: {
        temp01: 0.90,
        humidity01: 0.15
    },
    deadplains: {
        temp01: 0.70,
        humidity01: 0.20
    }
};
const $ce570bd6fda2fb53$var$HOLD_MIN_MS = 90000;
const $ce570bd6fda2fb53$var$HOLD_MAX_MS = 180000;
const $ce570bd6fda2fb53$var$MOOD_BUCKET_MS = 120000;
const $ce570bd6fda2fb53$var$TEMP_SNOW_CUTOFF = 0.35;
const $ce570bd6fda2fb53$var$CLOUD_COVER_MIN = 0.05;
const $ce570bd6fda2fb53$var$CLOUD_COVER_MAX = 0.55;
const $ce570bd6fda2fb53$var$PRECIP_MAX = 0.45;
const $ce570bd6fda2fb53$var$WIND_DIR = {
    x: 0.906,
    y: 0.423
}; // normalized (0.75, 0.35)
const $ce570bd6fda2fb53$var$WIND_SPEED = 6;
const $ce570bd6fda2fb53$var$STORAGE_KEY = 'hexaworlds_weather';
function $ce570bd6fda2fb53$var$hash01(seed, bucket) {
    let h = seed * 2654435761 + bucket * 2246822519 | 0;
    h = (h >>> 16 ^ h) * 0x45d9f3b | 0;
    h = (h >>> 16 ^ h) * 0x45d9f3b | 0;
    h = h >>> 16 ^ h;
    return (h & 0x7fffffff) / 0x7fffffff;
}
function $ce570bd6fda2fb53$var$lerpExp(curr, target, timeConstSec, dtSec) {
    const a = 1 - Math.exp(-dtSec / timeConstSec);
    return curr + (target - curr) * a;
}
function $ce570bd6fda2fb53$var$smoothstep(edge0, edge1, x) {
    const t = Math.max(0, Math.min(1, (x - edge0) / (edge1 - edge0)));
    return t * t * (3 - 2 * t);
}
function $ce570bd6fda2fb53$var$clamp01(v) {
    return Math.max(0, Math.min(1, v));
}
class $ce570bd6fda2fb53$export$64fa64c8fb69054a {
    constructor(worldSeed){
        this.worldSeed = worldSeed;
        this.mode = 'clear';
        this.targetMode = 'clear';
        this.cloudCover01 = 0.1;
        this.precip01 = 0;
        this.temperature01 = 0.5;
        this.wind = {
            x: $ce570bd6fda2fb53$var$WIND_DIR.x * $ce570bd6fda2fb53$var$WIND_SPEED,
            y: $ce570bd6fda2fb53$var$WIND_DIR.y * $ce570bd6fda2fb53$var$WIND_SPEED
        };
        this.modeHoldUntilMs = 0;
        this.enabled = true;
        this._debugForce = null; // 'rain' | 'snow' | null
        this._loadSettings();
    }
    /** Force rain or snow for testing. Pass null to return to normal. */ forceMode(mode) {
        this._debugForce = mode;
        if (mode === 'rain' || mode === 'snow') {
            this.enabled = true;
            this.mode = mode;
            this.targetMode = mode;
            this.precip01 = $ce570bd6fda2fb53$var$PRECIP_MAX;
            this.cloudCover01 = $ce570bd6fda2fb53$var$CLOUD_COVER_MAX;
        } else {
            this.mode = 'clear';
            this.targetMode = 'clear';
            this.precip01 = 0;
            this.cloudCover01 = 0.1;
        }
    }
    /** Called every frame. dtMs in milliseconds. */ update(dtMs, nowMs, biomeResult) {
        if (!this.enabled) return;
        if (this._debugForce) return; // skip natural weather when forced
        const dtSec = Math.min(dtMs / 1000, 0.1);
        if (dtSec <= 0) return;
        // Resolve biome climate
        const biome = biomeResult && biomeResult.targetBiome;
        const climate = biome && $ce570bd6fda2fb53$var$BIOME_CLIMATE[biome] || {
            temp01: 0.5,
            humidity01: 0.3
        };
        // World mood noise — slow drift
        const bucket = Math.floor(nowMs / $ce570bd6fda2fb53$var$MOOD_BUCKET_MS);
        const noise01 = $ce570bd6fda2fb53$var$hash01(this.worldSeed, bucket);
        // Cloud cover target
        const cloudRaw = $ce570bd6fda2fb53$var$clamp01(climate.humidity01 * 0.55 + noise01 * 0.25);
        const cloudTarget = $ce570bd6fda2fb53$var$CLOUD_COVER_MIN + cloudRaw * ($ce570bd6fda2fb53$var$CLOUD_COVER_MAX - $ce570bd6fda2fb53$var$CLOUD_COVER_MIN);
        // Precip target — only when cloud cover is high enough
        const precipRaw = $ce570bd6fda2fb53$var$smoothstep(0.45, 0.75, cloudRaw) * climate.humidity01;
        const precipTarget = Math.min(precipRaw, $ce570bd6fda2fb53$var$PRECIP_MAX);
        // Temperature target
        const tempTarget = climate.temp01;
        // Mode selection (only change when hold timer expires)
        let newMode;
        if (precipTarget < 0.08) newMode = cloudTarget > 0.30 ? 'overcast' : 'clear';
        else newMode = tempTarget < $ce570bd6fda2fb53$var$TEMP_SNOW_CUTOFF ? 'snow' : 'rain';
        if (newMode !== this.targetMode && nowMs >= this.modeHoldUntilMs) {
            this.targetMode = newMode;
            this.mode = newMode;
            this.modeHoldUntilMs = nowMs + $ce570bd6fda2fb53$var$HOLD_MIN_MS + Math.random() * ($ce570bd6fda2fb53$var$HOLD_MAX_MS - $ce570bd6fda2fb53$var$HOLD_MIN_MS);
        }
        // Exponential smoothing
        this.cloudCover01 = $ce570bd6fda2fb53$var$lerpExp(this.cloudCover01, cloudTarget, 3.0, dtSec);
        this.precip01 = $ce570bd6fda2fb53$var$lerpExp(this.precip01, precipTarget, 3.0, dtSec);
        this.temperature01 = $ce570bd6fda2fb53$var$lerpExp(this.temperature01, tempTarget, 8.0, dtSec);
        // Wind — slight variation from mood noise
        const windSpeed = $ce570bd6fda2fb53$var$WIND_SPEED * (0.8 + noise01 * 0.4);
        this.wind.x = $ce570bd6fda2fb53$var$WIND_DIR.x * windSpeed;
        this.wind.y = $ce570bd6fda2fb53$var$WIND_DIR.y * windSpeed;
    }
    setEnabled(on) {
        this.enabled = on;
        if (!on) {
            this.cloudCover01 = 0.1;
            this.precip01 = 0;
            this.mode = 'clear';
            this.targetMode = 'clear';
        }
        this._saveSettings();
    }
    _loadSettings() {
        try {
            const raw = localStorage.getItem($ce570bd6fda2fb53$var$STORAGE_KEY);
            if (raw) {
                const s = JSON.parse(raw);
                if (typeof s.enabled === 'boolean') this.enabled = s.enabled;
            }
        } catch (_) {}
    }
    _saveSettings() {
        try {
            localStorage.setItem($ce570bd6fda2fb53$var$STORAGE_KEY, JSON.stringify({
                enabled: this.enabled
            }));
        } catch (_) {}
    }
}


// PrecipRenderer — world-space rain/snow particles driven by WeatherState.
// Preallocated ring buffers, no per-frame allocations.
const $1df9fd9e8e3147d0$var$RAIN_MAX = 600;
const $1df9fd9e8e3147d0$var$SNOW_MAX = 380;
function $1df9fd9e8e3147d0$var$lerp(a, b, t) {
    return a + (b - a) * t;
}
function $1df9fd9e8e3147d0$var$makeParticle() {
    return {
        x: 0,
        y: 0,
        vx: 0,
        vy: 0,
        fallOffset: 0,
        age: 0,
        life: 0,
        size: 0,
        drift: 0,
        alive: false
    };
}
class $1df9fd9e8e3147d0$export$585aa35dc8269fa5 {
    constructor(){
        this.rainBuf = [];
        this.snowBuf = [];
        for(let i = 0; i < $1df9fd9e8e3147d0$var$RAIN_MAX; i++)this.rainBuf.push($1df9fd9e8e3147d0$var$makeParticle());
        for(let i = 0; i < $1df9fd9e8e3147d0$var$SNOW_MAX; i++)this.snowBuf.push($1df9fd9e8e3147d0$var$makeParticle());
        this._rainIdx = 0;
        this._snowIdx = 0;
        this._rainAccum = 0;
        this._snowAccum = 0;
    }
    /**
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} w - canvas width
   * @param {number} h - canvas height
   * @param {number} dtSec - delta time in seconds
   * @param {import('../../world/weather/WeatherState.mjs').WeatherState} ws
   */ render(ctx, w, h, dtSec, ws, cloudSystem, camera) {
        if (!ws || !ws.enabled || ws.precip01 < 0.01) return;
        dtSec = Math.min(dtSec, 0.1);
        const isSnow = ws.mode === 'snow';
        const isRain = ws.mode === 'rain';
        if (!isSnow && !isRain) return;
        const clouds = this._gatherClouds(cloudSystem, camera, w, h);
        if (isRain) this._updateRain(ctx, w, h, dtSec, ws, clouds, camera);
        else this._updateSnow(ctx, w, h, dtSec, ws, clouds, camera);
    }
    _gatherClouds(cloudSystem, camera, w, h) {
        if (!cloudSystem) return [];
        const result = [];
        for(let li = 0; li < cloudSystem.layerCount; li++)for (const item of cloudSystem.getGroundProjectedClouds(li, camera, w, h)){
            const { cloud: cloud, scale: scale } = item;
            const area = cloud.bounds.w * cloud.bounds.h * scale * scale;
            result.push({
                ...item,
                weight: area * cloud.alpha
            });
        }
        return result;
    }
    _sampleCloudPosition(clouds) {
        // 1. Pick cloud by weight
        let total = 0;
        for (const c of clouds)total += c.weight;
        let r = Math.random() * total;
        let picked = clouds[0];
        for (const c of clouds){
            r -= c.weight;
            if (r <= 0) {
                picked = c;
                break;
            }
        }
        // 2. Pick circle within cloud by area (r²)
        const { cloud: cloud } = picked;
        const circles = cloud.circles;
        let cTotal = 0;
        for (const ci of circles)cTotal += ci.r * ci.r;
        r = Math.random() * cTotal;
        let sc = circles[0];
        for (const ci of circles){
            r -= ci.r * ci.r;
            if (r <= 0) {
                sc = ci;
                break;
            }
        }
        // 3. Random point in world space
        const angle = Math.random() * Math.PI * 2;
        const dist = Math.sqrt(Math.random()) * sc.r * cloud.baseScale;
        return {
            wx: cloud.wx + sc.ox * cloud.baseScale + Math.cos(angle) * dist,
            wy: cloud.wy + sc.oy * cloud.baseScale + Math.sin(angle) * dist,
            height: picked.height
        };
    }
    _updateRain(ctx, w, h, dtSec, ws, clouds, camera) {
        const precip = ws.precip01;
        const spawnRate = $1df9fd9e8e3147d0$var$lerp(40, 220, precip);
        this._rainAccum += spawnRate * dtSec;
        // Spawn new particles
        while(this._rainAccum >= 1){
            if (clouds.length === 0) {
                this._rainAccum = 0;
                break;
            }
            this._rainAccum -= 1;
            const p = this.rainBuf[this._rainIdx];
            this._rainIdx = (this._rainIdx + 1) % $1df9fd9e8e3147d0$var$RAIN_MAX;
            const pos = this._sampleCloudPosition(clouds);
            p.x = pos.wx;
            p.y = pos.wy;
            p.fallOffset = -pos.height;
            p.vy = $1df9fd9e8e3147d0$var$lerp(600, 1000, precip);
            p.vx = ws.wind.x * 12;
            p.age = 0;
            p.life = 10;
            p.size = $1df9fd9e8e3147d0$var$lerp(8, 16, Math.random());
            p.alive = true;
        }
        // Update & render
        const alpha = $1df9fd9e8e3147d0$var$lerp(0.08, 0.18, precip);
        ctx.strokeStyle = 'rgba(200,210,230,' + alpha + ')';
        ctx.lineWidth = 1;
        ctx.beginPath();
        for(let i = 0; i < $1df9fd9e8e3147d0$var$RAIN_MAX; i++){
            const p = this.rainBuf[i];
            if (!p.alive) continue;
            p.x += p.vx * dtSec;
            p.fallOffset += p.vy * dtSec;
            p.age += dtSec;
            // World → screen
            const screenX = (p.x - camera.x) * camera.zoom + w / 2;
            const screenY = (p.y - camera.y) * camera.zoom + h / 2 + p.fallOffset * camera.zoom;
            // Kill by screen bounds or age
            if (screenY > h + 30 || screenX < -50 || screenX > w + 50 || p.age > p.life) {
                p.alive = false;
                continue;
            }
            // Draw line segment in wind-angled direction
            const len = p.size;
            const dx = p.vx * 0.01;
            const dy = p.vy * 0.01;
            const mag = Math.sqrt(dx * dx + dy * dy) || 1;
            const nx = dx / mag * len;
            const ny = dy / mag * len;
            ctx.moveTo(screenX, screenY);
            ctx.lineTo(screenX + nx, screenY + ny);
        }
        ctx.stroke();
    }
    _updateSnow(ctx, w, h, dtSec, ws, clouds, camera) {
        const precip = ws.precip01;
        const spawnRate = $1df9fd9e8e3147d0$var$lerp(25, 140, precip);
        this._snowAccum += spawnRate * dtSec;
        while(this._snowAccum >= 1){
            if (clouds.length === 0) {
                this._snowAccum = 0;
                break;
            }
            this._snowAccum -= 1;
            const p = this.snowBuf[this._snowIdx];
            this._snowIdx = (this._snowIdx + 1) % $1df9fd9e8e3147d0$var$SNOW_MAX;
            const pos = this._sampleCloudPosition(clouds);
            p.x = pos.wx;
            p.y = pos.wy;
            p.fallOffset = -pos.height;
            p.vy = $1df9fd9e8e3147d0$var$lerp(30, 80, precip);
            p.vx = ws.wind.x * 3;
            p.age = 0;
            p.life = 30;
            p.size = 1 + Math.random() * 1.5;
            p.drift = Math.random() * Math.PI * 2;
            p.alive = true;
        }
        const alpha = $1df9fd9e8e3147d0$var$lerp(0.06, 0.14, precip);
        ctx.fillStyle = 'rgba(255,255,255,' + alpha + ')';
        for(let i = 0; i < $1df9fd9e8e3147d0$var$SNOW_MAX; i++){
            const p = this.snowBuf[i];
            if (!p.alive) continue;
            p.x += p.vx * dtSec + Math.sin(p.age * 2 + p.drift) * 8 * dtSec;
            p.fallOffset += p.vy * dtSec;
            p.age += dtSec;
            // World → screen
            const screenX = (p.x - camera.x) * camera.zoom + w / 2;
            const screenY = (p.y - camera.y) * camera.zoom + h / 2 + p.fallOffset * camera.zoom;
            // Kill by screen bounds or age
            if (screenY > h + 30 || screenX < -30 || screenX > w + 30 || p.age > p.life) {
                p.alive = false;
                continue;
            }
            ctx.beginPath();
            ctx.arc(screenX, screenY, p.size, 0, Math.PI * 2);
            ctx.fill();
        }
    }
}


const $1785fd5408da3363$export$59b5344f0ddeca73 = 16;


class $6f8b53b9d161c817$export$2b3af6baec22bd98 {
    static sessionStarted = false;
    static debug = false;
    static init(opts) {
        this.debug = !!(opts && opts.debug);
    }
    static startSessionIfNeeded(baseParams) {
        if (this.sessionStarted) return;
        this.sessionStarted = true;
        this.track("session_start", baseParams);
    }
    static track(event, params) {
        try {
            const gtag = window.gtag;
            if (!gtag) {
                if (this.debug) console.log("[analytics] gtag not ready", event, params);
                return;
            }
            if (this.debug) console.log("[analytics]", event, params);
            gtag("event", event, params || {});
        } catch (err) {
            if (this.debug) console.warn("[analytics] error", err);
        // swallow
        }
    }
}


const $5218d4228794afd6$var$STORAGE_KEY = "hexaworld_player_id";
function $5218d4228794afd6$var$fallbackId() {
    return "p_" + Math.random().toString(16).slice(2) + "_" + Date.now().toString(16);
}
function $5218d4228794afd6$export$94f87c28e0ebadf8() {
    let id = localStorage.getItem($5218d4228794afd6$var$STORAGE_KEY);
    if (!id) {
        id = crypto && "randomUUID" in crypto ? crypto.randomUUID() : $5218d4228794afd6$var$fallbackId();
        localStorage.setItem($5218d4228794afd6$var$STORAGE_KEY, id);
    }
    return id;
}
function $5218d4228794afd6$export$65b13681cdfbf8a4(playerId) {
    try {
        const gtag = window.gtag;
        if (!gtag) return;
        gtag("set", {
            user_id: playerId
        });
    } catch  {
    // swallow
    }
}


function $4ce0f3b8ba251f2f$export$8d7692cdcb9b805e(sides) {
    const counts = new Map();
    for (const t of sides)counts.set(t, (counts.get(t) || 0) + 1);
    const entries = Array.from(counts.entries());
    if (entries.length <= 1) return `${entries[0]?.[0] ?? "unknown"}_6`;
    // sort by count desc, then name asc for determinism
    entries.sort((a, b)=>b[1] - a[1] || (a[0] < b[0] ? -1 : 1));
    const [major, majorCount] = entries[0];
    const [minor, minorCount] = entries[1];
    return `${major}_${majorCount}_${minor}_${minorCount}`;
}


/**
 * QuestManager.mjs
 * Central state manager for Pattern Quest v2.
 *
 * Manages 3 always-active quests (light / creative / special),
 * progress tracking, reward application, and persistence.
 */ /**
 * QuestGenerator.mjs
 * Generates Pattern Quest v2 quests using the template library.
 * Applies feasibility checks, anti-repetition, and scoring.
 */ /**
 * QuestTemplates.mjs
 * Template library for Pattern Quest v2.
 *
 * Each template:
 *   id, tier, category, progressKind
 *   bind(worldInfo) → { params, title, description, signature, reward, progress } | null
 */ // ─── helpers ─────────────────────────────────────────────────────────────────
function $ad2fbdb8b779ff29$var$scaleTarget(totalTiles, [min, max]) {
    let fraction = 0;
    if (totalTiles >= 30 && totalTiles < 120) fraction = (totalTiles - 30) / 90;
    else if (totalTiles >= 120) fraction = 1;
    return Math.round(min + (max - min) * fraction);
}
function $ad2fbdb8b779ff29$var$pickRand(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $ad2fbdb8b779ff29$var$pickHandFriendlyTerrain(worldInfo) {
    const { handTerrainTypes: handTerrainTypes, exposedTopTypes: exposedTopTypes, boardTerrainCounts: boardTerrainCounts } = worldInfo;
    const r = Math.random();
    if (r < 0.6 && exposedTopTypes.length > 0) {
        for (const t of exposedTopTypes){
            if (handTerrainTypes.has(t)) return t;
        }
        return exposedTopTypes[0];
    }
    if (r < 0.9) {
        const boardTypes = [
            ...boardTerrainCounts.keys()
        ];
        if (boardTypes.length > 0) return $ad2fbdb8b779ff29$var$pickRand(boardTypes);
    }
    if (handTerrainTypes.size > 0) return $ad2fbdb8b779ff29$var$pickRand([
        ...handTerrainTypes
    ]);
    return 'grass';
}
const $ad2fbdb8b779ff29$var$TERRAIN_NAMES = {
    ocean: 'ocean',
    grass: 'grass',
    grassland: 'grassland',
    mountain: 'mountain',
    snow: 'snow',
    desert: 'desert',
    deadplains: 'dead plains'
};
function $ad2fbdb8b779ff29$var$tname(t) {
    return $ad2fbdb8b779ff29$var$TERRAIN_NAMES[t] || t;
}
function $ad2fbdb8b779ff29$var$starsReward(n) {
    return {
        kind: 'stars',
        amount: n
    };
}
function $ad2fbdb8b779ff29$var$regularOverlayReward() {
    return {
        kind: 'overlay',
        pool: 'regular',
        fallbackStars: 75
    };
}
function $ad2fbdb8b779ff29$var$specialOverlayReward() {
    return {
        kind: 'overlay',
        pool: 'special',
        fallbackStars: 100
    };
}
function $ad2fbdb8b779ff29$var$creativeReward() {
    return Math.random() < 0.4 ? $ad2fbdb8b779ff29$var$regularOverlayReward() : $ad2fbdb8b779ff29$var$starsReward(75);
}
function $ad2fbdb8b779ff29$var$count(target) {
    return {
        kind: 'count',
        current: 0,
        target: target
    };
}
function $ad2fbdb8b779ff29$var$best(target) {
    return {
        kind: 'bestSoFar',
        bestSoFar: 0,
        target: target
    };
}
function $ad2fbdb8b779ff29$var$bool() {
    return {
        kind: 'boolean',
        done: false
    };
}
const $ad2fbdb8b779ff29$export$b3ff070490a1df6a = [
    // ══════════════════════════════════════════════════════════════════
    // LIGHT (reward: +50 ⭐)
    // ══════════════════════════════════════════════════════════════════
    {
        id: 'L1',
        tier: 'light',
        category: 'expand_world',
        bind (wi) {
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                6,
                12
            ]);
            return {
                params: {
                    target: target
                },
                title: 'Soft steps',
                description: `Place ${target} tiles.`,
                signature: `expand_world:any:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L2',
        tier: 'light',
        category: 'place_tiles',
        bind (wi) {
            if (wi.boardTerrainCounts.size === 0) return null;
            const terrain = $ad2fbdb8b779ff29$var$pickHandFriendlyTerrain(wi);
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                6,
                10
            ]);
            return {
                params: {
                    terrain: terrain,
                    target: target
                },
                title: `A touch of ${$ad2fbdb8b779ff29$var$tname(terrain)}`,
                description: `Place ${target} ${$ad2fbdb8b779ff29$var$tname(terrain)} tiles.`,
                signature: `place_tiles:${terrain}:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L3',
        tier: 'light',
        category: 'match_edges',
        bind (wi) {
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                9
            ]);
            return {
                params: {
                    target: target
                },
                title: 'New edges, new paths',
                description: `Create ${target} matching edges.`,
                signature: `match_edges:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L5',
        tier: 'light',
        category: 'place_overlays',
        bind (wi) {
            if (wi.unlockedFamilies.size === 0) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                6
            ]);
            return {
                params: {
                    target: target
                },
                title: 'Place a little life',
                description: `Place ${target} overlays.`,
                signature: `place_overlays:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L7',
        tier: 'light',
        category: 'place_tiles',
        bind (wi) {
            if (wi.boardTerrainCounts.size < 2) return null;
            const kinds = Math.min(wi.boardTerrainCounts.size, 3);
            return {
                params: {
                    kinds: kinds
                },
                title: 'A gentle mix',
                description: `Place tiles from ${kinds} different terrains.`,
                signature: `multi_terrain:${kinds}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: {
                    kind: 'distinct',
                    values: [],
                    target: kinds
                }
            };
        }
    },
    {
        id: 'L8',
        tier: 'light',
        category: 'place_tiles',
        bind (wi) {
            if (!wi.boardTerrainCounts.has('ocean') && !wi.handTerrainTypes.has('ocean')) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                8
            ]);
            return {
                params: {
                    terrain: 'ocean',
                    target: target
                },
                title: 'Calm waters',
                description: `Place ${target} ocean tiles.`,
                signature: `place_tiles:ocean:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L9',
        tier: 'light',
        category: 'place_tiles',
        bind (wi) {
            if (!wi.boardTerrainCounts.has('desert') && !wi.handTerrainTypes.has('desert')) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                8
            ]);
            return {
                params: {
                    terrain: 'desert',
                    target: target
                },
                title: 'Warm sands',
                description: `Place ${target} desert tiles.`,
                signature: `place_tiles:desert:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L10',
        tier: 'light',
        category: 'place_tiles',
        bind (wi) {
            if (!wi.boardTerrainCounts.has('snow') && !wi.handTerrainTypes.has('snow')) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                8
            ]);
            return {
                params: {
                    terrain: 'snow',
                    target: target
                },
                title: 'Snowdust',
                description: `Place ${target} snow tiles.`,
                signature: `place_tiles:snow:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L11',
        tier: 'light',
        category: 'place_tiles',
        bind (wi) {
            if (!wi.boardTerrainCounts.has('mountain') && !wi.handTerrainTypes.has('mountain')) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                8
            ]);
            return {
                params: {
                    terrain: 'mountain',
                    target: target
                },
                title: 'Stone and sky',
                description: `Place ${target} mountain tiles.`,
                signature: `place_tiles:mountain:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L12',
        tier: 'light',
        category: 'place_tiles',
        bind (wi) {
            const hasGrass = wi.boardTerrainCounts.has('grass') || wi.handTerrainTypes.has('grass');
            const hasGL = wi.boardTerrainCounts.has('grassland') || wi.handTerrainTypes.has('grassland');
            if (!hasGrass && !hasGL) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                6,
                10
            ]);
            return {
                params: {
                    terrainSet: [
                        'grass',
                        'grassland'
                    ],
                    target: target
                },
                title: 'Meadow days',
                description: `Place ${target} grass or grassland tiles.`,
                signature: `place_tiles:grass_grassland:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L13',
        tier: 'light',
        category: 'make_cluster',
        bind (wi) {
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                6
            ]);
            return {
                params: {
                    terrain: null,
                    target: target
                },
                title: 'A little cluster',
                description: `Build a cluster of ${target} same-terrain tiles.`,
                signature: `cluster:any:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'L14',
        tier: 'light',
        category: 'expand_world',
        bind (wi) {
            if (wi.totalTiles < 4) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                4
            ]);
            return {
                params: {
                    minNeighbours: 2,
                    target: target
                },
                title: 'Two neighbours',
                description: `Place ${target} tiles that each touch 2+ existing tiles.`,
                signature: `neighbours:2:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'L15',
        tier: 'light',
        category: 'overlay_adjacency',
        bind (wi) {
            if (wi.unlockedFamilies.size === 0) return null;
            if (wi.boardOverlayCount === 0) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                5
            ]);
            return {
                params: {
                    minNeighbourOverlays: 1,
                    target: target
                },
                title: 'Tiny sparkles',
                description: `Place ${target} overlays next to another overlay.`,
                signature: `overlay_adj:1:${target}`,
                reward: $ad2fbdb8b779ff29$var$starsReward(50),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    // ══════════════════════════════════════════════════════════════════
    // CREATIVE (reward: +75 ⭐ or regular overlay)
    // ══════════════════════════════════════════════════════════════════
    {
        id: 'C1',
        tier: 'creative',
        category: 'make_cluster',
        bind (wi) {
            if (wi.boardTerrainCounts.size === 0) return null;
            const terrain = $ad2fbdb8b779ff29$var$pickHandFriendlyTerrain(wi);
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                5,
                8
            ]);
            return {
                params: {
                    terrain: terrain,
                    target: target
                },
                title: `Patch of ${$ad2fbdb8b779ff29$var$tname(terrain)}`,
                description: `Grow a ${$ad2fbdb8b779ff29$var$tname(terrain)} patch to ${target} connected tiles.`,
                signature: `cluster:${terrain}:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'C3',
        tier: 'creative',
        category: 'place_tiles',
        bind (wi) {
            if (wi.totalTiles < 5) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                3,
                6
            ]);
            return {
                params: {
                    minTerrainVariety: 2,
                    target: target
                },
                title: 'Gentle gradient',
                description: `Place ${target} tiles where each touches 2+ different terrains.`,
                signature: `gradient:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'C4',
        tier: 'creative',
        category: 'make_chain',
        bind (wi) {
            if (wi.boardTerrainCounts.size === 0) return null;
            const terrain = $ad2fbdb8b779ff29$var$pickHandFriendlyTerrain(wi);
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                7
            ]);
            return {
                params: {
                    terrain: terrain,
                    target: target
                },
                title: 'A quiet line',
                description: `Make a straight line of ${target} ${$ad2fbdb8b779ff29$var$tname(terrain)} tiles.`,
                signature: `line:${terrain}:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'C5',
        tier: 'creative',
        category: 'make_chain',
        bind (wi) {
            if (wi.totalTiles < 6) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                7
            ]);
            return {
                params: {
                    terrain: null,
                    target: target
                },
                title: 'Winding path',
                description: `Make a straight line of ${target} same-terrain tiles.`,
                signature: `line:any:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'C6',
        tier: 'creative',
        category: 'make_coastline',
        bind (wi) {
            const hasOcean = wi.boardTerrainCounts.has('ocean') || wi.handTerrainTypes.has('ocean');
            if (!hasOcean) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                8
            ]);
            return {
                params: {
                    target: target
                },
                title: 'A small bay',
                description: `Shape a coastline with ${target} ocean-to-land edges.`,
                signature: `coastline:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'C8',
        tier: 'creative',
        category: 'make_ring',
        bind (wi) {
            if (wi.totalTiles < 8) return null;
            return {
                params: {
                    target: 1
                },
                title: 'Surround a quiet heart',
                description: 'Surround one empty hex with tiles.',
                signature: 'ring:1',
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$bool()
            };
        }
    },
    {
        id: 'C9',
        tier: 'creative',
        category: 'make_ring',
        bind (wi) {
            if (wi.totalTiles < 20) return null;
            return {
                params: {
                    target: 2
                },
                title: 'Two quiet hearts',
                description: 'Surround two empty hexes with tiles.',
                signature: 'ring:2',
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$count(2)
            };
        }
    },
    {
        id: 'C10',
        tier: 'creative',
        category: 'overlay_adjacency',
        bind (wi) {
            if (wi.boardOverlayCount < 2) return null;
            if (wi.unlockedFamilies.size === 0) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                1,
                3
            ]);
            return {
                params: {
                    minNeighbourOverlays: 2,
                    target: target
                },
                title: 'Neighbourhood bloom',
                description: `Place an overlay with 2+ neighbouring overlays, ${target} time${target > 1 ? 's' : ''}.`,
                signature: `overlay_adj:2:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'C11',
        tier: 'creative',
        category: 'overlay_cluster',
        bind (wi) {
            if (!wi.unlockedFamilies.has('forest')) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                3,
                6
            ]);
            return {
                params: {
                    family: 'forest',
                    target: target
                },
                title: 'A cozy grove',
                description: `Build a connected cluster of ${target} forest overlays.`,
                signature: `overlay_cluster:forest:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'C12',
        tier: 'creative',
        category: 'overlay_cluster',
        bind (wi) {
            if (!wi.unlockedFamilies.has('mountainrocks')) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                3,
                6
            ]);
            return {
                params: {
                    family: 'mountainrocks',
                    target: target
                },
                title: 'Little rock garden',
                description: `Build a connected cluster of ${target} mountain rock overlays.`,
                signature: `overlay_cluster:mountainrocks:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'C13',
        tier: 'creative',
        category: 'place_overlays',
        bind (wi) {
            const has = wi.unlockedFamilies.has('island_land') || wi.unlockedFamilies.has('island_water');
            if (!has) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                5
            ]);
            return {
                params: {
                    families: [
                        'island_land',
                        'island_water'
                    ],
                    target: target
                },
                title: 'Isles together',
                description: `Place ${target} island overlays.`,
                signature: `place_overlay_family:island:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'C14',
        tier: 'creative',
        category: 'match_edges',
        bind (wi) {
            if (wi.totalTiles < 5) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                5
            ]);
            return {
                params: {
                    minMatches: 3,
                    target: target
                },
                title: 'Pattern of three',
                description: `Place ${target} tiles each creating 3+ matching edges.`,
                signature: `match_edges:3plus:${target}`,
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'C15',
        tier: 'creative',
        category: 'match_edges',
        bind (wi) {
            if (wi.totalTiles < 8) return null;
            return {
                params: {
                    minMatches: 4
                },
                title: 'Gentle six',
                description: 'Place one tile that creates 4+ matching edges.',
                signature: 'match_edges:4:1',
                reward: $ad2fbdb8b779ff29$var$creativeReward(),
                progress: $ad2fbdb8b779ff29$var$bool()
            };
        }
    },
    // ══════════════════════════════════════════════════════════════════
    // SPECIAL (reward: special overlay, fallback +100 ⭐)
    // ══════════════════════════════════════════════════════════════════
    {
        id: 'S1',
        tier: 'special',
        category: 'place_overlays',
        bind (wi) {
            if (wi.totalTiles < 15) return null;
            if (wi.unlockedFamilies.size === 0) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                5
            ]);
            return {
                params: {
                    bonusTerrain: true,
                    target: target
                },
                title: 'A place for company',
                description: `Place ${target} overlays on their favourite terrain.`,
                signature: `bonus_terrain:${target}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'S2',
        tier: 'special',
        category: 'overlay_adjacency',
        bind (wi) {
            if (wi.boardOverlayCount < 4) return null;
            if (wi.unlockedFamilies.size === 0) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            return {
                params: {
                    minNeighbourOverlays: 4
                },
                title: 'Lively neighbourhood',
                description: 'Place an overlay that touches 4 other overlays.',
                signature: 'overlay_adj:4:1',
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$bool()
            };
        }
    },
    {
        id: 'S3',
        tier: 'special',
        category: 'overlay_cluster',
        bind (wi) {
            if (!wi.unlockedFamilies.has('forest')) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                6,
                10
            ]);
            return {
                params: {
                    family: 'forest',
                    target: target
                },
                title: 'Grand grove',
                description: `Grow a forest overlay cluster to ${target}.`,
                signature: `overlay_cluster:forest:${target}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'S4',
        tier: 'special',
        category: 'make_cluster',
        bind (wi) {
            if (!wi.boardTerrainCounts.has('mountain') && !wi.handTerrainTypes.has('mountain')) return null;
            if (wi.totalTiles < 20) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                8,
                12
            ]);
            return {
                params: {
                    terrain: 'mountain',
                    target: target
                },
                title: 'Mountain crown',
                description: `Make a mountain cluster of ${target} connected tiles.`,
                signature: `cluster:mountain:${target}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'S5',
        tier: 'special',
        category: 'make_cluster',
        bind (wi) {
            if (!wi.boardTerrainCounts.has('snow') && !wi.handTerrainTypes.has('snow')) return null;
            if (wi.totalTiles < 20) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                8,
                12
            ]);
            return {
                params: {
                    terrain: 'snow',
                    target: target
                },
                title: 'Snowcap plateau',
                description: `Make a snow cluster of ${target} connected tiles.`,
                signature: `cluster:snow:${target}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'S6',
        tier: 'special',
        category: 'make_cluster',
        bind (wi) {
            if (!wi.boardTerrainCounts.has('desert') && !wi.handTerrainTypes.has('desert')) return null;
            if (wi.totalTiles < 20) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                8,
                12
            ]);
            return {
                params: {
                    terrain: 'desert',
                    target: target
                },
                title: 'Desert bloom',
                description: `Make a desert cluster of ${target} connected tiles.`,
                signature: `cluster:desert:${target}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$best(target)
            };
        }
    },
    {
        id: 'S8',
        tier: 'special',
        category: 'make_ring',
        bind (wi) {
            if (wi.totalTiles < 25) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                4
            ]);
            return {
                params: {
                    target: target
                },
                title: 'Hidden circles',
                description: `Surround ${target} empty hexes with tiles.`,
                signature: `ring:${target}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    },
    {
        id: 'S9',
        tier: 'special',
        category: 'make_cluster',
        bind (wi) {
            if (wi.boardTerrainCounts.size < 3) return null;
            if (wi.totalTiles < 20) return null;
            if (wi.score.stars < 50 && wi.totalTiles < 25) return null;
            const clusterSize = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                4,
                6
            ]);
            const kinds = 3;
            return {
                params: {
                    kinds: kinds,
                    clusterSize: clusterSize
                },
                title: 'Three biomes, one world',
                description: `Build ${kinds} terrain clusters of ${clusterSize}+ tiles each.`,
                signature: `biome_trio:${kinds}:${clusterSize}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: {
                    kind: 'biome_trio',
                    achievedTerrains: [],
                    clusterSize: clusterSize,
                    target: kinds
                }
            };
        }
    },
    // S10 — meta fallback (always feasible for special tier)
    {
        id: 'S10',
        tier: 'special',
        category: 'meta',
        bind (wi) {
            const target = $ad2fbdb8b779ff29$var$scaleTarget(wi.totalTiles, [
                2,
                4
            ]);
            return {
                params: {
                    target: target
                },
                title: 'A wonder appears',
                description: `Complete any ${target} quests.`,
                signature: `meta:${target}`,
                reward: $ad2fbdb8b779ff29$var$specialOverlayReward(),
                progress: $ad2fbdb8b779ff29$var$count(target)
            };
        }
    }
];


const $7eca54e68a8f946f$var$TIERS = [
    'light',
    'creative',
    'special'
];
// Anti-repetition cooldowns
const $7eca54e68a8f946f$var$SIGNATURE_COOLDOWN = 8; // don't repeat same signature within last 8
const $7eca54e68a8f946f$var$CATEGORY_COOLDOWN = 3; // don't repeat same category in last 3 per tier
const $7eca54e68a8f946f$var$TERRAIN_COOLDOWN = 4; // don't repeat same primary terrain in last 4
function $7eca54e68a8f946f$export$7c8825621bd1f801(tier, worldInfo, history) {
    const templates = (0, $ad2fbdb8b779ff29$export$b3ff070490a1df6a).filter((t)=>t.tier === tier);
    // Try to bind each template, collect feasible candidates
    const candidates = [];
    for (const tpl of templates){
        let bound;
        try {
            bound = tpl.bind(worldInfo);
        } catch  {
            continue;
        }
        if (!bound) continue;
        const score = $7eca54e68a8f946f$var$scoreCandidatex(bound, tpl.category, tier, worldInfo, history);
        if (score === -Infinity) continue;
        candidates.push({
            templateId: tpl.id,
            tier: tier,
            category: tpl.category,
            ...bound,
            score: score
        });
    }
    if (candidates.length === 0) return $7eca54e68a8f946f$var$_hardFallback(tier, worldInfo);
    // Sort by score descending, pick from top with weighted random
    candidates.sort((a, b)=>b.score - a.score);
    const pool = candidates.slice(0, Math.min(candidates.length, 5));
    const picked = $7eca54e68a8f946f$var$_weightedPick(pool);
    return $7eca54e68a8f946f$var$_buildQuest(tier, picked);
}
// ─── Scoring ─────────────────────────────────────────────────────────────────
function $7eca54e68a8f946f$var$scoreCandidatex(bound, category, tier, worldInfo, history) {
    let score = 0;
    // Anti-repetition: signature cooldown
    const recentSigs = history.slice(-$7eca54e68a8f946f$var$SIGNATURE_COOLDOWN).map((h)=>h.signature);
    if (recentSigs.includes(bound.signature)) return -Infinity;
    // Anti-repetition: category cooldown per tier
    const tierHistory = history.filter((h)=>h.tier === tier).slice(-$7eca54e68a8f946f$var$CATEGORY_COOLDOWN);
    const recentCats = tierHistory.map((h)=>h.category);
    if (recentCats.includes(category)) score -= 20;
    // Anti-repetition: terrain cooldown
    const recentTerrains = history.slice(-$7eca54e68a8f946f$var$TERRAIN_COOLDOWN).map((h)=>h.terrain).filter(Boolean);
    if (bound.params?.terrain && recentTerrains.includes(bound.params.terrain)) score -= 15;
    // Novelty: prefer categories not recently used
    const allRecentCats = history.slice(-5).map((h)=>h.category);
    if (!allRecentCats.includes(category)) score += 10;
    // Variety: add some randomness
    score += Math.random() * 20;
    return score;
}
function $7eca54e68a8f946f$var$_weightedPick(pool) {
    // Exponential weighting: best gets weight 1.0, next 0.6, etc.
    const weights = pool.map((_, i)=>Math.pow(0.6, i));
    const total = weights.reduce((s, w)=>s + w, 0);
    let r = Math.random() * total;
    for(let i = 0; i < pool.length; i++){
        r -= weights[i];
        if (r <= 0) return pool[i];
    }
    return pool[0];
}
// ─── Hard fallbacks ───────────────────────────────────────────────────────────
function $7eca54e68a8f946f$var$_hardFallback(tier, worldInfo) {
    const ts = Date.now();
    if (tier === 'light') return {
        id: `fallback_light_${ts}`,
        templateId: 'L1',
        tier: 'light',
        category: 'expand_world',
        title: 'Soft steps',
        description: 'Place 6 tiles.',
        params: {
            target: 6
        },
        progress: {
            kind: 'count',
            current: 0,
            target: 6
        },
        reward: {
            kind: 'stars',
            amount: 50
        },
        signature: 'expand_world:any:6',
        createdAtMs: ts,
        completedAtMs: null
    };
    if (tier === 'creative') return {
        id: `fallback_creative_${ts}`,
        templateId: 'L3',
        tier: 'creative',
        category: 'match_edges',
        title: 'New edges, new paths',
        description: 'Create 3 matching edges.',
        params: {
            target: 3
        },
        progress: {
            kind: 'count',
            current: 0,
            target: 3
        },
        reward: {
            kind: 'stars',
            amount: 75
        },
        signature: 'match_edges:3',
        createdAtMs: ts,
        completedAtMs: null
    };
    // special fallback: S10 meta
    return {
        id: `fallback_special_${ts}`,
        templateId: 'S10',
        tier: 'special',
        category: 'meta',
        title: 'A wonder appears',
        description: 'Complete any 2 quests.',
        params: {
            target: 2
        },
        progress: {
            kind: 'count',
            current: 0,
            target: 2
        },
        reward: {
            kind: 'overlay',
            pool: 'special',
            fallbackStars: 100
        },
        signature: 'meta:2',
        createdAtMs: ts,
        completedAtMs: null
    };
}
// ─── Build final quest object ─────────────────────────────────────────────────
function $7eca54e68a8f946f$var$_buildQuest(tier, bound) {
    const ts = Date.now();
    return {
        id: `${bound.templateId}_${ts}`,
        templateId: bound.templateId,
        tier: tier,
        category: bound.category,
        title: bound.title,
        description: bound.description,
        params: bound.params || {},
        progress: bound.progress,
        reward: bound.reward,
        signature: bound.signature,
        createdAtMs: ts,
        completedAtMs: null
    };
}


/**
 * QuestProgress.mjs
 * Progress computation for Pattern Quest v2.
 *
 * updateQuestProgress(quest, event, worldFns)
 *   → returns true if quest is now complete
 *
 * event shapes:
 *   tile:    { type:'tile',    coord, matchCount, majorType, isOcean, neighbourCount, neighbourTerrainTypes }
 *   overlay: { type:'overlay', coord, overlayFamily, adjacentOverlays, onBonusTerrain, isOcean }
 */ 
var $3WWYP = parcelRequire("3WWYP");
// ─── BFS helpers ──────────────────────────────────────────────────────────────
function $717583c92e4d0d32$var$clusterBFS(tiles, startCoord, terrain, getMajorityType) {
    const startTile = tiles[(0, $3WWYP.hexKey)(startCoord.q, startCoord.r)];
    if (!startTile || !startTile.placed) return 0;
    if (terrain && getMajorityType(startTile.sides) !== terrain) return 0;
    const actualTerrain = terrain || getMajorityType(startTile.sides);
    const visited = new Set([
        (0, $3WWYP.hexKey)(startCoord.q, startCoord.r)
    ]);
    const queue = [
        startCoord
    ];
    let size = 0;
    while(queue.length > 0){
        const { q: q, r: r } = queue.shift();
        size++;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(q, r, s);
            const k = (0, $3WWYP.hexKey)(nb.q, nb.r);
            if (visited.has(k)) continue;
            visited.add(k);
            const t = tiles[k];
            if (!t || !t.placed) continue;
            if (getMajorityType(t.sides) !== actualTerrain) continue;
            queue.push(nb);
        }
    }
    return size;
}
function $717583c92e4d0d32$var$overlayClusterBFS(tiles, startCoord, family, getOverlayFamily) {
    const startTile = tiles[(0, $3WWYP.hexKey)(startCoord.q, startCoord.r)];
    if (!startTile || !startTile.placed || !startTile.overlaySpriteKey) return 0;
    if (getOverlayFamily(startTile.overlaySpriteKey) !== family) return 0;
    const visited = new Set([
        (0, $3WWYP.hexKey)(startCoord.q, startCoord.r)
    ]);
    const queue = [
        startCoord
    ];
    let size = 0;
    while(queue.length > 0){
        const { q: q, r: r } = queue.shift();
        size++;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(q, r, s);
            const k = (0, $3WWYP.hexKey)(nb.q, nb.r);
            if (visited.has(k)) continue;
            visited.add(k);
            const t = tiles[k];
            if (!t || !t.placed || !t.overlaySpriteKey) continue;
            if (getOverlayFamily(t.overlaySpriteKey) !== family) continue;
            queue.push(nb);
        }
    }
    return size;
}
/** Longest straight line of terrain T (or any terrain) through coord */ function $717583c92e4d0d32$var$straightLineLength(tiles, coord, terrain, getMajorityType) {
    const DIRS = [
        [
            {
                q: 1,
                r: 0
            },
            {
                q: -1,
                r: 0
            }
        ],
        [
            {
                q: 0,
                r: 1
            },
            {
                q: 0,
                r: -1
            }
        ],
        [
            {
                q: -1,
                r: 1
            },
            {
                q: 1,
                r: -1
            }
        ]
    ];
    const tile = tiles[(0, $3WWYP.hexKey)(coord.q, coord.r)];
    if (!tile || !tile.placed) return 0;
    const actualTerrain = terrain || getMajorityType(tile.sides);
    if (getMajorityType(tile.sides) !== actualTerrain) return 0;
    let maxLen = 0;
    for (const [d0, d1] of DIRS){
        let len = 1;
        for (const d of [
            d0,
            d1
        ]){
            let { q: q, r: r } = coord;
            while(true){
                q += d.q;
                r += d.r;
                const t = tiles[(0, $3WWYP.hexKey)(q, r)];
                if (!t || !t.placed || getMajorityType(t.sides) !== actualTerrain) break;
                len++;
            }
        }
        maxLen = Math.max(maxLen, len);
    }
    return maxLen;
}
/** Total ocean-land border edge count across the whole board */ function $717583c92e4d0d32$var$coastlineEdgeCount(tiles, getMajorityType) {
    let count = 0;
    for (const t of Object.values(tiles)){
        if (!t.placed || getMajorityType(t.sides) !== 'ocean') continue;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(t.coord.q, t.coord.r, s);
            const nbT = tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
            if (!nbT || !nbT.placed) continue;
            if (getMajorityType(nbT.sides) !== 'ocean') count++;
        }
    }
    return count;
}
/** Check if any empty hex adjacent to coord has all 6 neighbours placed. Returns count of new rings. */ function $717583c92e4d0d32$var$checkRings(tiles, coord) {
    let rings = 0;
    for(let s = 0; s < 6; s++){
        const candidate = (0, $3WWYP.getNeighbor)(coord.q, coord.r, s);
        const candidateKey = (0, $3WWYP.hexKey)(candidate.q, candidate.r);
        if (tiles[candidateKey]?.placed) continue; // not empty
        let allPlaced = true;
        for(let s2 = 0; s2 < 6; s2++){
            const nb2 = (0, $3WWYP.getNeighbor)(candidate.q, candidate.r, s2);
            if (!tiles[(0, $3WWYP.hexKey)(nb2.q, nb2.r)]?.placed) {
                allPlaced = false;
                break;
            }
        }
        if (allPlaced) rings++;
    }
    return rings;
}
/** For biome_trio: compute how many distinct terrains have a cluster >= clusterSize */ function $717583c92e4d0d32$var$countBiotrioTerrains(tiles, clusterSize, getMajorityType) {
    const visited = new Set();
    const largestByTerrain = new Map();
    for (const t of Object.values(tiles)){
        if (!t.placed) continue;
        const k = (0, $3WWYP.hexKey)(t.coord.q, t.coord.r);
        if (visited.has(k)) continue;
        const terrain = getMajorityType(t.sides);
        // BFS
        const localVisited = new Set([
            k
        ]);
        const queue = [
            t.coord
        ];
        let size = 0;
        while(queue.length > 0){
            const { q: q, r: r } = queue.shift();
            visited.add((0, $3WWYP.hexKey)(q, r));
            size++;
            for(let s = 0; s < 6; s++){
                const nb = (0, $3WWYP.getNeighbor)(q, r, s);
                const nk = (0, $3WWYP.hexKey)(nb.q, nb.r);
                if (localVisited.has(nk)) continue;
                localVisited.add(nk);
                const nt = tiles[nk];
                if (!nt || !nt.placed || getMajorityType(nt.sides) !== terrain) continue;
                queue.push(nb);
            }
        }
        largestByTerrain.set(terrain, Math.max(largestByTerrain.get(terrain) || 0, size));
    }
    let count = 0;
    for (const sz of largestByTerrain.values())if (sz >= clusterSize) count++;
    return count;
}
function $717583c92e4d0d32$export$9569565a7ac14e8e(progress) {
    switch(progress.kind){
        case 'count':
            return progress.current >= progress.target;
        case 'bestSoFar':
            return progress.bestSoFar >= progress.target;
        case 'boolean':
            return progress.done;
        case 'distinct':
            return progress.values.length >= progress.target;
        case 'biome_trio':
            return progress.achievedTerrains.length >= progress.target;
        default:
            return false;
    }
}
function $717583c92e4d0d32$export$ba222f409b09c174(progress) {
    switch(progress.kind){
        case 'count':
            return `${progress.current} / ${progress.target}`;
        case 'bestSoFar':
            return `Best: ${progress.bestSoFar} / ${progress.target}`;
        case 'boolean':
            return progress.done ? 'Complete!' : 'Not yet';
        case 'distinct':
            return `${progress.values.length} / ${progress.target} terrains`;
        case 'biome_trio':
            return `${progress.achievedTerrains.length} / ${progress.target} biomes`;
        default:
            return '';
    }
}
function $717583c92e4d0d32$export$b38e7f3df0b4dd10(quest, event, worldFns) {
    const { tiles: tiles, getMajorityType: getMajorityType, getOverlayFamily: getOverlayFamily } = worldFns;
    const { progress: progress, category: category, params: params } = quest;
    // Already complete — skip
    if ($717583c92e4d0d32$export$9569565a7ac14e8e(progress)) return true;
    if (event.type === 'tile') $717583c92e4d0d32$var$_updateTile(progress, category, params, event, tiles, getMajorityType);
    else if (event.type === 'overlay') $717583c92e4d0d32$var$_updateOverlay(progress, category, params, event, tiles, getMajorityType, getOverlayFamily);
    return $717583c92e4d0d32$export$9569565a7ac14e8e(progress);
}
// ─── Tile placement updates ───────────────────────────────────────────────────
function $717583c92e4d0d32$var$_updateTile(progress, category, params, ev, tiles, getMT) {
    switch(category){
        case 'expand_world':
            if (params.minNeighbours) {
                if (ev.neighbourCount >= params.minNeighbours) progress.current++;
            } else progress.current++;
            break;
        case 'place_tiles':
            if (params.terrain) {
                if (ev.majorType === params.terrain) {
                    if (progress.kind === 'count') progress.current++;
                }
            } else if (params.terrainSet) {
                if (params.terrainSet.includes(ev.majorType)) {
                    if (progress.kind === 'count') progress.current++;
                }
            } else if (params.kinds) // multi_terrain distinct progress
            {
                if (progress.kind === 'distinct' && !progress.values.includes(ev.majorType)) progress.values.push(ev.majorType);
            } else if (params.minTerrainVariety) // gradient: count placements where neighbour variety >= minTerrainVariety
            {
                if (ev.neighbourTerrainTypes && ev.neighbourTerrainTypes.size >= params.minTerrainVariety) progress.current++;
            } else if (progress.kind === 'count') progress.current++;
            break;
        case 'match_edges':
            if (progress.kind === 'count') {
                if (params.minMatches) {
                    if (ev.matchCount >= params.minMatches) progress.current++;
                } else progress.current += ev.matchCount;
            } else if (progress.kind === 'boolean') {
                if (params.minMatches && ev.matchCount >= params.minMatches) progress.done = true;
            }
            break;
        case 'make_cluster':
            if (progress.kind === 'biome_trio') {
                // Recompute how many distinct terrains have a cluster >= clusterSize
                const count = $717583c92e4d0d32$var$countBiotrioTerrains(tiles, progress.clusterSize, getMT);
                // Track achieved terrains as a count (just update the array length)
                progress.achievedTerrains = Array.from({
                    length: count
                }, (_, i)=>i);
            } else if (progress.kind === 'bestSoFar') {
                const terrain = params.terrain || null;
                const size = $717583c92e4d0d32$var$clusterBFS(tiles, ev.coord, terrain, getMT);
                if (size > progress.bestSoFar) progress.bestSoFar = size;
            }
            break;
        case 'make_chain':
            if (progress.kind === 'bestSoFar') {
                const len = $717583c92e4d0d32$var$straightLineLength(tiles, ev.coord, params.terrain || null, getMT);
                if (len > progress.bestSoFar) progress.bestSoFar = len;
            }
            break;
        case 'make_coastline':
            if (progress.kind === 'bestSoFar') {
                const edges = $717583c92e4d0d32$var$coastlineEdgeCount(tiles, getMT);
                if (edges > progress.bestSoFar) progress.bestSoFar = edges;
            }
            break;
        case 'make_ring':
            {
                const rings = $717583c92e4d0d32$var$checkRings(tiles, ev.coord);
                if (rings > 0) {
                    if (progress.kind === 'boolean') progress.done = true;
                    else if (progress.kind === 'count') progress.current = Math.min(progress.current + rings, progress.target);
                }
                break;
            }
        default:
            break;
    }
}
// ─── Overlay placement updates ────────────────────────────────────────────────
function $717583c92e4d0d32$var$_updateOverlay(progress, category, params, ev, tiles, getMT, getOF) {
    switch(category){
        case 'place_overlays':
            if (params.families) {
                if (params.families.includes(ev.overlayFamily)) progress.current++;
            } else if (params.bonusTerrain) {
                if (ev.onBonusTerrain) progress.current++;
            } else progress.current++;
            break;
        case 'overlay_adjacency':
            {
                const adj = ev.adjacentOverlays;
                if (progress.kind === 'count') {
                    if (adj >= params.minNeighbourOverlays) progress.current++;
                } else if (progress.kind === 'boolean') {
                    if (adj >= params.minNeighbourOverlays) progress.done = true;
                }
                break;
            }
        case 'overlay_cluster':
            if (progress.kind === 'bestSoFar') {
                const size = $717583c92e4d0d32$var$overlayClusterBFS(tiles, ev.coord, params.family, getOF);
                if (size > progress.bestSoFar) progress.bestSoFar = size;
            }
            break;
        default:
            break;
    }
}


const $742317e06faccc71$var$SAVE_KEY = 'hexaworlds_quests_v2';
const $742317e06faccc71$var$HISTORY_LIMIT = 50;
const $742317e06faccc71$var$TIERS = [
    'light',
    'creative',
    'special'
];
class $742317e06faccc71$export$2b3f6b475bacf6b7 {
    constructor(){
        /** @type {{ active: {light,creative,special}, history: Array, totalCompletions: number }} */ this.state = {
            active: {
                light: null,
                creative: null,
                special: null
            },
            history: [],
            totalCompletions: 0
        };
        // ── Callbacks (set by caller in index.mjs) ──────────────────────
        /** (n: number) => void  — add n stars to score */ this.onStarsReward = null;
        /** () => string|null  — unlock from regular overlay pool, returns key or null */ this.onRegularOverlayReward = null;
        /** () => string|null  — unlock from special overlay pool, returns key or null */ this.onSpecialOverlayReward = null;
        /** (tier: string, quest: object) => void — fired when quest completes */ this.onQuestComplete = null;
        /** (tier: string, quest: object) => void — fired when progress changes */ this.onProgress = null;
        /** (tier: string, quest: object) => void — fired when a new quest is set */ this.onQuestNew = null;
        /** () => worldInfo — must be set by caller */ this.getWorldInfo = null;
    }
    // ── Public API ──────────────────────────────────────────────────────────────
    /** Call after construction to load save and generate initial quests. */ init() {
        this._load();
        const wi = this._getWI();
        for (const tier of $742317e06faccc71$var$TIERS)if (!this.state.active[tier]) {
            this.state.active[tier] = (0, $7eca54e68a8f946f$export$7c8825621bd1f801)(tier, wi, this.state.history);
            this._notify('onQuestNew', tier);
        }
        this._save();
    }
    /**
   * Call when a tile is placed.
   * @param {{coord:{q,r}, matchCount:number, majorType:string, isOcean:boolean, neighbourCount:number, neighbourTerrainTypes:Set}} ev
   */ onTilePlaced(ev) {
        this._processEvent({
            type: 'tile',
            ...ev
        });
    }
    /**
   * Call when an overlay is placed.
   * @param {{coord:{q,r}, overlayFamily:string, adjacentOverlays:number, onBonusTerrain:boolean, isOcean:boolean}} ev
   */ onOverlayPlaced(ev) {
        this._processEvent({
            type: 'overlay',
            ...ev
        });
    }
    /** Called when ANY quest completes (for meta-quest S10). */ notifyQuestCompletion() {
        const special = this.state.active.special;
        if (special?.category === 'meta' && !(0, $717583c92e4d0d32$export$9569565a7ac14e8e)(special.progress)) {
            special.progress.current++;
            this._notify('onProgress', 'special');
            if ((0, $717583c92e4d0d32$export$9569565a7ac14e8e)(special.progress)) this._completeAndReplace('special');
        }
    }
    // ── Internal ────────────────────────────────────────────────────────────────
    _processEvent(ev) {
        const wi = this._getWI();
        const worldFns = wi._fns;
        for (const tier of $742317e06faccc71$var$TIERS){
            const quest = this.state.active[tier];
            if (!quest || (0, $717583c92e4d0d32$export$9569565a7ac14e8e)(quest.progress)) continue;
            const wasComplete = (0, $717583c92e4d0d32$export$b38e7f3df0b4dd10)(quest, ev, worldFns);
            this._notify('onProgress', tier);
            if (wasComplete) this._completeAndReplace(tier);
        }
        this._save();
    }
    _completeAndReplace(tier) {
        const quest = this.state.active[tier];
        if (!quest) return;
        quest.completedAtMs = Date.now();
        this.state.totalCompletions++;
        // Apply reward
        this._applyReward(quest);
        // Push to history
        this.state.history.push({
            signature: quest.signature,
            tier: quest.tier,
            category: quest.category,
            terrain: quest.params?.terrain || null,
            completedAtMs: quest.completedAtMs
        });
        if (this.state.history.length > $742317e06faccc71$var$HISTORY_LIMIT) this.state.history.shift();
        // Fire complete callback
        this._notify('onQuestComplete', tier, quest);
        // Notify meta-quest if any
        const special = this.state.active.special;
        if (tier !== 'special' && special?.category === 'meta') {
            special.progress.current++;
            this._notify('onProgress', 'special');
            if ((0, $717583c92e4d0d32$export$9569565a7ac14e8e)(special.progress)) {
                // defer to avoid re-entrancy
                setTimeout(()=>this._completeAndReplace('special'), 0);
                return;
            }
        }
        // Generate replacement
        const wi = this._getWI();
        const newQuest = (0, $7eca54e68a8f946f$export$7c8825621bd1f801)(tier, wi, this.state.history);
        this.state.active[tier] = newQuest;
        this._notify('onQuestNew', tier);
        this._save();
    }
    _applyReward(quest) {
        const reward = quest.reward;
        if (reward.kind === 'stars') {
            if (this.onStarsReward) this.onStarsReward(reward.amount);
        } else if (reward.kind === 'overlay') {
            const fn = reward.pool === 'regular' ? this.onRegularOverlayReward : this.onSpecialOverlayReward;
            const picked = fn ? fn() : null;
            if (!picked) // pool empty — fallback stars
            {
                if (this.onStarsReward) this.onStarsReward(reward.fallbackStars);
            }
        }
    }
    _getWI() {
        if (!this.getWorldInfo) throw new Error('QuestManager.getWorldInfo not set');
        return this.getWorldInfo();
    }
    _notify(cbName, tier, quest) {
        const cb = this[cbName];
        if (!cb) return;
        try {
            cb(tier, quest || this.state.active[tier]);
        } catch (e) {
            console.warn('[QuestManager]', e);
        }
    }
    // ── Persistence ─────────────────────────────────────────────────────────────
    _save() {
        try {
            localStorage.setItem($742317e06faccc71$var$SAVE_KEY, JSON.stringify({
                active: this.state.active,
                history: this.state.history,
                totalCompletions: this.state.totalCompletions
            }));
        } catch (_) {}
    }
    _load() {
        try {
            const raw = localStorage.getItem($742317e06faccc71$var$SAVE_KEY);
            if (!raw) return;
            const parsed = JSON.parse(raw);
            if (parsed.active) this.state.active = parsed.active;
            if (parsed.history) this.state.history = parsed.history;
            if (typeof parsed.totalCompletions === 'number') this.state.totalCompletions = parsed.totalCompletions;
        } catch (_) {
        // Corrupt save — start fresh
        }
    }
    /** Call on game reset */ reset() {
        this.state = {
            active: {
                light: null,
                creative: null,
                special: null
            },
            history: [],
            totalCompletions: 0
        };
        try {
            localStorage.removeItem($742317e06faccc71$var$SAVE_KEY);
        } catch (_) {}
        this.init();
    }
}


/**
 * QuestUI.mjs
 * Pattern Quest v2 — 3-slot quest panel UI.
 *
 * Always visible (no show/hide). Shows light / creative / special quest cards.
 */ 
const $d11d076be9c0eda4$var$REWARD_LABELS = {
    stars: (r)=>`+${r.amount} \u{2B50}`,
    overlay: (r)=>r.pool === 'regular' ? "\uD83C\uDF81 Overlay" : "\u2728 Special"
};
const $d11d076be9c0eda4$var$COMPLETION_GLOW_MS = 2500;
class $d11d076be9c0eda4$export$d6e2c749de993985 {
    /**
   * @param {HTMLElement} panelEl - the #quest-panel element
   */ constructor(panelEl){
        this._panel = panelEl;
        this._cards = {}; // tier → { el, titleEl, progressEl, rewardEl }
        this._glowTimers = {};
        this._init();
    }
    _init() {
        for (const tier of [
            'light',
            'creative',
            'special'
        ]){
            const cardEl = this._panel.querySelector(`.quest-card[data-tier="${tier}"]`);
            if (!cardEl) continue;
            this._cards[tier] = {
                el: cardEl,
                titleEl: cardEl.querySelector('.quest-title'),
                progressEl: cardEl.querySelector('.quest-progress'),
                rewardEl: cardEl.querySelector('.quest-reward')
            };
        }
    }
    /**
   * Set / replace the displayed quest for a tier.
   * @param {string} tier
   * @param {object} quest
   */ setQuest(tier, quest) {
        const card = this._cards[tier];
        if (!card || !quest) return;
        card.el.classList.remove('completing');
        if (this._glowTimers[tier]) {
            clearTimeout(this._glowTimers[tier]);
            this._glowTimers[tier] = null;
        }
        card.titleEl.textContent = quest.title;
        card.el.dataset.desc = quest.description;
        card.progressEl.textContent = (0, $717583c92e4d0d32$export$ba222f409b09c174)(quest.progress);
        card.rewardEl.textContent = $d11d076be9c0eda4$var$_rewardLabel(quest.reward);
    }
    /**
   * Refresh the progress text for a tier.
   * @param {string} tier
   * @param {object} quest
   */ updateProgress(tier, quest) {
        const card = this._cards[tier];
        if (!card || !quest) return;
        card.progressEl.textContent = (0, $717583c92e4d0d32$export$ba222f409b09c174)(quest.progress);
    }
    /**
   * Show the completion glow on a card, then reset to new quest.
   * @param {string} tier
   * @param {object} completedQuest
   */ showCompletion(tier, completedQuest) {
        const card = this._cards[tier];
        if (!card) return;
        card.progressEl.textContent = "Complete! \u2713";
        card.el.classList.add('completing');
        if (this._glowTimers[tier]) clearTimeout(this._glowTimers[tier]);
        this._glowTimers[tier] = setTimeout(()=>{
            card.el.classList.remove('completing');
            this._glowTimers[tier] = null;
        }, $d11d076be9c0eda4$var$COMPLETION_GLOW_MS);
    }
    /** Refresh all 3 cards from an active quests map. */ refresh(active) {
        for (const [tier, quest] of Object.entries(active))if (quest) this.setQuest(tier, quest);
    }
}
function $d11d076be9c0eda4$var$_rewardLabel(reward) {
    if (!reward) return '';
    const fn = $d11d076be9c0eda4$var$REWARD_LABELS[reward.kind];
    return fn ? fn(reward) : '';
}



var $b5Oyo = parcelRequire("b5Oyo");
// ===== CONSTANTS =====
const $761f97bf09d51d3e$var$HEX_SIZE = 40;
const $761f97bf09d51d3e$var$OVERLAY_UNLOCK_CADENCE = 100; // every N stars, unlock 1 regular overlay (v2)
// ===== AUDIO =====
const $761f97bf09d51d3e$var$audio = new (0, $e6iAa.AudioManager)();
const $761f97bf09d51d3e$var$ambienceManager = new (0, $a8d03dc7028b41ab$export$2705803b38c34715)($761f97bf09d51d3e$var$audio);
// Save-data check: default ambience off on metered connections
if (navigator.connection && navigator.connection.saveData) $761f97bf09d51d3e$var$ambienceManager.setEnabled(false);
function $761f97bf09d51d3e$var$getBiomeResolveDeps() {
    return {
        tiles: $761f97bf09d51d3e$var$tiles,
        hexKey: $3WWYP.hexKey,
        pixelToHex: $3WWYP.pixelToHex,
        hexSize: $761f97bf09d51d3e$var$HEX_SIZE,
        getMajorityType: $761f97bf09d51d3e$var$getMajorityType,
        hexesWithinRadius: $3WWYP.hexesWithinRadius
    };
}
function $761f97bf09d51d3e$var$resolveAndUpdateAmbience(force) {
    if (!$761f97bf09d51d3e$var$ambienceManager.isReady) return;
    const resolved = (0, $cd18dbf5d161796c$export$bc96b274c408949e)({
        cameraX: $761f97bf09d51d3e$var$camera.x,
        cameraY: $761f97bf09d51d3e$var$camera.y,
        zoom: $761f97bf09d51d3e$var$camera.zoom
    }, $761f97bf09d51d3e$var$getBiomeResolveDeps());
    if (force) $761f97bf09d51d3e$var$ambienceManager.forceUpdateFromResolvedBiome(resolved);
    else $761f97bf09d51d3e$var$ambienceManager.updateFromResolvedBiome(resolved);
}
function $761f97bf09d51d3e$var$unlockAudio() {
    if ($761f97bf09d51d3e$var$audio.isUnlocked()) return;
    $761f97bf09d51d3e$var$audio.unlock().then(()=>{
        $761f97bf09d51d3e$var$audio.preloadSfx();
        $761f97bf09d51d3e$var$audio.preloadMusic([
            (0, $4G7Km.MUSIC_TRACKS)[0].id
        ]).then(()=>{
            $761f97bf09d51d3e$var$audio.setPlaylist((0, $4G7Km.MUSIC_TRACKS).map((t)=>t.id), {
                shuffle: false
            });
            $761f97bf09d51d3e$var$audio.playMusic();
        });
        // Start ambience
        $761f97bf09d51d3e$var$ambienceManager.unlock();
        $761f97bf09d51d3e$var$resolveAndUpdateAmbience(true);
    });
}
// Unlock on first user interaction
const $761f97bf09d51d3e$var$unlockEvents = [
    "click",
    "keydown",
    "touchstart"
];
function $761f97bf09d51d3e$var$onFirstInteraction() {
    $761f97bf09d51d3e$var$unlockAudio();
    for (const ev of $761f97bf09d51d3e$var$unlockEvents)window.removeEventListener(ev, $761f97bf09d51d3e$var$onFirstInteraction, true);
}
for (const ev of $761f97bf09d51d3e$var$unlockEvents)window.addEventListener(ev, $761f97bf09d51d3e$var$onFirstInteraction, true);
// ===== GAME STATE =====
let $761f97bf09d51d3e$var$tiles = {};
let $761f97bf09d51d3e$var$resources = {};
let $761f97bf09d51d3e$var$score = {
    stars: 0
};
let $761f97bf09d51d3e$var$hand = [];
let $761f97bf09d51d3e$var$selectedHandIndex = 0;
let $761f97bf09d51d3e$var$camera = {
    x: 0,
    y: 0,
    zoom: 1
};
let $761f97bf09d51d3e$var$animations = [];
let $761f97bf09d51d3e$var$placementAnims = [];
let $761f97bf09d51d3e$var$pendingUnlockNotifs = [];
// Overlay state
let $761f97bf09d51d3e$var$overlayUnlocks = {
    locked: [],
    unlocked: [],
    starsSinceLastUnlock: 0
};
let $761f97bf09d51d3e$var$overlayIdCounter = 0;
// Ability state
let $761f97bf09d51d3e$var$rerollChainCount = 0;
let $761f97bf09d51d3e$var$storageCapacity = 0;
let $761f97bf09d51d3e$var$storage = [
    null,
    null,
    null
];
let $761f97bf09d51d3e$var$demolishMode = false;
let $761f97bf09d51d3e$var$selectedStorageIndex = -1;
// ===== ANALYTICS HELPERS =====
const $761f97bf09d51d3e$var$_SLOT_NAMES = [
    "optimal",
    "explorer",
    "comfort"
];
function $761f97bf09d51d3e$var$_starsBucket(n) {
    return n <= 5 ? String(n) : "6+";
}
function $761f97bf09d51d3e$var$_adjBucket(n) {
    return n <= 3 ? String(n) : "4+";
}
function $761f97bf09d51d3e$var$_chainBucket(n) {
    return n <= 0 ? "0" : n === 1 ? "1" : "2+";
}
let $761f97bf09d51d3e$var$_abilityUnlockTracked = {
    preview: false,
    reroll: false,
    storage: false
};
function $761f97bf09d51d3e$var$checkAbilityUnlocks() {
    if (!$761f97bf09d51d3e$var$_abilityUnlockTracked.preview && $761f97bf09d51d3e$var$score.stars >= 25) {
        $761f97bf09d51d3e$var$_abilityUnlockTracked.preview = true;
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("ability_unlock", {
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            ability: "preview",
            stars: 25
        });
    }
    if (!$761f97bf09d51d3e$var$_abilityUnlockTracked.reroll && $761f97bf09d51d3e$var$score.stars >= 50) {
        $761f97bf09d51d3e$var$_abilityUnlockTracked.reroll = true;
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("ability_unlock", {
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            ability: "reroll",
            stars: 50
        });
    }
    if (!$761f97bf09d51d3e$var$_abilityUnlockTracked.storage && $761f97bf09d51d3e$var$score.stars >= 100) {
        $761f97bf09d51d3e$var$_abilityUnlockTracked.storage = true;
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("ability_unlock", {
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            ability: "storage",
            stars: 100
        });
    }
}
function $761f97bf09d51d3e$var$initAbilityUnlockTracking() {
    $761f97bf09d51d3e$var$_abilityUnlockTracked = {
        preview: $761f97bf09d51d3e$var$score.stars >= 25,
        reroll: $761f97bf09d51d3e$var$score.stars >= 50,
        storage: $761f97bf09d51d3e$var$score.stars >= 100
    };
}
// ===== UNLOCK CHECKS =====
function $761f97bf09d51d3e$var$isPreviewUnlocked() {
    return $761f97bf09d51d3e$var$score.stars >= 25;
}
function $761f97bf09d51d3e$var$isRerollUnlocked() {
    return $761f97bf09d51d3e$var$score.stars >= 50;
}
function $761f97bf09d51d3e$var$isStorageUnlocked() {
    return $761f97bf09d51d3e$var$score.stars >= 100;
}
// ===== RESOURCE HELPERS =====
function $761f97bf09d51d3e$var$initResources() {
    $761f97bf09d51d3e$var$resources = {};
    for (const res of (0, $8pKpp.RESOURCE_TYPES))$761f97bf09d51d3e$var$resources[res] = 0;
}
$761f97bf09d51d3e$var$initResources();
function $761f97bf09d51d3e$var$canAfford(cost) {
    for (const [res, amount] of Object.entries(cost)){
        if (($761f97bf09d51d3e$var$resources[res] || 0) < amount) return false;
    }
    return true;
}
function $761f97bf09d51d3e$var$payCost(cost) {
    for (const [res, amount] of Object.entries(cost))$761f97bf09d51d3e$var$resources[res] = ($761f97bf09d51d3e$var$resources[res] || 0) - amount;
}
function $761f97bf09d51d3e$var$getRerollCost(n) {
    if (n <= 0) return {
        fish: 1,
        food: 1,
        supplies: 1
    };
    if (n === 1) return {
        fish: 2,
        food: 2,
        supplies: 1
    };
    return {
        fish: 3,
        food: 3,
        supplies: 2
    };
}
function $761f97bf09d51d3e$var$getStorageUpgradeCost(cap) {
    if (cap === 1) return {
        wood: 6,
        stone: 4,
        supplies: 2
    };
    return {
        wood: 10,
        stone: 8,
        supplies: 4,
        crystals: 2
    };
}
function $761f97bf09d51d3e$var$getDemolishCost(tile) {
    if (tile.overlaySpriteKey) return {
        stars: 3
    };
    return {
        stars: 5
    };
}
function $761f97bf09d51d3e$var$formatCost(cost) {
    return Object.entries(cost).map(([res, amt])=>{
        if (res === "stars") return `${amt}\u2b50`;
        return `${amt}${(0, $8pKpp.RESOURCE_EMOJI)[res]}`;
    }).join(" ");
}
/** Return the most common type in a sides array. */ function $761f97bf09d51d3e$var$getMajorityType(sides) {
    const counts = {};
    for (const s of sides)counts[s] = (counts[s] || 0) + 1;
    let best = null, bestCount = 0;
    for (const [type, count] of Object.entries(counts))if (count > bestCount) {
        best = type;
        bestCount = count;
    }
    return best;
}
// ===== ATLAS STATE (loaded async) =====
let $761f97bf09d51d3e$var$spriteAtlas = null;
let $761f97bf09d51d3e$var$spriteIndex = null;
// ===== RENDERER SETUP =====
const $761f97bf09d51d3e$var$lifeCanvas = document.getElementById("life-canvas");
const $761f97bf09d51d3e$var$canvas = document.getElementById("game");
const $761f97bf09d51d3e$var$ctx = $761f97bf09d51d3e$var$canvas.getContext("2d");
const $761f97bf09d51d3e$var$cloudsCanvas = document.getElementById("clouds");
const $761f97bf09d51d3e$var$cloudsCtx = $761f97bf09d51d3e$var$cloudsCanvas.getContext("2d");
const $761f97bf09d51d3e$var$postfxCanvas = document.getElementById("postfx");
const $761f97bf09d51d3e$var$postfxCtx = $761f97bf09d51d3e$var$postfxCanvas.getContext("2d");
const $761f97bf09d51d3e$var$cloudSystem = new (0, $18698456007592c5$export$56e19766c69f1963)();
const $761f97bf09d51d3e$var$cloudRenderer = new (0, $076d6ff4d6ef455d$export$5bda4955e4213f9c)();
const $761f97bf09d51d3e$var$cloudShadowRenderer = new (0, $569c26efefdfd603$export$379d01a2d692c6fb)();
const $761f97bf09d51d3e$var$zoomTracker = new (0, $b4ce220eca07e4ed$export$4b255736f634255e)();
const $761f97bf09d51d3e$var$worldClock = new (0, $6cbbc4839031f904$export$29a0f2b50ac2bb00)();
const $761f97bf09d51d3e$var$postFx = new (0, $e3cdab81932accf3$export$42854aa698a422ea)();
const $761f97bf09d51d3e$var$weatherState = new (0, $ce570bd6fda2fb53$export$64fa64c8fb69054a)(42);
const $761f97bf09d51d3e$var$precipRenderer = new (0, $1df9fd9e8e3147d0$export$585aa35dc8269fa5)();
$761f97bf09d51d3e$var$cloudSystem.weatherState = $761f97bf09d51d3e$var$weatherState;
const $761f97bf09d51d3e$var$renderer = new (0, $3oGCi.HexaworldsRenderer)({
    lifeCanvas: $761f97bf09d51d3e$var$lifeCanvas,
    blueprintCanvas: $761f97bf09d51d3e$var$canvas,
    hexSize: $761f97bf09d51d3e$var$HEX_SIZE,
    worldSeed: 42,
    cloudShadowRenderer: $761f97bf09d51d3e$var$cloudShadowRenderer
});
let $761f97bf09d51d3e$var$_lastFrameTime = 0;
function $761f97bf09d51d3e$var$resize() {
    $761f97bf09d51d3e$var$canvas.width = window.innerWidth;
    $761f97bf09d51d3e$var$canvas.height = window.innerHeight;
    $761f97bf09d51d3e$var$lifeCanvas.width = window.innerWidth;
    $761f97bf09d51d3e$var$lifeCanvas.height = window.innerHeight;
    $761f97bf09d51d3e$var$cloudsCanvas.width = window.innerWidth;
    $761f97bf09d51d3e$var$cloudsCanvas.height = window.innerHeight;
    $761f97bf09d51d3e$var$postfxCanvas.width = window.innerWidth;
    $761f97bf09d51d3e$var$postfxCanvas.height = window.innerHeight;
}
window.addEventListener("resize", $761f97bf09d51d3e$var$resize);
$761f97bf09d51d3e$var$resize();
// ===== TILE GENERATION =====
let $761f97bf09d51d3e$var$tileIdCounter = 0;
/** Count how many exposed edges exist per type (edges facing empty neighbours). */ function $761f97bf09d51d3e$var$getExposedTypeCounts() {
    const counts = new Map();
    for (const key of Object.keys($761f97bf09d51d3e$var$tiles)){
        const t = $761f97bf09d51d3e$var$tiles[key];
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(t.coord.q, t.coord.r, s);
            if (!$761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)]) {
                const type = (0, $3WWYP.getEffectiveSide)(t.sides, t.rotation, s);
                counts.set(type, (counts.get(type) || 0) + 1);
            }
        }
    }
    return counts;
}
/** Collect all distinct types present across all placed tile sides. */ function $761f97bf09d51d3e$var$getPlacedTypes() {
    const placed = new Set();
    for (const key of Object.keys($761f97bf09d51d3e$var$tiles)){
        const t = $761f97bf09d51d3e$var$tiles[key];
        for (const side of t.sides)placed.add(side);
    }
    return placed;
}
/** Build a tile object from a sides array, applying random rotation offset. */ function $761f97bf09d51d3e$var$buildTile(sides) {
    const offset = Math.floor(Math.random() * 6);
    const rotatedSides = [];
    for(let i = 0; i < 6; i++)rotatedSides.push(sides[((i - offset) % 6 + 6) % 6]);
    const tile = {
        id: "tile_" + $761f97bf09d51d3e$var$tileIdCounter++,
        coord: null,
        rotation: 0,
        sides: rotatedSides,
        placed: false,
        placedAtMs: null,
        seed: Math.floor(Math.random() * 0x7fffffff)
    };
    $761f97bf09d51d3e$var$renderer.assignSpriteKeys(tile);
    return tile;
}
/** Get the top N most-exposed types sorted by count descending. */ function $761f97bf09d51d3e$var$getTopExposed(exposedCounts, n) {
    return [
        ...exposedCounts.entries()
    ].sort((a, b)=>b[1] - a[1]).slice(0, n).map((e)=>e[0]);
}
/** Sample a type from exposed counts using sqrt-weighted random selection. */ function $761f97bf09d51d3e$var$pickWeightedType(exposedCounts, excludeType) {
    const entries = [
        ...exposedCounts.entries()
    ].filter(([type])=>type !== excludeType);
    if (entries.length === 0) return null;
    let total = 0;
    const weights = entries.map(([type, count])=>{
        const w = Math.sqrt(count);
        total += w;
        return {
            type: type,
            w: w
        };
    });
    let r = Math.random() * total;
    for (const { type: type, w: w } of weights){
        r -= w;
        if (r <= 0) return type;
    }
    return weights[weights.length - 1].type;
}
/** Pick two distinct types via weighted random sampling. */ function $761f97bf09d51d3e$var$pickWeightedTypePair(exposedCounts) {
    const typeA = $761f97bf09d51d3e$var$pickWeightedType(exposedCounts);
    if (typeA === null) return [
        null,
        null
    ];
    const typeB = $761f97bf09d51d3e$var$pickWeightedType(exposedCounts, typeA);
    return [
        typeA,
        typeB
    ];
}
/** Slot 1 — "Optimal" tile: best match potential using weighted-random types. */ function $761f97bf09d51d3e$var$generateOptimalTile(exposedCounts) {
    const [typeA, typeB] = $761f97bf09d51d3e$var$pickWeightedTypePair(exposedCounts);
    if (typeA === null) return $761f97bf09d51d3e$var$generateContiguousTileFallback();
    if (typeB === null) return $761f97bf09d51d3e$var$buildTile(Array(6).fill(typeA));
    const roll = Math.random();
    const aCount = roll < 0.15 ? 3 : roll < 0.55 ? 4 : 5;
    const sides = [];
    for(let i = 0; i < 6; i++)sides.push(i < aCount ? typeA : typeB);
    return $761f97bf09d51d3e$var$buildTile(sides);
}
/** Slot 2 — "Explorer" tile: introduces new types paired with weighted-random anchor. */ function $761f97bf09d51d3e$var$generateExplorerTile(exposedCounts, placedTypes) {
    const anchor = $761f97bf09d51d3e$var$pickWeightedType(exposedCounts);
    if (anchor === null) return $761f97bf09d51d3e$var$generateContiguousTileFallback();
    const unused = (0, $8pKpp.TILE_TYPES).filter((t)=>!placedTypes.has(t));
    let newType;
    if (unused.length > 0) newType = unused[Math.floor(Math.random() * unused.length)];
    else {
        const sorted = [
            ...exposedCounts.entries()
        ].sort((a, b)=>a[1] - b[1]);
        newType = sorted[0][0];
        if (newType === anchor && sorted.length > 1) newType = sorted[1][0];
    }
    const sides = [];
    for(let i = 0; i < 6; i++)sides.push(i < 3 ? anchor : newType);
    return $761f97bf09d51d3e$var$buildTile(sides);
}
/** Slot 3 — "Comfort" tile: safe mono tile of a weighted-random exposed type. */ function $761f97bf09d51d3e$var$generateComfortTile(exposedCounts) {
    const pick = $761f97bf09d51d3e$var$pickWeightedType(exposedCounts);
    if (pick === null) return $761f97bf09d51d3e$var$generateContiguousTileFallback();
    return $761f97bf09d51d3e$var$buildTile(Array(6).fill(pick));
}
/** Fallback: fully random tile via existing generator. */ function $761f97bf09d51d3e$var$generateContiguousTileFallback() {
    const exposedCounts = $761f97bf09d51d3e$var$getExposedTypeCounts();
    const exposed = new Set(exposedCounts.keys());
    const tile = (0, $jlsYx.generateContiguousTile)($761f97bf09d51d3e$var$tileIdCounter++, {
        exposedTypes: exposed.size > 0 ? exposed : null
    });
    $761f97bf09d51d3e$var$renderer.assignSpriteKeys(tile);
    return tile;
}
/** Classify a hand item as 'overlay', 'full', or 'two-type'. */ function $761f97bf09d51d3e$var$classifyHandItem(item) {
    if (item.isOverlay) return "overlay";
    const types = new Set(item.sides);
    return types.size <= 1 ? "full" : "two-type";
}
/** Generate a tile guaranteed to have exactly 2 distinct types. */ function $761f97bf09d51d3e$var$generateTwoTypeTile(exposedCounts, placedTypes) {
    if (exposedCounts.size === 0) return $761f97bf09d51d3e$var$generateContiguousTileFallback();
    if (Math.random() < 0.5) {
        // Optimal-style: 4:2 or 5:1 split using weighted-random types
        const [typeA, typeB_] = $761f97bf09d51d3e$var$pickWeightedTypePair(exposedCounts);
        if (typeA === null) return $761f97bf09d51d3e$var$generateContiguousTileFallback();
        let typeB = typeB_;
        if (typeB === null) {
            // Only 1 exposed type — pick a random different type
            const others = (0, $8pKpp.TILE_TYPES).filter((t)=>t !== typeA);
            typeB = others[Math.floor(Math.random() * others.length)];
        }
        const roll = Math.random();
        const aCount = roll < 0.15 ? 3 : roll < 0.55 ? 4 : 5;
        const sides = [];
        for(let i = 0; i < 6; i++)sides.push(i < aCount ? typeA : typeB);
        return $761f97bf09d51d3e$var$buildTile(sides);
    } else // Explorer-style: 3:3 split
    return $761f97bf09d51d3e$var$generateExplorerTile(exposedCounts, placedTypes);
}
/** Create an overlay hand item from a random overlay in the given list. */ function $761f97bf09d51d3e$var$generateOverlayHandItem(placeableKeys) {
    const idx = Math.floor(Math.random() * placeableKeys.length);
    const overlayKey = placeableKeys[idx];
    return {
        isOverlay: true,
        overlayKey: overlayKey,
        id: "overlay_" + $761f97bf09d51d3e$var$overlayIdCounter++,
        sides: []
    };
}
/** Generate a tile for a specific hand slot using gap-filling strategy. */ function $761f97bf09d51d3e$var$generateTileForSlot(slot) {
    const exposedCounts = $761f97bf09d51d3e$var$getExposedTypeCounts();
    const placedTypes = $761f97bf09d51d3e$var$getPlacedTypes();
    // Scan existing hand to see what categories are present
    const present = new Set();
    for (const item of $761f97bf09d51d3e$var$hand)if (item) present.add($761f97bf09d51d3e$var$classifyHandItem(item));
    // Ideal set of categories
    const ideal = [
        "two-type",
        "full",
        "overlay"
    ];
    const missing = ideal.filter((c)=>!present.has(c));
    // Pick category: 80% fill a gap, 20% wild random
    let isRandomFallback = false;
    let category;
    if (missing.length > 0 && Math.random() < 0.8) category = missing[Math.floor(Math.random() * missing.length)];
    else {
        // Wild: pick from all three weighted toward tiles
        isRandomFallback = true;
        const roll = Math.random();
        category = roll < 0.4 ? "two-type" : roll < 0.8 ? "full" : "overlay";
    }
    // Try to generate overlay if chosen
    if (category === "overlay" && $761f97bf09d51d3e$var$overlayUnlocks.unlocked.length > 0) {
        const { hasVacantWater: hasVacantWater, hasVacantGround: hasVacantGround } = $761f97bf09d51d3e$var$getVacantTileTypes();
        const placeableKeys = $761f97bf09d51d3e$var$overlayUnlocks.unlocked.filter((k)=>(0, $eehpt.isWaterOverlay)(k) ? hasVacantWater : hasVacantGround);
        if (placeableKeys.length > 0) return $761f97bf09d51d3e$var$generateOverlayHandItem(placeableKeys);
        // Fall through to a tile if can't generate overlay
        category = Math.random() < 0.5 ? "two-type" : "full";
    }
    let result;
    if (exposedCounts.size === 0) {
        result = $761f97bf09d51d3e$var$generateContiguousTileFallback();
        isRandomFallback = true;
    } else if (category === "two-type") result = $761f97bf09d51d3e$var$generateTwoTypeTile(exposedCounts, placedTypes);
    else result = $761f97bf09d51d3e$var$generateComfortTile(exposedCounts);
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("tile_offer", {
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        slot: $761f97bf09d51d3e$var$_SLOT_NAMES[slot] || "slot" + slot,
        tile_sig: (0, $4ce0f3b8ba251f2f$export$8d7692cdcb9b805e)(result.sides),
        is_random_fallback: isRandomFallback
    });
    return result;
}
function $761f97bf09d51d3e$var$fillHand() {
    while($761f97bf09d51d3e$var$hand.length < 3){
        const slot = $761f97bf09d51d3e$var$hand.length;
        $761f97bf09d51d3e$var$hand.push($761f97bf09d51d3e$var$generateTileForSlot(slot));
    }
    if ($761f97bf09d51d3e$var$selectedHandIndex >= $761f97bf09d51d3e$var$hand.length) $761f97bf09d51d3e$var$selectedHandIndex = 0;
    $761f97bf09d51d3e$var$renderHand();
}
// ===== PLACEMENT =====
function $761f97bf09d51d3e$var$getValidPlacements() {
    const tileKeys = Object.keys($761f97bf09d51d3e$var$tiles);
    if (tileKeys.length === 0) return new Set([
        (0, $3WWYP.hexKey)(0, 0)
    ]);
    const valid = new Set();
    for (const key of tileKeys){
        const t = $761f97bf09d51d3e$var$tiles[key];
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(t.coord.q, t.coord.r, s);
            const nk = (0, $3WWYP.hexKey)(nb.q, nb.r);
            if (!$761f97bf09d51d3e$var$tiles[nk]) valid.add(nk);
        }
    }
    return valid;
}
function $761f97bf09d51d3e$var$placeTile(q, r) {
    if ($761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(q, r)]) return false;
    const tile = $761f97bf09d51d3e$var$hand[$761f97bf09d51d3e$var$selectedHandIndex];
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).startSessionIfNeeded({
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        first_action: "tile_place"
    });
    tile.coord = {
        q: q,
        r: r
    };
    tile.placed = true;
    tile.placedAtMs = performance.now();
    $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(q, r)] = tile;
    if (!tile.baseSpriteKey) $761f97bf09d51d3e$var$renderer.assignSpriteKeys(tile);
    const px = (0, $3WWYP.hexToPixel)(q, r, $761f97bf09d51d3e$var$HEX_SIZE);
    $761f97bf09d51d3e$var$placementAnims.push({
        x: px.x,
        y: px.y,
        t: performance.now(),
        duration: 300
    });
    $761f97bf09d51d3e$var$renderer.upsertTile(tile);
    // Only count matching sides for stars — no resource gains from tile placement
    let totalStars = 0;
    for(let s = 0; s < 6; s++){
        const nb = (0, $3WWYP.getNeighbor)(q, r, s);
        const neighbor = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
        if (!neighbor) continue;
        const mySideType = (0, $3WWYP.getEffectiveSide)(tile.sides, tile.rotation, s);
        const theirSideType = (0, $3WWYP.getEffectiveSide)(neighbor.sides, neighbor.rotation, (0, $3WWYP.oppositeSide)(s));
        if (mySideType === theirSideType) totalStars++;
    }
    if (totalStars > 0) {
        $761f97bf09d51d3e$var$score.stars += totalStars;
        $761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock += totalStars;
        $761f97bf09d51d3e$var$checkOverlayUnlock();
        $761f97bf09d51d3e$var$animations.push({
            x: px.x,
            y: px.y - 10,
            text: "\u2b50 +" + totalStars,
            startTime: performance.now(),
            duration: 1000,
            isScore: true
        });
    }
    $761f97bf09d51d3e$var$checkAbilityUnlocks();
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("tile_place", {
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        source: $761f97bf09d51d3e$var$_SLOT_NAMES[$761f97bf09d51d3e$var$selectedHandIndex] || "slot" + $761f97bf09d51d3e$var$selectedHandIndex,
        tile_sig: (0, $4ce0f3b8ba251f2f$export$8d7692cdcb9b805e)(tile.sides),
        stars_bucket: $761f97bf09d51d3e$var$_starsBucket(totalStars)
    });
    // Ensure storage unlocks when threshold met
    if ($761f97bf09d51d3e$var$isStorageUnlocked() && $761f97bf09d51d3e$var$storageCapacity < 1) $761f97bf09d51d3e$var$storageCapacity = 1;
    $761f97bf09d51d3e$var$rerollChainCount = 0;
    $761f97bf09d51d3e$var$audio.playSfx("tile_place");
    $761f97bf09d51d3e$var$hand.splice($761f97bf09d51d3e$var$selectedHandIndex, 1);
    $761f97bf09d51d3e$var$fillHand();
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$renderStoragePanel();
    $761f97bf09d51d3e$var$saveGame();
    $761f97bf09d51d3e$var$rebuildAdjacencyAt({
        q: q,
        r: r
    });
    // Quest v2: build placement event
    {
        const majorType = $761f97bf09d51d3e$var$getMajorityType(tile.sides);
        let neighbourCount = 0;
        const neighbourTerrainTypes = new Set();
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(q, r, s);
            const nbT = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
            if (nbT && nbT.placed) {
                neighbourCount++;
                neighbourTerrainTypes.add($761f97bf09d51d3e$var$getMajorityType(nbT.sides));
            }
        }
        $761f97bf09d51d3e$var$questManager.onTilePlaced({
            coord: {
                q: q,
                r: r
            },
            matchCount: totalStars,
            majorType: majorType,
            isOcean: tile.baseSpriteKey ? (0, $eehpt.isWaterTile)(tile.baseSpriteKey) : false,
            neighbourCount: neighbourCount,
            neighbourTerrainTypes: neighbourTerrainTypes
        });
    }
    return true;
}
/** Check which vacant tile categories exist for overlay placement. */ function $761f97bf09d51d3e$var$getVacantTileTypes() {
    let hasVacantWater = false;
    let hasVacantGround = false;
    for (const key of Object.keys($761f97bf09d51d3e$var$tiles)){
        const t = $761f97bf09d51d3e$var$tiles[key];
        if (!t.placed || t.overlaySpriteKey) continue;
        if (t.baseSpriteKey && (0, $eehpt.isWaterTile)(t.baseSpriteKey)) hasVacantWater = true;
        else hasVacantGround = true;
        if (hasVacantWater && hasVacantGround) break;
    }
    return {
        hasVacantWater: hasVacantWater,
        hasVacantGround: hasVacantGround
    };
}
// ===== OVERLAY SYSTEM =====
/** Regular overlay families (unlocked via creative quests or 100-star milestone). */ const $761f97bf09d51d3e$var$REGULAR_OVERLAY_FAMILIES = new Set([
    'forest',
    'vegetation',
    'mountainrocks',
    'island_land',
    'island_water'
]);
/** Special overlay families (unlocked only via special quests). */ const $761f97bf09d51d3e$var$SPECIAL_OVERLAY_FAMILIES = new Set([
    'animal_land',
    'animal_water',
    'ship',
    'structure',
    'campsite',
    'castle_ruin',
    'dragon',
    'geysers',
    'flying_castle',
    'graveyard'
]);
function $761f97bf09d51d3e$var$getRegularLockedOverlays() {
    return $761f97bf09d51d3e$var$overlayUnlocks.locked.filter((k)=>$761f97bf09d51d3e$var$REGULAR_OVERLAY_FAMILIES.has((0, $eehpt.getOverlayFamily)(k)));
}
function $761f97bf09d51d3e$var$getSpecialLockedOverlays() {
    return $761f97bf09d51d3e$var$overlayUnlocks.locked.filter((k)=>$761f97bf09d51d3e$var$SPECIAL_OVERLAY_FAMILIES.has((0, $eehpt.getOverlayFamily)(k)));
}
/** Unlock one overlay from the given pool ('regular' or 'special'). Returns the key or null. */ function $761f97bf09d51d3e$var$unlockOverlayFromPool(pool) {
    const candidates = pool === 'regular' ? $761f97bf09d51d3e$var$getRegularLockedOverlays() : $761f97bf09d51d3e$var$getSpecialLockedOverlays();
    if (candidates.length === 0) return null;
    const pick = candidates[Math.floor(Math.random() * candidates.length)];
    const idx = $761f97bf09d51d3e$var$overlayUnlocks.locked.indexOf(pick);
    $761f97bf09d51d3e$var$overlayUnlocks.locked.splice(idx, 1);
    $761f97bf09d51d3e$var$overlayUnlocks.unlocked.push(pick);
    return pick;
}
function $761f97bf09d51d3e$var$initOverlayState() {
    if ($761f97bf09d51d3e$var$spriteIndex) {
        $761f97bf09d51d3e$var$overlayUnlocks.locked = [
            ...$761f97bf09d51d3e$var$spriteIndex.overlayKeysAll
        ];
        $761f97bf09d51d3e$var$overlayUnlocks.unlocked = [];
        $761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock = 0;
    }
}
/** Called when stars are added — check 100-star regular overlay milestone. */ function $761f97bf09d51d3e$var$checkOverlayUnlock() {
    let unlocked = false;
    while($761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock >= $761f97bf09d51d3e$var$OVERLAY_UNLOCK_CADENCE && $761f97bf09d51d3e$var$getRegularLockedOverlays().length > 0){
        $761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock -= $761f97bf09d51d3e$var$OVERLAY_UNLOCK_CADENCE;
        const pick = $761f97bf09d51d3e$var$unlockOverlayFromPool('regular');
        if (pick) {
            $761f97bf09d51d3e$var$pendingUnlockNotifs.push(pick);
            (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("overlay_unlock", {
                build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
                source: "star_milestone",
                unlocked_total: $761f97bf09d51d3e$var$overlayUnlocks.unlocked.length,
                locked_remaining: $761f97bf09d51d3e$var$overlayUnlocks.locked.length
            });
            unlocked = true;
        }
    }
    if (unlocked) {
        $761f97bf09d51d3e$var$audio.playSfx("overlay_unlock");
        $761f97bf09d51d3e$var$updateHUD();
        $761f97bf09d51d3e$var$showNextUnlockNotif();
    }
}
function $761f97bf09d51d3e$var$spawnConfetti() {
    const colors = [
        "#ff6b6b",
        "#ffd93d",
        "#6bcb77",
        "#4d96ff",
        "#ff6bef",
        "#ffa36b"
    ];
    const modal = document.getElementById("unlock-modal");
    for(let i = 0; i < 30; i++){
        const piece = document.createElement("div");
        piece.className = "confetti-piece";
        piece.style.background = colors[Math.floor(Math.random() * colors.length)];
        piece.style.left = Math.random() * 100 + "vw";
        piece.style.top = -10 - Math.random() * 20 + "px";
        piece.style.setProperty("--cx", Math.random() * 200 - 100 + "px");
        piece.style.animationDuration = 1.5 + Math.random() + "s";
        piece.style.animationDelay = Math.random() * 0.5 + "s";
        modal.appendChild(piece);
    }
}
function $761f97bf09d51d3e$var$clearConfetti() {
    const modal = document.getElementById("unlock-modal");
    modal.querySelectorAll(".confetti-piece").forEach((el)=>el.remove());
}
function $761f97bf09d51d3e$var$showNextUnlockNotif() {
    if ($761f97bf09d51d3e$var$pendingUnlockNotifs.length === 0) return;
    const modal = document.getElementById("unlock-modal");
    if (modal.classList.contains("visible")) return;
    const overlayKey = $761f97bf09d51d3e$var$pendingUnlockNotifs.shift();
    const previewCanvas = document.getElementById("unlock-preview");
    const pctx = previewCanvas.getContext("2d");
    pctx.clearRect(0, 0, 80, 80);
    if ($761f97bf09d51d3e$var$spriteAtlas && $761f97bf09d51d3e$var$spriteAtlas.has(overlayKey)) {
        const scale = 80 / 30;
        pctx.save();
        pctx.scale(scale, scale);
        $761f97bf09d51d3e$var$spriteAtlas.draw(pctx, overlayKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
        pctx.restore();
    }
    $761f97bf09d51d3e$var$clearConfetti();
    $761f97bf09d51d3e$var$spawnConfetti();
    modal.classList.add("visible");
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_open");
}
// Prevent unlock modal clicks from bubbling to the canvas/window placement handler
const $761f97bf09d51d3e$var$unlockModal = document.getElementById("unlock-modal");
$761f97bf09d51d3e$var$unlockModal.addEventListener("mousedown", (e)=>e.stopPropagation());
$761f97bf09d51d3e$var$unlockModal.addEventListener("mouseup", (e)=>e.stopPropagation());
$761f97bf09d51d3e$var$unlockModal.addEventListener("click", (e)=>e.stopPropagation());
document.getElementById("unlock-ok").addEventListener("click", ()=>{
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_close");
    $761f97bf09d51d3e$var$unlockModal.classList.remove("visible");
    $761f97bf09d51d3e$var$clearConfetti();
    setTimeout(()=>$761f97bf09d51d3e$var$showNextUnlockNotif(), 200);
});
function $761f97bf09d51d3e$var$placeOverlayFromHand(q, r) {
    const key = (0, $3WWYP.hexKey)(q, r);
    const tile = $761f97bf09d51d3e$var$tiles[key];
    if (!tile || !tile.placed) return false;
    if (tile.overlaySpriteKey) return false;
    const handItem = $761f97bf09d51d3e$var$hand[$761f97bf09d51d3e$var$selectedHandIndex];
    if (!handItem || !handItem.isOverlay) return false;
    const overlayKey = handItem.overlayKey;
    const tileIsWater = tile.baseSpriteKey ? (0, $eehpt.isWaterTile)(tile.baseSpriteKey) : false;
    const overlayIsWater = (0, $eehpt.isWaterOverlay)(overlayKey);
    if (tileIsWater !== overlayIsWater) return false;
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).startSessionIfNeeded({
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        first_action: "overlay_place"
    });
    tile.overlaySpriteKey = overlayKey;
    const px = (0, $3WWYP.hexToPixel)(q, r, $761f97bf09d51d3e$var$HEX_SIZE);
    $761f97bf09d51d3e$var$placementAnims.push({
        x: px.x,
        y: px.y,
        t: performance.now(),
        duration: 300
    });
    // Sparkle burst on overlay placement
    $761f97bf09d51d3e$var$renderer.triggerOverlaySparkles(q, r);
    // Compute overlay economy reward
    const majorType = $761f97bf09d51d3e$var$getMajorityType(tile.sides);
    let adjacentOverlays = 0;
    for(let s = 0; s < 6; s++){
        const nb = (0, $3WWYP.getNeighbor)(q, r, s);
        const neighbor = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
        if (neighbor && neighbor.overlaySpriteKey) adjacentOverlays++;
    }
    const reward = (0, $eehpt.computeOverlayPlacementReward)(overlayKey, majorType, adjacentOverlays);
    // Award stars
    $761f97bf09d51d3e$var$score.stars += reward.stars;
    $761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock += reward.stars;
    $761f97bf09d51d3e$var$checkOverlayUnlock();
    $761f97bf09d51d3e$var$animations.push({
        x: px.x,
        y: px.y - 10,
        text: "\u2b50 +" + reward.stars,
        startTime: performance.now(),
        duration: 1000,
        isScore: true
    });
    // Award resources
    for (const [resType, amount] of Object.entries(reward.resources)){
        $761f97bf09d51d3e$var$resources[resType] = ($761f97bf09d51d3e$var$resources[resType] || 0) + amount;
        const emoji = (0, $8pKpp.RESOURCE_EMOJI)[resType];
        if (emoji) for(let i = 0; i < Math.min(amount, 5); i++){
            $761f97bf09d51d3e$var$animations.push({
                x: px.x + (Math.random() - 0.5) * 20,
                y: px.y,
                text: `+${amount > 1 && i === 0 ? amount + " " : ""}${emoji}`,
                startTime: performance.now() + i * 80,
                duration: 800
            });
            if (amount > 1 && i === 0) break; // show single "+N emoji" for multi
        }
    }
    $761f97bf09d51d3e$var$checkAbilityUnlocks();
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("overlay_place", {
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        family: (0, $eehpt.getOverlayFamily)(overlayKey),
        adj_bucket: $761f97bf09d51d3e$var$_adjBucket(adjacentOverlays),
        terrain: majorType
    });
    // Ensure storage unlocks when threshold met
    if ($761f97bf09d51d3e$var$isStorageUnlocked() && $761f97bf09d51d3e$var$storageCapacity < 1) $761f97bf09d51d3e$var$storageCapacity = 1;
    $761f97bf09d51d3e$var$rerollChainCount = 0;
    $761f97bf09d51d3e$var$renderer.upsertTile(tile);
    $761f97bf09d51d3e$var$audio.playSfx("overlay_place");
    if (reward.stars > 0) $761f97bf09d51d3e$var$audio.playSfx("reward_star");
    const hasResources = Object.values(reward.resources).some((v)=>v > 0);
    if (hasResources) $761f97bf09d51d3e$var$audio.playSfx("resource_gain");
    $761f97bf09d51d3e$var$hand.splice($761f97bf09d51d3e$var$selectedHandIndex, 1);
    $761f97bf09d51d3e$var$fillHand();
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$renderStoragePanel();
    $761f97bf09d51d3e$var$saveGame();
    // Quest v2: build overlay placement event
    {
        const overlayFamily = (0, $eehpt.getOverlayFamily)(overlayKey);
        const econ = (0, $eehpt.OVERLAY_ECONOMY)[overlayFamily];
        const onBonusTerrain = econ ? econ.bonusTerrains.includes(majorType) : false;
        $761f97bf09d51d3e$var$questManager.onOverlayPlaced({
            coord: {
                q: q,
                r: r
            },
            overlayFamily: overlayFamily,
            adjacentOverlays: adjacentOverlays,
            onBonusTerrain: onBonusTerrain,
            isOcean: tile.baseSpriteKey ? (0, $eehpt.isWaterTile)(tile.baseSpriteKey) : false
        });
    }
    return true;
}
// ===== REROLL ABILITY =====
function $761f97bf09d51d3e$var$rerollSlot(i) {
    if (!$761f97bf09d51d3e$var$isRerollUnlocked()) return;
    const cost = $761f97bf09d51d3e$var$getRerollCost($761f97bf09d51d3e$var$rerollChainCount);
    if (!$761f97bf09d51d3e$var$canAfford(cost)) return;
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).startSessionIfNeeded({
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        first_action: "reroll"
    });
    const chainBucketVal = $761f97bf09d51d3e$var$_chainBucket($761f97bf09d51d3e$var$rerollChainCount);
    $761f97bf09d51d3e$var$payCost(cost);
    $761f97bf09d51d3e$var$hand[i] = $761f97bf09d51d3e$var$generateTileForSlot(i);
    $761f97bf09d51d3e$var$rerollChainCount++;
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("reroll", {
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        slot: $761f97bf09d51d3e$var$_SLOT_NAMES[i] || "slot" + i,
        chain_bucket: chainBucketVal
    });
    $761f97bf09d51d3e$var$renderHand();
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$saveGame();
}
// ===== STORAGE ABILITY =====
function $761f97bf09d51d3e$var$storeFromHand(i) {
    if (!$761f97bf09d51d3e$var$isStorageUnlocked()) return;
    // Find first empty slot within capacity
    let emptyIdx = -1;
    for(let s = 0; s < $761f97bf09d51d3e$var$storageCapacity; s++)if ($761f97bf09d51d3e$var$storage[s] === null) {
        emptyIdx = s;
        break;
    }
    if (emptyIdx === -1) return; // full
    $761f97bf09d51d3e$var$storage[emptyIdx] = $761f97bf09d51d3e$var$hand[i];
    $761f97bf09d51d3e$var$hand[i] = $761f97bf09d51d3e$var$generateTileForSlot(i);
    $761f97bf09d51d3e$var$renderHand();
    $761f97bf09d51d3e$var$renderStoragePanel();
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$saveGame();
}
function $761f97bf09d51d3e$var$placeFromStorage(idx, q, r) {
    if (idx < 0 || idx >= $761f97bf09d51d3e$var$storageCapacity || !$761f97bf09d51d3e$var$storage[idx]) return false;
    const item = $761f97bf09d51d3e$var$storage[idx];
    if (item.isOverlay) {
        // Place overlay from storage
        const key = (0, $3WWYP.hexKey)(q, r);
        const tile = $761f97bf09d51d3e$var$tiles[key];
        if (!tile || !tile.placed || tile.overlaySpriteKey) return false;
        const tileIsWater = tile.baseSpriteKey ? (0, $eehpt.isWaterTile)(tile.baseSpriteKey) : false;
        const overlayIsWater = (0, $eehpt.isWaterOverlay)(item.overlayKey);
        if (tileIsWater !== overlayIsWater) return false;
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).startSessionIfNeeded({
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            first_action: "overlay_place"
        });
        tile.overlaySpriteKey = item.overlayKey;
        const px = (0, $3WWYP.hexToPixel)(q, r, $761f97bf09d51d3e$var$HEX_SIZE);
        $761f97bf09d51d3e$var$placementAnims.push({
            x: px.x,
            y: px.y,
            t: performance.now(),
            duration: 300
        });
        // Sparkle burst on overlay placement from storage
        $761f97bf09d51d3e$var$renderer.triggerOverlaySparkles(q, r);
        const majorType = $761f97bf09d51d3e$var$getMajorityType(tile.sides);
        let adjacentOverlays = 0;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(q, r, s);
            const neighbor = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
            if (neighbor && neighbor.overlaySpriteKey) adjacentOverlays++;
        }
        const reward = (0, $eehpt.computeOverlayPlacementReward)(item.overlayKey, majorType, adjacentOverlays);
        $761f97bf09d51d3e$var$score.stars += reward.stars;
        $761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock += reward.stars;
        $761f97bf09d51d3e$var$checkOverlayUnlock();
        $761f97bf09d51d3e$var$animations.push({
            x: px.x,
            y: px.y - 10,
            text: "\u2b50 +" + reward.stars,
            startTime: performance.now(),
            duration: 1000,
            isScore: true
        });
        for (const [resType, amount] of Object.entries(reward.resources)){
            $761f97bf09d51d3e$var$resources[resType] = ($761f97bf09d51d3e$var$resources[resType] || 0) + amount;
            const emoji = (0, $8pKpp.RESOURCE_EMOJI)[resType];
            if (emoji) $761f97bf09d51d3e$var$animations.push({
                x: px.x + (Math.random() - 0.5) * 20,
                y: px.y,
                text: `+${amount} ${emoji}`,
                startTime: performance.now(),
                duration: 800
            });
        }
        $761f97bf09d51d3e$var$checkAbilityUnlocks();
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("overlay_place", {
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            family: (0, $eehpt.getOverlayFamily)(item.overlayKey),
            adj_bucket: $761f97bf09d51d3e$var$_adjBucket(adjacentOverlays),
            terrain: majorType
        });
        $761f97bf09d51d3e$var$renderer.upsertTile(tile);
    } else {
        // Place tile from storage
        if ($761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(q, r)]) return false;
        const valid = $761f97bf09d51d3e$var$getValidPlacements();
        if (!valid.has((0, $3WWYP.hexKey)(q, r))) return false;
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).startSessionIfNeeded({
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            first_action: "tile_place"
        });
        item.coord = {
            q: q,
            r: r
        };
        item.placed = true;
        item.placedAtMs = performance.now();
        $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(q, r)] = item;
        $761f97bf09d51d3e$var$renderer.assignSpriteKeys(item);
        const px = (0, $3WWYP.hexToPixel)(q, r, $761f97bf09d51d3e$var$HEX_SIZE);
        $761f97bf09d51d3e$var$placementAnims.push({
            x: px.x,
            y: px.y,
            t: performance.now(),
            duration: 300
        });
        $761f97bf09d51d3e$var$renderer.upsertTile(item);
        // Star counting for matching sides
        let totalStars = 0;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(q, r, s);
            const neighbor = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
            if (!neighbor) continue;
            const mySideType = (0, $3WWYP.getEffectiveSide)(item.sides, item.rotation, s);
            const theirSideType = (0, $3WWYP.getEffectiveSide)(neighbor.sides, neighbor.rotation, (0, $3WWYP.oppositeSide)(s));
            if (mySideType === theirSideType) totalStars++;
        }
        if (totalStars > 0) {
            $761f97bf09d51d3e$var$score.stars += totalStars;
            $761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock += totalStars;
            $761f97bf09d51d3e$var$checkOverlayUnlock();
            $761f97bf09d51d3e$var$animations.push({
                x: px.x,
                y: px.y - 10,
                text: "\u2b50 +" + totalStars,
                startTime: performance.now(),
                duration: 1000,
                isScore: true
            });
        }
        $761f97bf09d51d3e$var$checkAbilityUnlocks();
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("tile_place", {
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            source: "storage",
            tile_sig: (0, $4ce0f3b8ba251f2f$export$8d7692cdcb9b805e)(item.sides),
            stars_bucket: $761f97bf09d51d3e$var$_starsBucket(totalStars)
        });
    }
    if ($761f97bf09d51d3e$var$isStorageUnlocked() && $761f97bf09d51d3e$var$storageCapacity < 1) $761f97bf09d51d3e$var$storageCapacity = 1;
    $761f97bf09d51d3e$var$rerollChainCount = 0;
    $761f97bf09d51d3e$var$storage[idx] = null;
    $761f97bf09d51d3e$var$selectedStorageIndex = -1;
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$renderHand();
    $761f97bf09d51d3e$var$renderStoragePanel();
    $761f97bf09d51d3e$var$saveGame();
    if (!item.isOverlay) $761f97bf09d51d3e$var$rebuildAdjacencyAt({
        q: q,
        r: r
    });
    if (item.isOverlay) {
        // Quest v2: overlay placed from storage
        const _sFam = (0, $eehpt.getOverlayFamily)(item.overlayKey);
        const _sEcon = (0, $eehpt.OVERLAY_ECONOMY)[_sFam];
        const _sMajor = $761f97bf09d51d3e$var$getMajorityType($761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(q, r)].sides);
        let _sAdj = 0;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(q, r, s);
            if ($761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)]?.overlaySpriteKey) _sAdj++;
        }
        $761f97bf09d51d3e$var$questManager.onOverlayPlaced({
            coord: {
                q: q,
                r: r
            },
            overlayFamily: _sFam,
            adjacentOverlays: _sAdj,
            onBonusTerrain: _sEcon ? _sEcon.bonusTerrains.includes(_sMajor) : false,
            isOcean: item.isOverlay && (0, $eehpt.isWaterTile)($761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(q, r)]?.baseSpriteKey || '')
        });
    } else {
        // Quest v2: tile placed from storage
        const _sT = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(q, r)];
        const _sType = $761f97bf09d51d3e$var$getMajorityType(_sT.sides);
        let _sNC = 0;
        const _sTT = new Set();
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(q, r, s);
            const nbT = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
            if (nbT && nbT.placed) {
                _sNC++;
                _sTT.add($761f97bf09d51d3e$var$getMajorityType(nbT.sides));
            }
        }
        $761f97bf09d51d3e$var$questManager.onTilePlaced({
            coord: {
                q: q,
                r: r
            },
            matchCount: 0,
            majorType: _sType,
            isOcean: _sT.baseSpriteKey ? (0, $eehpt.isWaterTile)(_sT.baseSpriteKey) : false,
            neighbourCount: _sNC,
            neighbourTerrainTypes: _sTT
        });
    }
    return true;
}
function $761f97bf09d51d3e$var$upgradeStorage() {
    if ($761f97bf09d51d3e$var$storageCapacity >= 3) return;
    if ($761f97bf09d51d3e$var$storageCapacity < 1) return;
    const cost = $761f97bf09d51d3e$var$getStorageUpgradeCost($761f97bf09d51d3e$var$storageCapacity);
    if (!$761f97bf09d51d3e$var$canAfford(cost)) return;
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).startSessionIfNeeded({
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        first_action: "storage_upgrade"
    });
    $761f97bf09d51d3e$var$payCost(cost);
    $761f97bf09d51d3e$var$storageCapacity++;
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("storage_upgrade", {
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        new_capacity: $761f97bf09d51d3e$var$storageCapacity
    });
    $761f97bf09d51d3e$var$renderStoragePanel();
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$saveGame();
}
// ===== DEMOLISH =====
function $761f97bf09d51d3e$var$toggleDemolish() {
    $761f97bf09d51d3e$var$demolishMode = !$761f97bf09d51d3e$var$demolishMode;
    $761f97bf09d51d3e$var$selectedStorageIndex = -1;
    const btn = document.getElementById("demolish-btn");
    btn.classList.toggle("active", $761f97bf09d51d3e$var$demolishMode);
    $761f97bf09d51d3e$var$canvas.classList.toggle("demolish-cursor", $761f97bf09d51d3e$var$demolishMode);
}
function $761f97bf09d51d3e$var$demolishAt(q, r) {
    const key = (0, $3WWYP.hexKey)(q, r);
    const tile = $761f97bf09d51d3e$var$tiles[key];
    if (!tile) return false;
    const cost = $761f97bf09d51d3e$var$getDemolishCost(tile);
    if ($761f97bf09d51d3e$var$score.stars < cost.stars) {
        // Show "can't afford" feedback
        $761f97bf09d51d3e$var$audio.playSfx("invalid_action");
        const px = (0, $3WWYP.hexToPixel)(q, r, $761f97bf09d51d3e$var$HEX_SIZE);
        $761f97bf09d51d3e$var$animations.push({
            x: px.x,
            y: px.y - 10,
            text: `Need ${$761f97bf09d51d3e$var$formatCost(cost)}`,
            startTime: performance.now(),
            duration: 2400,
            isError: true
        });
        return false;
    }
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).startSessionIfNeeded({
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        first_action: "demolish_execute"
    });
    const demolishType = tile.overlaySpriteKey ? "overlay" : "tile";
    $761f97bf09d51d3e$var$score.stars -= cost.stars;
    const px = (0, $3WWYP.hexToPixel)(q, r, $761f97bf09d51d3e$var$HEX_SIZE);
    if (tile.overlaySpriteKey) {
        // Remove overlay only
        tile.overlaySpriteKey = null;
        $761f97bf09d51d3e$var$renderer.upsertTile(tile);
    } else {
        // Remove entire tile
        const coord = {
            q: q,
            r: r
        };
        delete $761f97bf09d51d3e$var$tiles[key];
        $761f97bf09d51d3e$var$renderer.removeTile(coord);
    }
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("demolish_execute", {
        build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
        type: demolishType
    });
    $761f97bf09d51d3e$var$animations.push({
        x: px.x,
        y: px.y - 10,
        text: `-${$761f97bf09d51d3e$var$formatCost(cost)}`,
        startTime: performance.now(),
        duration: 1000,
        isScore: false
    });
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$saveGame();
    return true;
}
document.getElementById("demolish-btn").addEventListener("click", (e)=>{
    e.stopPropagation();
    $761f97bf09d51d3e$var$audio.playSfx("ui_click");
    $761f97bf09d51d3e$var$toggleDemolish();
});
// ===== PREVIEW PLACEMENT =====
function $761f97bf09d51d3e$var$previewPlacement(hex) {
    if (!hex || !$761f97bf09d51d3e$var$isPreviewUnlocked()) return null;
    const selected = $761f97bf09d51d3e$var$selectedStorageIndex >= 0 ? $761f97bf09d51d3e$var$storage[$761f97bf09d51d3e$var$selectedStorageIndex] : $761f97bf09d51d3e$var$hand[$761f97bf09d51d3e$var$selectedHandIndex];
    if (!selected) return null;
    if (selected.isOverlay) {
        const key = (0, $3WWYP.hexKey)(hex.q, hex.r);
        const tile = $761f97bf09d51d3e$var$tiles[key];
        if (!tile || !tile.placed || tile.overlaySpriteKey) return null;
        const tileIsWater = tile.baseSpriteKey ? (0, $eehpt.isWaterTile)(tile.baseSpriteKey) : false;
        const overlayIsWater = (0, $eehpt.isWaterOverlay)(selected.overlayKey);
        if (tileIsWater !== overlayIsWater) return null;
        const majorType = $761f97bf09d51d3e$var$getMajorityType(tile.sides);
        let adjacentOverlays = 0;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(hex.q, hex.r, s);
            const neighbor = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
            if (neighbor && neighbor.overlaySpriteKey) adjacentOverlays++;
        }
        return (0, $eehpt.computeOverlayPlacementReward)(selected.overlayKey, majorType, adjacentOverlays);
    } else {
        // Tile placement preview: count matching sides for stars only
        const valid = $761f97bf09d51d3e$var$getValidPlacements();
        if (!valid.has((0, $3WWYP.hexKey)(hex.q, hex.r))) return null;
        let totalStars = 0;
        for(let s = 0; s < 6; s++){
            const nb = (0, $3WWYP.getNeighbor)(hex.q, hex.r, s);
            const neighbor = $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(nb.q, nb.r)];
            if (!neighbor) continue;
            const mySideType = (0, $3WWYP.getEffectiveSide)(selected.sides, selected.rotation, s);
            const theirSideType = (0, $3WWYP.getEffectiveSide)(neighbor.sides, neighbor.rotation, (0, $3WWYP.oppositeSide)(s));
            if (mySideType === theirSideType) totalStars++;
        }
        if (totalStars === 0) return null;
        return {
            stars: totalStars,
            resources: {}
        };
    }
}
// ===== ADJACENCY TRANSITION HELPERS =====
function $761f97bf09d51d3e$var$rebuildAdjacencyAt(coord) {
    (0, $b5Oyo.rebuildRenderMetaAround)(coord, $761f97bf09d51d3e$var$tiles, $761f97bf09d51d3e$var$spriteIndex?.tileTransitionKeys ?? null);
}
// ===== SYNC HELPERS =====
function $761f97bf09d51d3e$var$syncRendererTiles() {
    const tileMap = new Map();
    for (const [key, tile] of Object.entries($761f97bf09d51d3e$var$tiles))tileMap.set(key, tile);
    $761f97bf09d51d3e$var$renderer.setTiles(tileMap);
}
function $761f97bf09d51d3e$var$syncRendererCamera() {
    $761f97bf09d51d3e$var$renderer.setCamera($761f97bf09d51d3e$var$camera);
}
function $761f97bf09d51d3e$var$syncRendererState() {
    $761f97bf09d51d3e$var$syncRendererTiles();
    $761f97bf09d51d3e$var$syncRendererCamera();
    $761f97bf09d51d3e$var$renderer.validPlacements = $761f97bf09d51d3e$var$getValidPlacements();
}
// ===== CAMERA HELPERS =====
function $761f97bf09d51d3e$var$worldToScreen(wx, wy) {
    return {
        x: (wx - $761f97bf09d51d3e$var$camera.x) * $761f97bf09d51d3e$var$camera.zoom + $761f97bf09d51d3e$var$canvas.width / 2,
        y: (wy - $761f97bf09d51d3e$var$camera.y) * $761f97bf09d51d3e$var$camera.zoom + $761f97bf09d51d3e$var$canvas.height / 2
    };
}
// ===== ANIMATION =====
function $761f97bf09d51d3e$var$easeOutBack(t) {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
}
// ===== RENDER =====
function $761f97bf09d51d3e$var$render(now) {
    $761f97bf09d51d3e$var$syncRendererCamera();
    // Update ghost tile and overlay ghost
    if ($761f97bf09d51d3e$var$demolishMode) {
        $761f97bf09d51d3e$var$renderer.ghostTile = null;
        $761f97bf09d51d3e$var$renderer.ghostOverlayKey = null;
    } else if ($761f97bf09d51d3e$var$selectedStorageIndex >= 0 && $761f97bf09d51d3e$var$storage[$761f97bf09d51d3e$var$selectedStorageIndex]) {
        const stored = $761f97bf09d51d3e$var$storage[$761f97bf09d51d3e$var$selectedStorageIndex];
        if (stored.isOverlay) {
            $761f97bf09d51d3e$var$renderer.ghostTile = null;
            $761f97bf09d51d3e$var$renderer.ghostOverlayKey = stored.overlayKey;
        } else {
            $761f97bf09d51d3e$var$renderer.ghostTile = stored;
            $761f97bf09d51d3e$var$renderer.ghostOverlayKey = null;
        }
    } else {
        const selected = $761f97bf09d51d3e$var$hand[$761f97bf09d51d3e$var$selectedHandIndex];
        if (selected && !selected.isOverlay) {
            $761f97bf09d51d3e$var$renderer.ghostTile = selected;
            $761f97bf09d51d3e$var$renderer.ghostOverlayKey = null;
        } else {
            $761f97bf09d51d3e$var$renderer.ghostTile = null;
            $761f97bf09d51d3e$var$renderer.ghostOverlayKey = selected && selected.isOverlay ? selected.overlayKey : null;
        }
    }
    $761f97bf09d51d3e$var$renderer.hoveredHex = $761f97bf09d51d3e$var$hoveredHex;
    $761f97bf09d51d3e$var$renderer.validPlacements = $761f97bf09d51d3e$var$getValidPlacements();
    // Cloud + shadow pipeline
    $761f97bf09d51d3e$var$zoomTracker.update($761f97bf09d51d3e$var$camera.zoom);
    const dt = now - $761f97bf09d51d3e$var$_lastFrameTime;
    $761f97bf09d51d3e$var$_lastFrameTime = now;
    // Update weather state before clouds (reads biome to drive cloud density/precip)
    const biomeResult = (0, $cd18dbf5d161796c$export$bc96b274c408949e)({
        cameraX: $761f97bf09d51d3e$var$camera.x,
        cameraY: $761f97bf09d51d3e$var$camera.y,
        zoom: $761f97bf09d51d3e$var$camera.zoom
    }, $761f97bf09d51d3e$var$getBiomeResolveDeps());
    $761f97bf09d51d3e$var$weatherState.update(dt, now, biomeResult);
    $761f97bf09d51d3e$var$cloudSystem.update(dt, $761f97bf09d51d3e$var$camera, $761f97bf09d51d3e$var$canvas.width, $761f97bf09d51d3e$var$canvas.height);
    $761f97bf09d51d3e$var$cloudShadowRenderer.render($761f97bf09d51d3e$var$cloudSystem, $761f97bf09d51d3e$var$camera, $761f97bf09d51d3e$var$canvas.width, $761f97bf09d51d3e$var$canvas.height, now);
    $761f97bf09d51d3e$var$renderer.update(now);
    $761f97bf09d51d3e$var$renderer.render(now);
    // Render clouds on dedicated canvas (above game, below UI) — no masking, clouds float freely
    $761f97bf09d51d3e$var$cloudRenderer.render($761f97bf09d51d3e$var$cloudsCtx, $761f97bf09d51d3e$var$cloudSystem, $761f97bf09d51d3e$var$camera, $761f97bf09d51d3e$var$canvas.width, $761f97bf09d51d3e$var$canvas.height, now, $761f97bf09d51d3e$var$weatherState);
    // Time-of-day post-processing overlay
    if ($761f97bf09d51d3e$var$worldClock.enabled) {
        const phase = $761f97bf09d51d3e$var$worldClock.getPhase01(now);
        const preset = $761f97bf09d51d3e$var$worldClock.getPreset(phase);
        $761f97bf09d51d3e$var$postFx.render($761f97bf09d51d3e$var$postfxCtx, $761f97bf09d51d3e$var$canvas.width, $761f97bf09d51d3e$var$canvas.height, preset, $761f97bf09d51d3e$var$worldClock.strength);
    } else $761f97bf09d51d3e$var$postfxCtx.clearRect(0, 0, $761f97bf09d51d3e$var$canvas.width, $761f97bf09d51d3e$var$canvas.height);
    $761f97bf09d51d3e$var$updateClockDisplay(now);
    // Precipitation overlay (after PostFx since PostFx clears canvas)
    const dtSec = Math.min(dt / 1000, 0.1);
    $761f97bf09d51d3e$var$precipRenderer.render($761f97bf09d51d3e$var$postfxCtx, $761f97bf09d51d3e$var$canvas.width, $761f97bf09d51d3e$var$canvas.height, dtSec, $761f97bf09d51d3e$var$weatherState, $761f97bf09d51d3e$var$cloudSystem, $761f97bf09d51d3e$var$camera);
    // Draw placement scale animations on top
    const sz = $761f97bf09d51d3e$var$HEX_SIZE * $761f97bf09d51d3e$var$camera.zoom;
    for(let i = $761f97bf09d51d3e$var$placementAnims.length - 1; i >= 0; i--){
        const anim = $761f97bf09d51d3e$var$placementAnims[i];
        const elapsed = now - anim.t;
        const prog = Math.min(1, elapsed / anim.duration);
        if (prog >= 1) {
            $761f97bf09d51d3e$var$placementAnims.splice(i, 1);
            continue;
        }
        const scale = 0.5 + 0.5 * $761f97bf09d51d3e$var$easeOutBack(prog);
        const alpha = prog;
        const sp = $761f97bf09d51d3e$var$worldToScreen(anim.x, anim.y);
        for (const [, t] of Object.entries($761f97bf09d51d3e$var$tiles)){
            const wp = (0, $3WWYP.hexToPixel)(t.coord.q, t.coord.r, $761f97bf09d51d3e$var$HEX_SIZE);
            if (Math.abs(wp.x - anim.x) < 1 && Math.abs(wp.y - anim.y) < 1) {
                $761f97bf09d51d3e$var$ctx.save();
                $761f97bf09d51d3e$var$ctx.globalAlpha = alpha;
                if ($761f97bf09d51d3e$var$spriteAtlas && t.baseSpriteKey) {
                    const s = sz * scale;
                    const drawScale = 2 * s / 30;
                    const dx = sp.x - 15 * drawScale;
                    const dy = sp.y - 15 * drawScale;
                    $761f97bf09d51d3e$var$ctx.translate(dx, dy);
                    $761f97bf09d51d3e$var$ctx.scale(drawScale, drawScale);
                    $761f97bf09d51d3e$var$spriteAtlas.draw($761f97bf09d51d3e$var$ctx, t.baseSpriteKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
                    if (t.transitionSpriteKey && $761f97bf09d51d3e$var$spriteAtlas.has(t.transitionSpriteKey)) $761f97bf09d51d3e$var$spriteAtlas.draw($761f97bf09d51d3e$var$ctx, t.transitionSpriteKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
                    if (t.overlaySpriteKey && $761f97bf09d51d3e$var$spriteAtlas.has(t.overlaySpriteKey)) $761f97bf09d51d3e$var$spriteAtlas.draw($761f97bf09d51d3e$var$ctx, t.overlaySpriteKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
                } else (0, $jD2dp.drawBlueprintTile)($761f97bf09d51d3e$var$ctx, t, sp.x, sp.y, sz * scale, alpha);
                $761f97bf09d51d3e$var$ctx.restore();
                break;
            }
        }
    }
    // Draw floating animations (score/resource popups)
    for(let i = $761f97bf09d51d3e$var$animations.length - 1; i >= 0; i--){
        const a = $761f97bf09d51d3e$var$animations[i];
        const elapsed = now - a.startTime;
        if (elapsed < 0) continue;
        const prog = elapsed / a.duration;
        if (prog > 1) {
            $761f97bf09d51d3e$var$animations.splice(i, 1);
            continue;
        }
        const sp = $761f97bf09d51d3e$var$worldToScreen(a.x, a.y);
        const offsetY = -40 * prog;
        if (a.isError) {
            // Hold full opacity for first 40% of duration, then fade out
            const fadeStart = 0.4;
            $761f97bf09d51d3e$var$ctx.globalAlpha = prog < fadeStart ? 1 : 1 - (prog - fadeStart) / (1 - fadeStart);
            $761f97bf09d51d3e$var$ctx.font = "14px sans-serif";
            $761f97bf09d51d3e$var$ctx.textAlign = "center";
            const tm = $761f97bf09d51d3e$var$ctx.measureText(a.text);
            const px = 8, py = 4;
            const bx = sp.x - tm.width / 2 - px;
            const by = sp.y + offsetY - 12 - py;
            const bw = tm.width + px * 2;
            const bh = 16 + py * 2;
            $761f97bf09d51d3e$var$ctx.fillStyle = "rgba(0, 0, 0, 0.55)";
            $761f97bf09d51d3e$var$ctx.beginPath();
            $761f97bf09d51d3e$var$ctx.roundRect(bx, by, bw, bh, bh / 2);
            $761f97bf09d51d3e$var$ctx.fill();
            $761f97bf09d51d3e$var$ctx.fillStyle = "#ff5555";
        } else {
            $761f97bf09d51d3e$var$ctx.globalAlpha = 1 - prog;
            $761f97bf09d51d3e$var$ctx.font = a.isScore ? "bold 18px sans-serif" : "20px sans-serif";
            $761f97bf09d51d3e$var$ctx.textAlign = "center";
            $761f97bf09d51d3e$var$ctx.fillStyle = a.isScore ? "#ffd700" : "#fff";
        }
        $761f97bf09d51d3e$var$ctx.fillText(a.text, sp.x, sp.y + offsetY);
        $761f97bf09d51d3e$var$ctx.globalAlpha = 1;
    }
    // Preview tooltip
    $761f97bf09d51d3e$var$updatePreviewTooltip();
    requestAnimationFrame($761f97bf09d51d3e$var$render);
}
// ===== PREVIEW TOOLTIP =====
function $761f97bf09d51d3e$var$updatePreviewTooltip() {
    const tooltip = document.getElementById("preview-tooltip");
    if (!$761f97bf09d51d3e$var$hoveredHex || !$761f97bf09d51d3e$var$isPreviewUnlocked() || $761f97bf09d51d3e$var$demolishMode) {
        tooltip.style.display = "none";
        return;
    }
    const preview = $761f97bf09d51d3e$var$previewPlacement($761f97bf09d51d3e$var$hoveredHex);
    if (!preview) {
        tooltip.style.display = "none";
        return;
    }
    let text = `\u2b50+${preview.stars}`;
    for (const [resType, amount] of Object.entries(preview.resources))if (amount > 0) text += ` ${(0, $8pKpp.RESOURCE_EMOJI)[resType]}+${amount}`;
    const px = (0, $3WWYP.hexToPixel)($761f97bf09d51d3e$var$hoveredHex.q, $761f97bf09d51d3e$var$hoveredHex.r, $761f97bf09d51d3e$var$HEX_SIZE);
    const sp = $761f97bf09d51d3e$var$worldToScreen(px.x, px.y);
    tooltip.textContent = text;
    tooltip.style.display = "block";
    tooltip.style.left = sp.x + 20 + "px";
    tooltip.style.top = sp.y - 30 + "px";
}
// ===== WORLD CLOCK DISPLAY =====
const $761f97bf09d51d3e$var$_clockEl = document.getElementById("world-clock-display");
let $761f97bf09d51d3e$var$_lastClockText = "";
function $761f97bf09d51d3e$var$updateClockDisplay(now) {
    if (!$761f97bf09d51d3e$var$worldClock.enabled) {
        if ($761f97bf09d51d3e$var$_clockEl.style.display !== "none") $761f97bf09d51d3e$var$_clockEl.style.display = "none";
        return;
    }
    if ($761f97bf09d51d3e$var$_clockEl.style.display === "none") $761f97bf09d51d3e$var$_clockEl.style.display = "";
    const phase = $761f97bf09d51d3e$var$worldClock.getPhase01(now);
    // Map phase 0..1 to 24-hour clock (phase 0 = midnight)
    const totalMinutes = Math.floor(phase * 1440);
    const hours = Math.floor(totalMinutes / 60) % 24;
    const minutes = totalMinutes % 60;
    const h12 = hours % 12 || 12;
    const ampm = hours < 12 ? "AM" : "PM";
    const icon = hours >= 6 && hours < 18 ? "\u2600\uFE0F" : "\uD83C\uDF19";
    const text = `${icon} ${h12}:${String(minutes).padStart(2, "0")} ${ampm}`;
    if (text !== $761f97bf09d51d3e$var$_lastClockText) {
        $761f97bf09d51d3e$var$_clockEl.textContent = text;
        $761f97bf09d51d3e$var$_lastClockText = text;
    }
}
// ===== HUD =====
function $761f97bf09d51d3e$var$updateHUD() {
    const resDiv = document.getElementById("resources");
    resDiv.innerHTML = "";
    for (const res of (0, $8pKpp.RESOURCE_TYPES)){
        const item = document.createElement("div");
        item.className = "resource-item";
        item.innerHTML = `<span class="icon">${(0, $8pKpp.RESOURCE_EMOJI)[res]}</span><span class="count">${$761f97bf09d51d3e$var$resources[res] || 0}</span>`;
        resDiv.appendChild(item);
    }
    document.getElementById("score-display").textContent = `\u2b50 ${$761f97bf09d51d3e$var$score.stars}`;
}
// ===== HAND RENDERING =====
function $761f97bf09d51d3e$var$drawTileOnMiniCanvas(tctx, tile, cx, cy, size) {
    tctx.clearRect(0, 0, 80, 80);
    if ($761f97bf09d51d3e$var$spriteAtlas && tile.baseSpriteKey) {
        const scale = 2 * size / 30;
        const dx = cx - 15 * scale;
        const dy = cy - 15 * scale;
        tctx.save();
        tctx.translate(dx, dy);
        tctx.scale(scale, scale);
        $761f97bf09d51d3e$var$spriteAtlas.draw(tctx, tile.baseSpriteKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
        if (tile.transitionSpriteKey && $761f97bf09d51d3e$var$spriteAtlas.has(tile.transitionSpriteKey)) $761f97bf09d51d3e$var$spriteAtlas.draw(tctx, tile.transitionSpriteKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
        tctx.restore();
    } else (0, $jD2dp.drawBlueprintTile)(tctx, tile, cx, cy, size, 1, false, false);
}
function $761f97bf09d51d3e$var$drawOverlayOnMiniCanvas(tctx, overlayKey) {
    tctx.clearRect(0, 0, 80, 80);
    if ($761f97bf09d51d3e$var$spriteAtlas && $761f97bf09d51d3e$var$spriteAtlas.has(overlayKey)) {
        const scale = 80 / 30;
        tctx.save();
        tctx.scale(scale, scale);
        $761f97bf09d51d3e$var$spriteAtlas.draw(tctx, overlayKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
        tctx.restore();
    }
}
function $761f97bf09d51d3e$var$renderHand() {
    const handDiv = document.getElementById("hand");
    handDiv.innerHTML = "";
    $761f97bf09d51d3e$var$hand.forEach((item, i)=>{
        const slot = document.createElement("div");
        slot.className = "hand-slot";
        const wrapper = document.createElement("div");
        let cls = "hand-tile";
        if (item.isOverlay) cls += " overlay-item";
        if (i === $761f97bf09d51d3e$var$selectedHandIndex && $761f97bf09d51d3e$var$selectedStorageIndex < 0) cls += " selected";
        wrapper.className = cls;
        const c = document.createElement("canvas");
        c.width = 80;
        c.height = 80;
        wrapper.appendChild(c);
        const tctx = c.getContext("2d");
        if (item.isOverlay) $761f97bf09d51d3e$var$drawOverlayOnMiniCanvas(tctx, item.overlayKey);
        else $761f97bf09d51d3e$var$drawTileOnMiniCanvas(tctx, item, 40, 40, 32);
        wrapper.addEventListener("click", (e)=>{
            e.stopPropagation();
            $761f97bf09d51d3e$var$audio.playSfx("ui_click");
            $761f97bf09d51d3e$var$selectedHandIndex = i;
            $761f97bf09d51d3e$var$selectedStorageIndex = -1;
            $761f97bf09d51d3e$var$demolishMode = false;
            document.getElementById("demolish-btn").classList.remove("active");
            $761f97bf09d51d3e$var$canvas.classList.remove("demolish-cursor");
            $761f97bf09d51d3e$var$renderHand();
            $761f97bf09d51d3e$var$renderStoragePanel();
        });
        slot.appendChild(wrapper);
        // Ability buttons below tile
        const btns = document.createElement("div");
        btns.className = "hand-slot-buttons";
        // Reroll button
        const rerollBtn = document.createElement("button");
        rerollBtn.textContent = "\uD83D\uDD04"; // 🔄
        rerollBtn.title = $761f97bf09d51d3e$var$isRerollUnlocked() ? `Reroll (${$761f97bf09d51d3e$var$formatCost($761f97bf09d51d3e$var$getRerollCost($761f97bf09d51d3e$var$rerollChainCount))})` : "Unlock at 50\u2b50";
        if (!$761f97bf09d51d3e$var$isRerollUnlocked()) {
            rerollBtn.classList.add("locked");
            rerollBtn.disabled = true;
        } else if (!$761f97bf09d51d3e$var$canAfford($761f97bf09d51d3e$var$getRerollCost($761f97bf09d51d3e$var$rerollChainCount))) rerollBtn.disabled = true;
        rerollBtn.addEventListener("click", (e)=>{
            e.stopPropagation();
            $761f97bf09d51d3e$var$audio.playSfx("ui_click");
            $761f97bf09d51d3e$var$rerollSlot(i);
        });
        btns.appendChild(rerollBtn);
        // Store button
        const storeBtn = document.createElement("button");
        storeBtn.textContent = "\uD83D\uDCE6"; // 📦
        const storageFull = (()=>{
            for(let s = 0; s < $761f97bf09d51d3e$var$storageCapacity; s++){
                if ($761f97bf09d51d3e$var$storage[s] === null) return false;
            }
            return true;
        })();
        storeBtn.title = $761f97bf09d51d3e$var$isStorageUnlocked() ? storageFull ? "Storage full" : "Store tile" : "Unlock at 100\u2b50";
        if (!$761f97bf09d51d3e$var$isStorageUnlocked()) {
            storeBtn.classList.add("locked");
            storeBtn.disabled = true;
        } else if (storageFull) storeBtn.disabled = true;
        storeBtn.addEventListener("click", (e)=>{
            e.stopPropagation();
            $761f97bf09d51d3e$var$audio.playSfx("ui_click");
            $761f97bf09d51d3e$var$storeFromHand(i);
        });
        btns.appendChild(storeBtn);
        slot.appendChild(btns);
        handDiv.appendChild(slot);
    });
}
// ===== STORAGE PANEL =====
function $761f97bf09d51d3e$var$renderStoragePanel() {
    const panel = document.getElementById("storage-panel");
    panel.innerHTML = "";
    if (!$761f97bf09d51d3e$var$isStorageUnlocked()) {
        panel.classList.remove("visible");
        return;
    }
    panel.classList.add("visible");
    const label = document.createElement("span");
    label.className = "storage-label";
    const occupied = $761f97bf09d51d3e$var$storage.filter((s, i)=>i < $761f97bf09d51d3e$var$storageCapacity && s !== null).length;
    label.textContent = `Storage (${occupied}/${$761f97bf09d51d3e$var$storageCapacity})`;
    panel.appendChild(label);
    for(let idx = 0; idx < 3; idx++){
        const slotDiv = document.createElement("div");
        slotDiv.className = "storage-slot";
        const c = document.createElement("canvas");
        c.width = 60;
        c.height = 60;
        slotDiv.appendChild(c);
        if (idx >= $761f97bf09d51d3e$var$storageCapacity) slotDiv.classList.add("locked-slot");
        else if ($761f97bf09d51d3e$var$storage[idx] === null) slotDiv.classList.add("empty");
        else {
            // Draw stored item
            const tctx = c.getContext("2d");
            const item = $761f97bf09d51d3e$var$storage[idx];
            if (item.isOverlay) {
                tctx.clearRect(0, 0, 60, 60);
                if ($761f97bf09d51d3e$var$spriteAtlas && $761f97bf09d51d3e$var$spriteAtlas.has(item.overlayKey)) {
                    const scale = 2;
                    tctx.save();
                    tctx.scale(scale, scale);
                    $761f97bf09d51d3e$var$spriteAtlas.draw(tctx, item.overlayKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
                    tctx.restore();
                }
            } else {
                tctx.clearRect(0, 0, 60, 60);
                if ($761f97bf09d51d3e$var$spriteAtlas && item.baseSpriteKey) {
                    const size = 24;
                    const scale = 2 * size / 30;
                    const cx = 30, cy = 30;
                    const dx = cx - 15 * scale;
                    const dy = cy - 15 * scale;
                    tctx.save();
                    tctx.translate(dx, dy);
                    tctx.scale(scale, scale);
                    $761f97bf09d51d3e$var$spriteAtlas.draw(tctx, item.baseSpriteKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
                    if (item.transitionSpriteKey && $761f97bf09d51d3e$var$spriteAtlas.has(item.transitionSpriteKey)) $761f97bf09d51d3e$var$spriteAtlas.draw(tctx, item.transitionSpriteKey, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
                    tctx.restore();
                } else (0, $jD2dp.drawBlueprintTile)(tctx, item, 30, 30, 24, 1, false, false);
            }
            if (idx === $761f97bf09d51d3e$var$selectedStorageIndex) slotDiv.classList.add("selected-storage");
            slotDiv.addEventListener("click", (e)=>{
                e.stopPropagation();
                if ($761f97bf09d51d3e$var$selectedStorageIndex === idx) $761f97bf09d51d3e$var$selectedStorageIndex = -1;
                else {
                    $761f97bf09d51d3e$var$selectedStorageIndex = idx;
                    $761f97bf09d51d3e$var$demolishMode = false;
                    document.getElementById("demolish-btn").classList.remove("active");
                    $761f97bf09d51d3e$var$canvas.classList.remove("demolish-cursor");
                }
                $761f97bf09d51d3e$var$renderHand();
                $761f97bf09d51d3e$var$renderStoragePanel();
            });
        }
        panel.appendChild(slotDiv);
    }
    // Upgrade button
    if ($761f97bf09d51d3e$var$storageCapacity < 3) {
        const upgradeBtn = document.createElement("button");
        upgradeBtn.id = "storage-upgrade-btn";
        const cost = $761f97bf09d51d3e$var$getStorageUpgradeCost($761f97bf09d51d3e$var$storageCapacity);
        upgradeBtn.textContent = `Upgrade (${$761f97bf09d51d3e$var$formatCost(cost)})`;
        if (!$761f97bf09d51d3e$var$canAfford(cost)) upgradeBtn.disabled = true;
        upgradeBtn.addEventListener("click", (e)=>{
            e.stopPropagation();
            $761f97bf09d51d3e$var$upgradeStorage();
        });
        panel.appendChild(upgradeBtn);
    }
}
// ===== INPUT =====
let $761f97bf09d51d3e$var$isDragging = false;
let $761f97bf09d51d3e$var$dragStart = {
    x: 0,
    y: 0
};
let $761f97bf09d51d3e$var$dragCameraStart = {
    x: 0,
    y: 0
};
let $761f97bf09d51d3e$var$hoveredHex = null;
let $761f97bf09d51d3e$var$hasDragged = false;
let $761f97bf09d51d3e$var$pointerOverUI = false;
// Track when pointer is over UI panels to prevent grid interaction
for (const uiId of [
    "hand",
    "storage-panel"
]){
    const el = document.getElementById(uiId);
    el.addEventListener("mouseenter", ()=>{
        $761f97bf09d51d3e$var$pointerOverUI = true;
        $761f97bf09d51d3e$var$hoveredHex = null;
    });
    el.addEventListener("mouseleave", ()=>{
        $761f97bf09d51d3e$var$pointerOverUI = false;
    });
}
$761f97bf09d51d3e$var$canvas.addEventListener("mousedown", (e)=>{
    if (e.button === 0) {
        $761f97bf09d51d3e$var$isDragging = true;
        $761f97bf09d51d3e$var$hasDragged = false;
        $761f97bf09d51d3e$var$dragStart = {
            x: e.clientX,
            y: e.clientY
        };
        $761f97bf09d51d3e$var$dragCameraStart = {
            x: $761f97bf09d51d3e$var$camera.x,
            y: $761f97bf09d51d3e$var$camera.y
        };
        $761f97bf09d51d3e$var$canvas.classList.add("grabbing");
    }
});
window.addEventListener("mousemove", (e)=>{
    if ($761f97bf09d51d3e$var$isDragging) {
        const dx = e.clientX - $761f97bf09d51d3e$var$dragStart.x;
        const dy = e.clientY - $761f97bf09d51d3e$var$dragStart.y;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) $761f97bf09d51d3e$var$hasDragged = true;
        $761f97bf09d51d3e$var$camera.x = $761f97bf09d51d3e$var$dragCameraStart.x - dx / $761f97bf09d51d3e$var$camera.zoom;
        $761f97bf09d51d3e$var$camera.y = $761f97bf09d51d3e$var$dragCameraStart.y - dy / $761f97bf09d51d3e$var$camera.zoom;
        $761f97bf09d51d3e$var$resolveAndUpdateAmbience(false);
    }
    if (!$761f97bf09d51d3e$var$pointerOverUI) $761f97bf09d51d3e$var$hoveredHex = $761f97bf09d51d3e$var$renderer.screenToAxial(e.clientX, e.clientY);
});
window.addEventListener("mouseup", (e)=>{
    if (e.button === 0) {
        if (!$761f97bf09d51d3e$var$hasDragged && $761f97bf09d51d3e$var$hoveredHex && !$761f97bf09d51d3e$var$pointerOverUI) {
            if ($761f97bf09d51d3e$var$demolishMode) $761f97bf09d51d3e$var$demolishAt($761f97bf09d51d3e$var$hoveredHex.q, $761f97bf09d51d3e$var$hoveredHex.r);
            else if ($761f97bf09d51d3e$var$selectedStorageIndex >= 0) $761f97bf09d51d3e$var$placeFromStorage($761f97bf09d51d3e$var$selectedStorageIndex, $761f97bf09d51d3e$var$hoveredHex.q, $761f97bf09d51d3e$var$hoveredHex.r);
            else {
                const selectedItem = $761f97bf09d51d3e$var$hand[$761f97bf09d51d3e$var$selectedHandIndex];
                if (selectedItem && selectedItem.isOverlay) $761f97bf09d51d3e$var$placeOverlayFromHand($761f97bf09d51d3e$var$hoveredHex.q, $761f97bf09d51d3e$var$hoveredHex.r);
                else {
                    const valid = $761f97bf09d51d3e$var$getValidPlacements();
                    const hk = (0, $3WWYP.hexKey)($761f97bf09d51d3e$var$hoveredHex.q, $761f97bf09d51d3e$var$hoveredHex.r);
                    if (valid.has(hk)) $761f97bf09d51d3e$var$placeTile($761f97bf09d51d3e$var$hoveredHex.q, $761f97bf09d51d3e$var$hoveredHex.r);
                    else if ($761f97bf09d51d3e$var$tiles[hk]) $761f97bf09d51d3e$var$audio.playSfx("invalid_action");
                }
            }
        }
        if ($761f97bf09d51d3e$var$hasDragged) $761f97bf09d51d3e$var$resolveAndUpdateAmbience(true);
        $761f97bf09d51d3e$var$isDragging = false;
        $761f97bf09d51d3e$var$canvas.classList.remove("grabbing");
    }
});
$761f97bf09d51d3e$var$canvas.addEventListener("contextmenu", (e)=>{
    e.preventDefault();
    $761f97bf09d51d3e$var$rotateTile(1);
});
$761f97bf09d51d3e$var$canvas.addEventListener("wheel", (e)=>{
    e.preventDefault();
    const zoomFactor = e.deltaY > 0 ? 0.9 : 1.1;
    $761f97bf09d51d3e$var$camera.zoom = Math.max(0.3, Math.min(3, $761f97bf09d51d3e$var$camera.zoom * zoomFactor));
    $761f97bf09d51d3e$var$resolveAndUpdateAmbience(false);
}, {
    passive: false
});
// Keyboard
const $761f97bf09d51d3e$var$keysDown = new Set();
window.addEventListener("keydown", (e)=>{
    $761f97bf09d51d3e$var$keysDown.add(e.key.toLowerCase());
    if (e.key === "q" || e.key === "Q") $761f97bf09d51d3e$var$rotateTile(-1);
    if (e.key === "e" || e.key === "E") $761f97bf09d51d3e$var$rotateTile(1);
    if (e.key === "r" || e.key === "R") $761f97bf09d51d3e$var$showResetModal();
    if (e.key === "1") {
        $761f97bf09d51d3e$var$selectedHandIndex = 0;
        $761f97bf09d51d3e$var$selectedStorageIndex = -1;
        $761f97bf09d51d3e$var$renderHand();
        $761f97bf09d51d3e$var$renderStoragePanel();
    }
    if (e.key === "2" && $761f97bf09d51d3e$var$hand.length > 1) {
        $761f97bf09d51d3e$var$selectedHandIndex = 1;
        $761f97bf09d51d3e$var$selectedStorageIndex = -1;
        $761f97bf09d51d3e$var$renderHand();
        $761f97bf09d51d3e$var$renderStoragePanel();
    }
    if (e.key === "3" && $761f97bf09d51d3e$var$hand.length > 2) {
        $761f97bf09d51d3e$var$selectedHandIndex = 2;
        $761f97bf09d51d3e$var$selectedStorageIndex = -1;
        $761f97bf09d51d3e$var$renderHand();
        $761f97bf09d51d3e$var$renderStoragePanel();
    }
    // Time-of-day debug shortcuts: [ rewind, ] fast-forward (10% of cycle each)
    if (e.key === "[") $761f97bf09d51d3e$var$worldClock.startMs += $761f97bf09d51d3e$var$worldClock.cycleMs * 0.0001;
    if (e.key === "]") $761f97bf09d51d3e$var$worldClock.startMs -= $761f97bf09d51d3e$var$worldClock.cycleMs * 0.0001;
    // Weather debug shortcuts: 5 = rain, 6 = snow, 7 = clear (back to normal)
    if (e.key === "5") $761f97bf09d51d3e$var$weatherState.forceMode('rain');
    if (e.key === "6") $761f97bf09d51d3e$var$weatherState.forceMode('snow');
    if (e.key === "7") $761f97bf09d51d3e$var$weatherState.forceMode(null);
    // Adjacency debug toggles (non-conflicting keys)
    if (e.key === "`") $761f97bf09d51d3e$var$renderer.debugFlags.hideAdjacency = !$761f97bf09d51d3e$var$renderer.debugFlags.hideAdjacency;
    if (e.key === "i" || e.key === "I") $761f97bf09d51d3e$var$renderer.debugFlags.hideInternal = !$761f97bf09d51d3e$var$renderer.debugFlags.hideInternal;
    if (e.key === "t" || e.key === "T") $761f97bf09d51d3e$var$renderer.debugFlags.showRuns = !$761f97bf09d51d3e$var$renderer.debugFlags.showRuns;
});
window.addEventListener("keyup", (e)=>$761f97bf09d51d3e$var$keysDown.delete(e.key.toLowerCase()));
function $761f97bf09d51d3e$var$updateKeyPan() {
    const speed = 5 / $761f97bf09d51d3e$var$camera.zoom;
    let moved = false;
    if ($761f97bf09d51d3e$var$keysDown.has("w") || $761f97bf09d51d3e$var$keysDown.has("arrowup")) {
        $761f97bf09d51d3e$var$camera.y -= speed;
        moved = true;
    }
    if ($761f97bf09d51d3e$var$keysDown.has("s") || $761f97bf09d51d3e$var$keysDown.has("arrowdown")) {
        $761f97bf09d51d3e$var$camera.y += speed;
        moved = true;
    }
    if ($761f97bf09d51d3e$var$keysDown.has("a") || $761f97bf09d51d3e$var$keysDown.has("arrowleft")) {
        $761f97bf09d51d3e$var$camera.x -= speed;
        moved = true;
    }
    if ($761f97bf09d51d3e$var$keysDown.has("d") || $761f97bf09d51d3e$var$keysDown.has("arrowright")) {
        $761f97bf09d51d3e$var$camera.x += speed;
        moved = true;
    }
    if (moved) $761f97bf09d51d3e$var$resolveAndUpdateAmbience(false);
    requestAnimationFrame($761f97bf09d51d3e$var$updateKeyPan);
}
$761f97bf09d51d3e$var$updateKeyPan();
function $761f97bf09d51d3e$var$rotateTile(dir) {
    const tile = $761f97bf09d51d3e$var$selectedStorageIndex >= 0 ? $761f97bf09d51d3e$var$storage[$761f97bf09d51d3e$var$selectedStorageIndex] : $761f97bf09d51d3e$var$hand[$761f97bf09d51d3e$var$selectedHandIndex];
    if (!tile || tile.isOverlay) return;
    tile.rotation = ((tile.rotation + dir) % 6 + 6) % 6;
    $761f97bf09d51d3e$var$renderer.assignSpriteKeys(tile);
    $761f97bf09d51d3e$var$renderHand();
    if ($761f97bf09d51d3e$var$selectedStorageIndex >= 0) $761f97bf09d51d3e$var$renderStoragePanel();
}
// ===== MENU =====
const $761f97bf09d51d3e$var$menuBtn = document.getElementById("menu-btn");
const $761f97bf09d51d3e$var$menuDropdown = document.getElementById("menu-dropdown");
$761f97bf09d51d3e$var$menuBtn.addEventListener("mousedown", (e)=>{
    e.stopPropagation();
});
$761f97bf09d51d3e$var$menuBtn.addEventListener("mouseup", (e)=>{
    e.stopPropagation();
    $761f97bf09d51d3e$var$audio.playSfx("ui_click");
    $761f97bf09d51d3e$var$menuDropdown.classList.toggle("visible");
});
$761f97bf09d51d3e$var$menuBtn.addEventListener("click", (e)=>{
    e.stopPropagation();
});
$761f97bf09d51d3e$var$menuDropdown.addEventListener("mousedown", (e)=>e.stopPropagation());
$761f97bf09d51d3e$var$menuDropdown.addEventListener("mouseup", (e)=>e.stopPropagation());
$761f97bf09d51d3e$var$menuDropdown.addEventListener("click", (e)=>e.stopPropagation());
document.addEventListener("mousedown", ()=>{
    $761f97bf09d51d3e$var$menuDropdown.classList.remove("visible");
});
// ===== AUDIO VOLUME CONTROLS =====
const $761f97bf09d51d3e$var$volMaster = document.getElementById("vol-master");
const $761f97bf09d51d3e$var$volMusic = document.getElementById("vol-music");
const $761f97bf09d51d3e$var$volSfx = document.getElementById("vol-sfx");
const $761f97bf09d51d3e$var$volAmbience = document.getElementById("vol-ambience");
const $761f97bf09d51d3e$var$ambienceToggle = document.getElementById("ambience-toggle");
const $761f97bf09d51d3e$var$muteToggle = document.getElementById("mute-toggle");
// Init slider positions from stored volumes
$761f97bf09d51d3e$var$volMaster.value = Math.round($761f97bf09d51d3e$var$audio.getVolume("master") * 100);
$761f97bf09d51d3e$var$volMusic.value = Math.round($761f97bf09d51d3e$var$audio.getVolume("music") * 100);
$761f97bf09d51d3e$var$volSfx.value = Math.round($761f97bf09d51d3e$var$audio.getVolume("sfx") * 100);
$761f97bf09d51d3e$var$volAmbience.value = Math.round($761f97bf09d51d3e$var$audio.getVolume("ambience") * 100);
$761f97bf09d51d3e$var$ambienceToggle.checked = $761f97bf09d51d3e$var$ambienceManager.enabled;
$761f97bf09d51d3e$var$muteToggle.checked = $761f97bf09d51d3e$var$audio.isMuted();
$761f97bf09d51d3e$var$volMaster.addEventListener("input", ()=>$761f97bf09d51d3e$var$audio.setVolume("master", $761f97bf09d51d3e$var$volMaster.value / 100));
$761f97bf09d51d3e$var$volMusic.addEventListener("input", ()=>$761f97bf09d51d3e$var$audio.setVolume("music", $761f97bf09d51d3e$var$volMusic.value / 100));
$761f97bf09d51d3e$var$volSfx.addEventListener("input", ()=>$761f97bf09d51d3e$var$audio.setVolume("sfx", $761f97bf09d51d3e$var$volSfx.value / 100));
$761f97bf09d51d3e$var$volAmbience.addEventListener("input", ()=>{
    $761f97bf09d51d3e$var$audio.setVolume("ambience", $761f97bf09d51d3e$var$volAmbience.value / 100);
    $761f97bf09d51d3e$var$ambienceManager.onSettingsChanged();
});
$761f97bf09d51d3e$var$ambienceToggle.addEventListener("change", ()=>{
    $761f97bf09d51d3e$var$ambienceManager.setEnabled($761f97bf09d51d3e$var$ambienceToggle.checked);
    if ($761f97bf09d51d3e$var$ambienceToggle.checked) $761f97bf09d51d3e$var$resolveAndUpdateAmbience(true);
});
const $761f97bf09d51d3e$var$weatherToggle = document.getElementById("weather-toggle");
$761f97bf09d51d3e$var$weatherToggle.checked = $761f97bf09d51d3e$var$weatherState.enabled;
$761f97bf09d51d3e$var$weatherToggle.addEventListener("change", ()=>{
    $761f97bf09d51d3e$var$weatherState.setEnabled($761f97bf09d51d3e$var$weatherToggle.checked);
});
$761f97bf09d51d3e$var$muteToggle.addEventListener("change", ()=>$761f97bf09d51d3e$var$audio.setMuted($761f97bf09d51d3e$var$muteToggle.checked));
function $761f97bf09d51d3e$var$showResetModal() {
    $761f97bf09d51d3e$var$menuDropdown.classList.remove("visible");
    document.getElementById("confirm-modal").classList.add("visible");
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_open");
}
document.getElementById("reset-btn").addEventListener("click", $761f97bf09d51d3e$var$showResetModal);
document.getElementById("confirm-yes").addEventListener("click", ()=>{
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_close");
    localStorage.removeItem("hexaworlds_save");
    $761f97bf09d51d3e$var$tiles = {};
    $761f97bf09d51d3e$var$initResources();
    $761f97bf09d51d3e$var$score = {
        stars: 0
    };
    $761f97bf09d51d3e$var$camera = {
        x: 0,
        y: 0,
        zoom: 1
    };
    $761f97bf09d51d3e$var$hand = [];
    $761f97bf09d51d3e$var$selectedHandIndex = 0;
    $761f97bf09d51d3e$var$tileIdCounter = 0;
    $761f97bf09d51d3e$var$animations = [];
    $761f97bf09d51d3e$var$placementAnims = [];
    $761f97bf09d51d3e$var$pendingUnlockNotifs = [];
    $761f97bf09d51d3e$var$overlayIdCounter = 0;
    $761f97bf09d51d3e$var$rerollChainCount = 0;
    $761f97bf09d51d3e$var$storageCapacity = 0;
    $761f97bf09d51d3e$var$storage = [
        null,
        null,
        null
    ];
    $761f97bf09d51d3e$var$demolishMode = false;
    $761f97bf09d51d3e$var$selectedStorageIndex = -1;
    document.getElementById("demolish-btn").classList.remove("active");
    $761f97bf09d51d3e$var$canvas.classList.remove("demolish-cursor");
    $761f97bf09d51d3e$var$_abilityUnlockTracked = {
        preview: false,
        reroll: false,
        storage: false
    };
    (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).sessionStarted = false;
    $761f97bf09d51d3e$var$initOverlayState();
    (0, $b5Oyo.clearAllRenderMeta)();
    $761f97bf09d51d3e$var$initGame();
    (0, $b5Oyo.buildAllRenderMeta)($761f97bf09d51d3e$var$tiles, $761f97bf09d51d3e$var$spriteIndex?.tileTransitionKeys ?? null);
    $761f97bf09d51d3e$var$questManager.reset();
    $761f97bf09d51d3e$var$questUI.refresh($761f97bf09d51d3e$var$questManager.state.active);
    document.getElementById("confirm-modal").classList.remove("visible");
});
document.getElementById("confirm-no").addEventListener("click", ()=>{
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_close");
    document.getElementById("confirm-modal").classList.remove("visible");
});
// ===== GALLERY =====
let $761f97bf09d51d3e$var$galleryRenderedCount = 0;
const $761f97bf09d51d3e$var$GALLERY_BATCH = 30;
function $761f97bf09d51d3e$var$openGallery() {
    $761f97bf09d51d3e$var$menuDropdown.classList.remove("visible");
    $761f97bf09d51d3e$var$galleryRenderedCount = 0;
    document.getElementById("gallery-scroll").innerHTML = "";
    document.getElementById("gallery-modal").classList.add("visible");
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_open");
    $761f97bf09d51d3e$var$renderGalleryBatch();
}
function $761f97bf09d51d3e$var$renderGalleryBatch() {
    if (!$761f97bf09d51d3e$var$spriteIndex) return;
    const allKeys = $761f97bf09d51d3e$var$spriteIndex.overlayKeysAll;
    const end = Math.min($761f97bf09d51d3e$var$galleryRenderedCount + $761f97bf09d51d3e$var$GALLERY_BATCH, allKeys.length);
    const container = document.getElementById("gallery-scroll");
    for(let i = $761f97bf09d51d3e$var$galleryRenderedCount; i < end; i++){
        const key = allKeys[i];
        const item = document.createElement("div");
        item.className = "gallery-item";
        if (!$761f97bf09d51d3e$var$overlayUnlocks.unlocked.includes(key)) item.classList.add("locked");
        const c = document.createElement("canvas");
        c.width = 72;
        c.height = 72;
        item.appendChild(c);
        const cctx = c.getContext("2d");
        if ($761f97bf09d51d3e$var$spriteAtlas && $761f97bf09d51d3e$var$spriteAtlas.has(key)) {
            const scale = 2.4;
            cctx.save();
            cctx.scale(scale, scale);
            $761f97bf09d51d3e$var$spriteAtlas.draw(cctx, key, 0, (0, $3oGCi.SPRITE_OFFSET_Y));
            cctx.restore();
        }
        container.appendChild(item);
    }
    $761f97bf09d51d3e$var$galleryRenderedCount = end;
}
document.getElementById("gallery-btn").addEventListener("click", $761f97bf09d51d3e$var$openGallery);
document.getElementById("gallery-close").addEventListener("click", ()=>{
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_close");
    document.getElementById("gallery-modal").classList.remove("visible");
});
document.getElementById("gallery-scroll").addEventListener("scroll", (e)=>{
    const el = e.target;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) $761f97bf09d51d3e$var$renderGalleryBatch();
});
// ===== FX GUIDE =====
document.getElementById("fx-guide-btn").addEventListener("click", ()=>{
    $761f97bf09d51d3e$var$menuDropdown.classList.remove("visible");
    document.getElementById("fx-guide-modal").classList.add("visible");
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_open");
});
document.getElementById("fx-guide-close").addEventListener("click", ()=>{
    $761f97bf09d51d3e$var$audio.playSfx("ui_popup_close");
    document.getElementById("fx-guide-modal").classList.remove("visible");
});
const $761f97bf09d51d3e$var$fxGuideModal = document.getElementById("fx-guide-modal");
$761f97bf09d51d3e$var$fxGuideModal.addEventListener("mousedown", (e)=>e.stopPropagation());
$761f97bf09d51d3e$var$fxGuideModal.addEventListener("mouseup", (e)=>e.stopPropagation());
$761f97bf09d51d3e$var$fxGuideModal.addEventListener("click", (e)=>e.stopPropagation());
// ===== SAVE/LOAD =====
function $761f97bf09d51d3e$var$saveGame() {
    const state = {
        tiles: Object.values($761f97bf09d51d3e$var$tiles),
        resources: $761f97bf09d51d3e$var$resources,
        score: $761f97bf09d51d3e$var$score,
        camera: $761f97bf09d51d3e$var$camera,
        hand: $761f97bf09d51d3e$var$hand,
        selectedHandIndex: $761f97bf09d51d3e$var$selectedHandIndex,
        tileIdCounter: $761f97bf09d51d3e$var$tileIdCounter,
        overlayUnlocks: $761f97bf09d51d3e$var$overlayUnlocks,
        rerollChainCount: $761f97bf09d51d3e$var$rerollChainCount,
        storageCapacity: $761f97bf09d51d3e$var$storageCapacity,
        storage: $761f97bf09d51d3e$var$storage
    };
    localStorage.setItem("hexaworlds_save", JSON.stringify(state));
}
function $761f97bf09d51d3e$var$loadGame() {
    const data = localStorage.getItem("hexaworlds_save");
    if (!data) return false;
    try {
        const state = JSON.parse(data);
        // Validate tile types
        const validTypes = new Set((0, $8pKpp.TILE_TYPES));
        for (const t of state.tiles)if (t.sides.some((s)=>!validTypes.has(s))) {
            console.warn("Save contains unknown tile types, starting fresh");
            localStorage.removeItem("hexaworlds_save");
            return false;
        }
        if (state.hand) for (const t of state.hand){
            if (t.isOverlay) continue;
            if (t.sides.some((s)=>!validTypes.has(s))) {
                console.warn("Save contains unknown tile types in hand, starting fresh");
                localStorage.removeItem("hexaworlds_save");
                return false;
            }
        }
        $761f97bf09d51d3e$var$tiles = {};
        for (const t of state.tiles)$761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(t.coord.q, t.coord.r)] = t;
        $761f97bf09d51d3e$var$resources = state.resources || {};
        // Ensure all new resource keys exist, drop old ones
        const newRes = {};
        for (const res of (0, $8pKpp.RESOURCE_TYPES))newRes[res] = $761f97bf09d51d3e$var$resources[res] || 0;
        $761f97bf09d51d3e$var$resources = newRes;
        $761f97bf09d51d3e$var$score = state.score;
        $761f97bf09d51d3e$var$camera = state.camera || {
            x: 0,
            y: 0,
            zoom: 1
        };
        $761f97bf09d51d3e$var$hand = state.hand || [];
        $761f97bf09d51d3e$var$selectedHandIndex = state.selectedHandIndex || 0;
        $761f97bf09d51d3e$var$tileIdCounter = state.tileIdCounter || Object.keys($761f97bf09d51d3e$var$tiles).length;
        if (state.overlayUnlocks) $761f97bf09d51d3e$var$overlayUnlocks = state.overlayUnlocks;
        // Load new ability state with backward compat
        $761f97bf09d51d3e$var$rerollChainCount = state.rerollChainCount || 0;
        $761f97bf09d51d3e$var$storageCapacity = state.storageCapacity || 0;
        $761f97bf09d51d3e$var$storage = state.storage || [
            null,
            null,
            null
        ];
        // Ensure storage array is always length 3
        while($761f97bf09d51d3e$var$storage.length < 3)$761f97bf09d51d3e$var$storage.push(null);
        // Derive storage unlock from stars
        if ($761f97bf09d51d3e$var$isStorageUnlocked() && $761f97bf09d51d3e$var$storageCapacity < 1) $761f97bf09d51d3e$var$storageCapacity = 1;
        return true;
    } catch (e) {
        return false;
    }
}
// ===== ATLAS LOADING =====
async function $761f97bf09d51d3e$var$loadAtlas() {
    try {
        const atlas = await (0, $23xJk.SpriteAtlas).load((0, (/*@__PURE__*/$parcel$interopDefault($9KLml))), (0, (/*@__PURE__*/$parcel$interopDefault($foHJT))));
        $761f97bf09d51d3e$var$spriteAtlas = atlas;
        $761f97bf09d51d3e$var$spriteIndex = (0, $eehpt.buildSpriteIndex)(atlas);
        $761f97bf09d51d3e$var$renderer.spriteAtlas = atlas;
        $761f97bf09d51d3e$var$renderer.spriteIndex = $761f97bf09d51d3e$var$spriteIndex;
    } catch (e) {
        console.warn("Atlas load failed, using procedural fallback:", e);
    }
}
// ===== INIT =====
function $761f97bf09d51d3e$var$initGame() {
    if (!$761f97bf09d51d3e$var$loadGame()) {
        const firstTile = $761f97bf09d51d3e$var$generateContiguousTileFallback();
        firstTile.coord = {
            q: 0,
            r: 0
        };
        firstTile.placed = true;
        firstTile.placedAtMs = performance.now();
        $761f97bf09d51d3e$var$tiles[(0, $3WWYP.hexKey)(0, 0)] = firstTile;
        $761f97bf09d51d3e$var$renderer.assignSpriteKeys(firstTile);
    }
    // Assign sprite keys to any loaded tiles that don't have them
    for (const tile of Object.values($761f97bf09d51d3e$var$tiles))if (!tile.baseSpriteKey) $761f97bf09d51d3e$var$renderer.assignSpriteKeys(tile);
    // Initialize overlay state if not loaded from save
    if ($761f97bf09d51d3e$var$overlayUnlocks.locked.length === 0 && $761f97bf09d51d3e$var$overlayUnlocks.unlocked.length === 0) $761f97bf09d51d3e$var$initOverlayState();
    $761f97bf09d51d3e$var$syncRendererState();
    $761f97bf09d51d3e$var$fillHand();
    $761f97bf09d51d3e$var$updateHUD();
    $761f97bf09d51d3e$var$renderStoragePanel();
    $761f97bf09d51d3e$var$initAbilityUnlockTracking();
    requestAnimationFrame($761f97bf09d51d3e$var$render);
}
// Display build number
document.getElementById("build-number").textContent = `Build #${0, $1785fd5408da3363$export$59b5344f0ddeca73}`;
// ===== ANALYTICS INIT =====
(0, $6f8b53b9d161c817$export$2b3af6baec22bd98).init({
    debug: new URLSearchParams(location.search).has("debugAnalytics")
});
const $761f97bf09d51d3e$var$_playerId = (0, $5218d4228794afd6$export$94f87c28e0ebadf8)();
(0, $5218d4228794afd6$export$65b13681cdfbf8a4)($761f97bf09d51d3e$var$_playerId);
// ===== QUESTS v2 =====
/** Build the world info object for quest generation and progress. */ function $761f97bf09d51d3e$var$buildQuestWorldInfo() {
    const tileValues = Object.values($761f97bf09d51d3e$var$tiles).filter((t)=>t.placed);
    const boardTerrainCounts = new Map();
    let boardOverlayCount = 0;
    for (const t of tileValues){
        const type = $761f97bf09d51d3e$var$getMajorityType(t.sides);
        boardTerrainCounts.set(type, (boardTerrainCounts.get(type) || 0) + 1);
        if (t.overlaySpriteKey) boardOverlayCount++;
    }
    const handTerrainTypes = new Set();
    for (const h of $761f97bf09d51d3e$var$hand)if (!h.isOverlay) handTerrainTypes.add($761f97bf09d51d3e$var$getMajorityType(h.sides));
    const exposedCounts = $761f97bf09d51d3e$var$getExposedTypeCounts();
    const exposedTopTypes = $761f97bf09d51d3e$var$getTopExposed(exposedCounts, 3);
    const unlockedFamilies = new Set($761f97bf09d51d3e$var$overlayUnlocks.unlocked.map((k)=>(0, $eehpt.getOverlayFamily)(k)));
    return {
        totalTiles: tileValues.length,
        tiles: $761f97bf09d51d3e$var$tiles,
        handTerrainTypes: handTerrainTypes,
        exposedTopTypes: exposedTopTypes,
        boardTerrainCounts: boardTerrainCounts,
        boardOverlayCount: boardOverlayCount,
        unlockedFamilies: unlockedFamilies,
        score: $761f97bf09d51d3e$var$score,
        // Functions needed by progress updater
        _fns: {
            tiles: $761f97bf09d51d3e$var$tiles,
            getMajorityType: $761f97bf09d51d3e$var$getMajorityType,
            getOverlayFamily: $eehpt.getOverlayFamily
        }
    };
}
const $761f97bf09d51d3e$var$questManager = new (0, $742317e06faccc71$export$2b3f6b475bacf6b7)();
$761f97bf09d51d3e$var$questManager.getWorldInfo = $761f97bf09d51d3e$var$buildQuestWorldInfo;
$761f97bf09d51d3e$var$questManager.onStarsReward = (n)=>{
    $761f97bf09d51d3e$var$score.stars += n;
    $761f97bf09d51d3e$var$overlayUnlocks.starsSinceLastUnlock += n;
    $761f97bf09d51d3e$var$checkOverlayUnlock();
    $761f97bf09d51d3e$var$checkAbilityUnlocks();
    // Show floating reward text near centre of screen
    const px = {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2 - 60
    };
    $761f97bf09d51d3e$var$animations.push({
        x: px.x,
        y: px.y,
        text: `\u{2B50} +${n}  Quest!`,
        startTime: performance.now(),
        duration: 1400,
        isScore: true
    });
    $761f97bf09d51d3e$var$updateHUD();
};
$761f97bf09d51d3e$var$questManager.onRegularOverlayReward = ()=>{
    const pick = $761f97bf09d51d3e$var$unlockOverlayFromPool('regular');
    if (pick) {
        $761f97bf09d51d3e$var$pendingUnlockNotifs.push(pick);
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("overlay_unlock", {
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            source: "quest_creative",
            unlocked_total: $761f97bf09d51d3e$var$overlayUnlocks.unlocked.length,
            locked_remaining: $761f97bf09d51d3e$var$overlayUnlocks.locked.length
        });
        $761f97bf09d51d3e$var$audio.playSfx("overlay_unlock");
        $761f97bf09d51d3e$var$updateHUD();
        $761f97bf09d51d3e$var$showNextUnlockNotif();
    }
    return pick;
};
$761f97bf09d51d3e$var$questManager.onSpecialOverlayReward = ()=>{
    const pick = $761f97bf09d51d3e$var$unlockOverlayFromPool('special');
    if (pick) {
        $761f97bf09d51d3e$var$pendingUnlockNotifs.push(pick);
        (0, $6f8b53b9d161c817$export$2b3af6baec22bd98).track("overlay_unlock", {
            build: String((0, $1785fd5408da3363$export$59b5344f0ddeca73)),
            source: "quest_special",
            unlocked_total: $761f97bf09d51d3e$var$overlayUnlocks.unlocked.length,
            locked_remaining: $761f97bf09d51d3e$var$overlayUnlocks.locked.length
        });
        $761f97bf09d51d3e$var$audio.playSfx("overlay_unlock");
        $761f97bf09d51d3e$var$updateHUD();
        $761f97bf09d51d3e$var$showNextUnlockNotif();
    }
    return pick;
};
$761f97bf09d51d3e$var$questManager.onQuestComplete = (tier, quest)=>{
    $761f97bf09d51d3e$var$questUI.showCompletion(tier, quest);
    $761f97bf09d51d3e$var$spawnConfetti();
};
$761f97bf09d51d3e$var$questManager.onProgress = (tier, quest)=>{
    $761f97bf09d51d3e$var$questUI.updateProgress(tier, quest);
};
$761f97bf09d51d3e$var$questManager.onQuestNew = (tier, quest)=>{
    $761f97bf09d51d3e$var$questUI.setQuest(tier, quest);
};
const $761f97bf09d51d3e$var$_questPanelEl = document.getElementById("quest-panel");
const $761f97bf09d51d3e$var$questUI = new (0, $d11d076be9c0eda4$export$d6e2c749de993985)($761f97bf09d51d3e$var$_questPanelEl);
let $761f97bf09d51d3e$var$resolveWorldReady;
const $761f97bf09d51d3e$var$worldReadyPromise = new Promise((resolve)=>{
    $761f97bf09d51d3e$var$resolveWorldReady = resolve;
});
(0, $26425851e20efade$export$19072be089c6139a)($761f97bf09d51d3e$var$worldReadyPromise);
// Load atlas then init game
$761f97bf09d51d3e$var$loadAtlas().then(()=>{
    $761f97bf09d51d3e$var$initGame();
    (0, $b5Oyo.buildAllRenderMeta)($761f97bf09d51d3e$var$tiles, $761f97bf09d51d3e$var$spriteIndex?.tileTransitionKeys ?? null);
    $761f97bf09d51d3e$var$questManager.init();
    $761f97bf09d51d3e$var$questUI.refresh($761f97bf09d51d3e$var$questManager.state.active);
    $761f97bf09d51d3e$var$resolveWorldReady();
});


//# sourceMappingURL=path0.9bc1588e.js.map
